const bodyScrollLockOptions = {
  reserveScrollBarGap: true,
  allowTouchMove: (el) => {
    return !!el.closest?.('[data-scrollable]');
  },
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);
};



var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: true, passive: isScrollEvent });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: false, passive: isScrollEvent });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent = ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !== -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, { capture: useCapture, passive: isScrollEvent });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class IOSScrollLock {
  static _preventScroll = null;
  static _preventGesture = null;
  static _lockCount = 0;

  static lock() {
    if (this._lockCount === 0) {
      this._preventScroll = (e) => {
        if (e.target.closest('.Drawer--wrapper') || e.target.closest('[data-scrollable]')) return;
        e.preventDefault();
      };
      document.addEventListener('touchmove', this._preventScroll, { passive: false, capture: true });

      this._preventGesture = (e) => e.preventDefault();
      document.addEventListener('gesturestart', this._preventGesture);
    }
    this._lockCount++;
  }

  static unlock() {
    if (this._lockCount < 0) return;
    this._lockCount--;

    if (this._lockCount === 0) {
      if (this._preventScroll) {
        document.removeEventListener('touchmove', this._preventScroll, { passive: false, capture: true });
        this._preventScroll = null;
      }

      if (this._preventGesture) {
        document.removeEventListener('gesturestart', this._preventGesture);
        this._preventGesture = null;
      }
    }
  }
}

class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this._ticking = false;
    this.boundRunCallbacks = () => {
      if (this._ticking) return;
      this._ticking = true;
      requestAnimationFrame(() => {
        this.runCallbacks();
        this._ticking = false;
      });
    };
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, '_'); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, { passive: true });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key)
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener("scroll", this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach(callback => callback());
  }
}

const scrollListener = new GlobalScrollListener();

class Responsive {
  constructor(enableGeneralBreakpointChange, trackWindowHeight) {
    this.settings();

    this.trackWindowHeight = trackWindowHeight;
    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.setWindowHeight();
    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)",
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      pocket: "(max-width: 1024px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      desktop: "(min-width: 1025px)",
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
          new CustomEvent("breakpoint:changed", {
            detail: {
              previousBreakpoint: this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          })
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
          new CustomEvent(`breakpoint:${key}`, {
            detail: {
              matches: isCurrentlyInBreakpoint,
            },
          })
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    this.setWindowHeight();

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  setWindowHeight() {
    if (this.trackWindowHeight) {
      document.documentElement.style.setProperty(
        "--window-height",
        `${window.innerHeight}px`
      );
    }
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(false, false);

const sharedBodyDelegate = new Delegate(document.body);

//use this for all popups
class Popup {
  constructor() {
    // Reuse the shared body delegate to avoid duplicate event listeners.
    this.delegateBody = sharedBodyDelegate;
    // Maintain a stack of active popups.
    this.activePopups = [];
    this.onPopupOpen = null;
    this.onPopupClose = null;
    this.bindEvents();
  }

  bindEvents() {
    // Bind a listener for clicks on toggle buttons.
    this.delegateBody.on(
      'click',
      '[data-action="toggle-popup"]',
      this.handleOpenOptions.bind(this)
    );

    // Listen for the custom "drawer:close-other" event to close all open popups.
    this.delegateBody.on(
      'drawer:close-other',
      this.handleDrawerCloseOther.bind(this)
    );

    this.delegateBody.on(
      'edit-img:open-popup',
      this.handleOpenOptions.bind(this)
    );

    // Close all popups when desktop menu opens
    this.delegateBody.on('menu:open', this.closeAllPopups.bind(this));

    // Bind keydown directly on the delegate element so it fires only once.
    this.delegateBody.on('keydown', this.handleEscape.bind(this));
  }

  // This method is called when a toggle button is clicked.
  handleOpenOptions(event) {
    event.stopPropagation();
    event.preventDefault();

    dynamicVars.syncHeight();
    const toggleButton = event.target.closest('[data-action="toggle-popup"]');
    if (toggleButton) {
      this.togglePopup(toggleButton);
      return;
    }

    // If a click occurs on the overlay of the top-most popup, close that popup.
    if (this.activePopups.length) {
      const topPopup = this.activePopups[this.activePopups.length - 1];
      const overlay = this.getOverlayElement(topPopup);
      if (overlay && overlay.contains(event.target)) {
        this.closePopup(topPopup);
      }
    }
  }

  // Handle keydown events.
  // Only close the top-most popup when Esc is pressed.
  handleEscape(event) {
    if (event.key === 'Escape' && this.activePopups.length) {
      event.preventDefault();
      event.stopPropagation();
      const topPopup = this.activePopups[this.activePopups.length - 1];
      if (topPopup.querySelector('[data-action="toggle-popup"]')) {
        topPopup.querySelector('[data-action="toggle-popup"]').click();
      } else {
        this.closePopup(topPopup);
      }

    }
  }

  // Toggle the popup associated with the given button.
  togglePopup(button) {
    const popupId = button.getAttribute('aria-controls');
    if (!popupId) return;

    const popupElement = document.getElementById(popupId);
    if (!popupElement) return;

    // Guard against rapid clicks while a toggle is still being processed.
    if (popupElement._toggling) return;
    popupElement._toggling = true;
    requestAnimationFrame(() => { popupElement._toggling = false; });

    // Determine if this popup should be treated as a child popup.
    const isChild = button.getAttribute('data-child-popup') === 'true';

    // If the popup is already open, close it; otherwise, open it.
    if (popupElement.getAttribute('aria-hidden') === 'false') {
      this.closePopup(popupElement);
    } else {
      this.openPopup(popupElement, isChild);
    }
  }

  // Open the popup element.
  // If it's not a child popup, close all currently open popups.
  openPopup(popupElement, isChild = false) {
    // Mark the popup element as a child (or not) for later checks.
    popupElement._isChild = isChild;

    // Cancel any pending close transition/timeout from a previous close so it
    // doesn't fire after we re-open and hide the popup again.
    if (popupElement._closeTimeout) {
      clearTimeout(popupElement._closeTimeout);
      popupElement._closeTimeout = null;
    }
    if (popupElement._closeTransitionHandler) {
      popupElement.removeEventListener('transitionend', popupElement._closeTransitionHandler);
      popupElement._closeTransitionHandler = null;
    }

    // Ensure the popup is visible before starting any animations.
    // Explicit 'flex' for localization modals so Safari and re-open work (clearing display:none).
    const isLocalizationModal = popupElement.id && (popupElement.id.includes('modal-country') || popupElement.id.includes('modal-language'));
    const isDesktopLocalization = isLocalizationModal && popupElement.id.includes('-desktop');
    if (isLocalizationModal) {
      popupElement.style.display = 'flex';
    } else {
      popupElement.style.removeProperty('display');
    }

    // If this is a parent popup, close any other open popups BEFORE setting transparency.
    if (!isChild) {
      while (this.activePopups.length) {
        this._closePopup(this.activePopups.pop());
      }
    }

    // Remove header transparency while desktop localization popup is open
    if (isDesktopLocalization) {
      const headerEl = document.querySelector('header-component');
      if (headerEl && headerEl.classList.contains('Header--Transparent')) {
        popupElement._wasHeaderTransparent = true;
        headerEl.classList.remove('Header--Transparent');
      } else {
        popupElement._wasHeaderTransparent = false;
      }
      // Block toggleColor from restoring transparency while popup is open
      if (headerEl) headerEl.drawerBlocksTransparency = true;
    }

    popupElement.removeAttribute('inert');
    // Double rAF so Safari applies display/layout before clip-path transition
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        popupElement.setAttribute('aria-hidden', 'false');
        popupElement.setAttribute('aria-expanded', 'true');

        // Update trigger button's aria-expanded
        const triggerButton = document.querySelector(`[aria-controls="${popupElement.id}"]`);
        if (triggerButton) {
          triggerButton.setAttribute('aria-expanded', 'true');
        }

        if (typeof this.onPopupOpen === 'function') {
          this.onPopupOpen(popupElement);
        }

        // Dispatch events to close other open UI elements (search, desktop menu)
        document.body.dispatchEvent(new CustomEvent("popup:opened", { bubbles: true }));
        document.body.dispatchEvent(new CustomEvent("menu:close", { bubbles: true }));
      });
    });

    // Store the scrollable element reference on the popup for later use.
    const focus = popupElement.querySelector('[data-scrollable]');

    if (focus) {
      popupElement._scrollableElement = focus;
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      IOSScrollLock.lock();
    }

    trapFocus(popupElement);
    // If the popup specifies an overlay, find it, display it, and attach a click listener.
    const overlay = this.getOverlayElement(popupElement);
    if (overlay) {
      overlay.classList.add('is-visible');
      const handleOverlayClick = (e) => {
        e.preventDefault();
        this.closePopup(popupElement);
      };
      // Store the handler so it can be removed later.
      popupElement._overlayClickHandler = handleOverlayClick;
      overlay.addEventListener('click', handleOverlayClick);
    }

    // Push this popup onto the active stack (avoid duplicates from rapid clicks).
    if (this.activePopups.indexOf(popupElement) === -1) {
      this.activePopups.push(popupElement);
    }
  }

  // Close the popup element.
  closePopup(popupElement) {
    const index = this.activePopups.indexOf(popupElement);
    if (index !== -1) {
      // Save the scrollable element from the popup being closed.
      const closedScrollEl = popupElement._scrollableElement;
      this._closePopup(popupElement);
      this.activePopups.splice(index, 1);

      // If there is a new top popup, check for its scrollable element.
      if (this.activePopups.length > 0) {
        const topPopup = this.activePopups[this.activePopups.length - 1];
        if (topPopup._scrollableElement) {
          // Reapply the scroll lock to the new top popup's scrollable element.
          bodyScrollLock.disableBodyScroll(topPopup._scrollableElement, bodyScrollLockOptions);
          IOSScrollLock.lock();
        }
      } else {
        // No active popups remain; remove the scroll lock from the closed element.
        if (closedScrollEl) {
          bodyScrollLock.enableBodyScroll(closedScrollEl);
          IOSScrollLock.unlock();
        }
      }
    }
  }


  // Internal method to remove open styles and attributes from the popup,
  // then wait for the transition to finish before setting display: none.
  _closePopup(popupElement) {
    popupElement.setAttribute('aria-expanded', 'false');
    popupElement.setAttribute('aria-hidden', 'true');

    // Update trigger button's aria-expanded
    const triggerButton = document.querySelector(`[aria-controls="${popupElement.id}"]`);
    if (triggerButton) {
      triggerButton.setAttribute('aria-expanded', 'false');
    }

    const overlay = this.getOverlayElement(popupElement);
    if (overlay) {
      overlay.classList.remove('is-visible');
      if (popupElement._overlayClickHandler) {
        overlay.removeEventListener('click', popupElement._overlayClickHandler);
        delete popupElement._overlayClickHandler;
      }
    }

    removeTrapFocus(popupElement);

    // Restore header transparency if we removed it when opening
    const isDesktopLoc = popupElement.id && popupElement.id.includes('-desktop') &&
      (popupElement.id.includes('modal-country') || popupElement.id.includes('modal-language'));
    if (isDesktopLoc) {
      const headerEl = document.querySelector('header-component');
      if (headerEl) {
        headerEl.drawerBlocksTransparency = false;
        if (popupElement._wasHeaderTransparent) {
          headerEl.classList.add('Header--Transparent');
        }
      }
      popupElement._wasHeaderTransparent = false;
    }

    const transitionEndHandler = () => {
      popupElement.style.display = 'none';
      popupElement.setAttribute('inert', '');
      popupElement.removeEventListener('transitionend', transitionEndHandler);
      popupElement._closeTransitionHandler = null;
      if (popupElement._closeTimeout) {
        clearTimeout(popupElement._closeTimeout);
        popupElement._closeTimeout = null;
      }
      // Trigger the close callback after the transition ends.
      if (typeof this.onPopupClose === 'function') {
        this.onPopupClose(popupElement);
      }
    };

    // Store references so openPopup can cancel them if the popup is
    // re-opened before the close transition finishes.
    popupElement._closeTransitionHandler = transitionEndHandler;
    popupElement._closeTimeout = setTimeout(() => {
      popupElement.style.display = 'none';
      popupElement.setAttribute('inert', '');
      popupElement.removeEventListener('transitionend', transitionEndHandler);
      popupElement._closeTransitionHandler = null;
      popupElement._closeTimeout = null;
    }, 500);

    popupElement.addEventListener('transitionend', transitionEndHandler);
  }

  // Method to handle the custom event "drawer:close-other".
  // It closes all currently open popups.
  handleDrawerCloseOther(event) {
    event.preventDefault();
    this.closeAllPopups();
  }

  // Method to close all open popups.
  closeAllPopups() {
    while (this.activePopups.length) {
      const popup = this.activePopups.pop();
      this._closePopup(popup);
    }
  }

  // Retrieve the overlay element based on the popup's data-overlay attribute.
  getOverlayElement(popupElement) {
    const overlayClass = popupElement.getAttribute('data-overlay');
    if (overlayClass) {
      return document.querySelector(`.${overlayClass}`);
    }
    return null;
  }
}

window.globalPopup = new Popup();

class dynamicVariables {
  constructor() {
    requestAnimationFrame(() => {
      document.documentElement.style.setProperty(
        "--viewport_width",
        `${document.documentElement.clientWidth}px`
      );
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    });

    responsive.addResizeListener(this, this.sync.bind(this));
  }

  sync() {
    this.syncWidth();
    this.syncHeight();
  }

  syncWidth() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  }
}

const dynamicVars = new dynamicVariables();

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;

    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);

    loadScript(window.theme.pswpScript);

    this.photoSwipeInstance = null;
    this.pswpThumbEls = null;
    this.pswpBulletEls = null;

    this.syncHeight();
    this.bindEvents();
  }

  isMobile() {
    return window.matchMedia("(max-width: 1024px)").matches;
  }

  syncHeight() {
    document.documentElement.style.setProperty("--window-inner-height", `${window.innerHeight}px`);
  }

  syncPswpColorScheme() {
    const pswp = document.querySelector(".pswp");
    const productRoot = document.querySelector("product-component.main-product");

    if (!pswp || !productRoot) return;

    [...pswp.classList].forEach((c) => {
      if (c.startsWith("colorGroup--")) pswp.classList.remove(c);
    });

    const schemeClass = [...productRoot.classList].find((c) => c.startsWith("colorGroup--"));
    if (schemeClass) pswp.classList.add(schemeClass);
  }

  bindEvents() {
    responsive.addResizeListener(this, this.syncHeight.bind(this));

    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );

    this.delegateElement.on("click", ".ProductSliderCell--Zoom", (e) => {
      const slide = e.target.closest(".ProductSliderCell--Zoom");
      if (!slide) return;
      this.initPhotoSwipeFromImageClick(e, slide);
    });

    this.delegateRoot.on("pswpTap", ".pswp__button--close", this.photoswiperClose.bind(this));
  }

  photoswiperClose() {
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe() {
    this.syncPswpColorScheme();

    const images = [];
    let index = 0;

    if (this.slideshow?.swiperElement) {
      this.slideshow.swiperElement.slides.forEach((slide) => {
        if (slide.classList.contains("ProductSliderCell--Zoom")) {
          const img = slide.querySelector("img");
          if (img) images.push(img);
        }
      });

      const current = this.slideshow.swiperElement.realIndex || 0;
      const currentSlide = this.slideshow.swiperElement.slides[current];
      const posAttr = currentSlide
        ?.querySelector(".ProductSlider--Element")
        ?.getAttribute("data-image-position");

      index = parseInt(posAttr, 10) || 0;
    } else {
      const img =
        this.element.querySelector(".ProductSlider--Image") ||
        document.querySelector(".ProductSlider--Image");
      if (img) images.push(img);
    }

    const items = this.createPhotoSwipeItemsFromImages(images);
    this.createPhotoSwipeInstance(items, index);
  }

  initPhotoSwipeFromImageClick(event, targetSlide) {
    this.syncPswpColorScheme();

    const images = [];
    const siblings = Array.from(targetSlide.parentElement?.children || []);

    siblings.forEach((slide) => {
      if (slide.classList.contains("ProductSliderCell--Zoom")) {
        const img = slide.querySelector("img");
        if (img) images.push(img);
      }
    });

    const posAttr = targetSlide
      .querySelector(".ProductSlider--Element")
      ?.getAttribute("data-image-position");

    const index = parseInt(posAttr, 10) || 0;

    const items = this.createPhotoSwipeItemsFromImages(images);
    this.createPhotoSwipeInstance(items, index);
  }

  createPhotoSwipeItemsFromImages(images) {
    const isMobile = this.isMobile();

    const desktopWidth = 640;
    const desktopHeight = 753;

    return images.map((image) => {
      const fullWidth =
        parseInt(image.getAttribute("data-max-width"), 10) || image.naturalWidth || 2000;
      const fullHeight =
        parseInt(image.getAttribute("data-max-height"), 10) || image.naturalHeight || 2000;

      const src = image.dataset.originalSrc || image.currentSrc || image.src;
      const msrc = image.currentSrc || image.src;

      if (isMobile) {
        const vw = window.innerWidth || 360;
        const vh = window.innerHeight || 640;
        const fitZoom = Math.min(vw / fullWidth, vh / fullHeight);

        return {
          msrc,
          src,
          w: fullWidth,
          h: fullHeight,
          initialZoomLevel: fitZoom,
          initZoomLevel: fitZoom
        };
      }

      const initialZoomLevel = desktopWidth / fullWidth;

      return {
        msrc,
        src,
        w: desktopWidth,
        h: desktopHeight,
        initialZoomLevel,
        initZoomLevel: initialZoomLevel
      };
    });
  }

  buildPswpThumbsUI(items) {
    const pswp = document.querySelector(".pswp");
    const list = pswp?.querySelector(".pswp__thumbs-list");
    if (!pswp || !list) return;

    list.innerHTML = "";

    items.forEach((item, i) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "pswp__thumb";
      btn.setAttribute("aria-label", `Open image ${i + 1}`);

      const img = document.createElement("img");
      img.src = item.msrc || item.src;
      img.loading = "lazy";
      img.decoding = "async";

      btn.appendChild(img);

      const handler = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        ev.stopImmediatePropagation?.();

        if (!this.photoSwipeInstance) return;
        this.photoSwipeInstance.goTo(i);
        this.syncPswpThumbActive();
        this.syncPswpBulletsActive();
      };

      btn.addEventListener("click", handler, true);
      btn.addEventListener("pointerdown", handler, true);

      list.appendChild(btn);
    });

    this.pswpThumbEls = Array.from(list.querySelectorAll(".pswp__thumb"));
  }

  syncPswpThumbActive() {
    if (!this.photoSwipeInstance || !this.pswpThumbEls?.length) return;

    const idx = this.photoSwipeInstance.getCurrentIndex();
    this.pswpThumbEls.forEach((el, i) => el.classList.toggle("is-active", i === idx));

    const active = this.pswpThumbEls[idx];
    if (active) active.scrollIntoView({ block: "nearest" });
  }

  ensureBulletsContainer() {
    const pswp = document.querySelector(".pswp");
    const ui = pswp?.querySelector(".pswp__ui");
    if (!pswp || !ui) return null;

    let wrap = pswp.querySelector(".pswp__bullets");
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "pswp__bullets";
      wrap.setAttribute("aria-hidden", "true");
      ui.appendChild(wrap);
    }
    return wrap;
  }

  buildPswpBulletsUI(items) {
    if (!this.isMobile()) return;
    if (!items || items.length <= 1) return;

    const wrap = this.ensureBulletsContainer();
    if (!wrap) return;

    wrap.innerHTML = "";

    items.forEach((_, i) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "pswp__bullet";
      btn.setAttribute("aria-label", `Go to image ${i + 1}`);

      const handler = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        ev.stopImmediatePropagation?.();

        if (!this.photoSwipeInstance) return;
        this.photoSwipeInstance.goTo(i);
        this.syncPswpBulletsActive();
        this.syncPswpThumbActive();
      };

      btn.addEventListener("click", handler, true);
      btn.addEventListener("pointerdown", handler, true);

      wrap.appendChild(btn);
    });

    this.pswpBulletEls = Array.from(wrap.querySelectorAll(".pswp__bullet"));
  }

  syncPswpBulletsActive() {
    if (!this.photoSwipeInstance || !this.pswpBulletEls?.length) return;

    const idx = this.photoSwipeInstance.getCurrentIndex();
    this.pswpBulletEls.forEach((el, i) => el.classList.toggle("is-active", i === idx));
  }

  teardownPswpBulletsUI() {
    const pswp = document.querySelector(".pswp");
    const wrap = pswp?.querySelector(".pswp__bullets");
    if (wrap) wrap.innerHTML = "";
    this.pswpBulletEls = null;
  }

  enableThumbsScrolling() {
    const pswp = document.querySelector(".pswp");
    const thumbs = pswp?.querySelector(".pswp__thumbs");
    if (!thumbs) return;

    const stop = (e) => {
      e.stopPropagation();
      e.stopImmediatePropagation?.();
    };

    thumbs.style.touchAction = "pan-y";
    thumbs.style.webkitOverflowScrolling = "touch";

    thumbs.addEventListener("wheel", stop, { capture: true, passive: true });

    thumbs.addEventListener(
      "touchmove",
      (e) => {
        stop(e);
        e.preventDefault();
      },
      { capture: true, passive: false }
    );

    thumbs.addEventListener(
      "pointermove",
      (e) => {
        stop(e);
      },
      { capture: true, passive: true }
    );
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    const photoswipeContainer = document.querySelector(".pswp");
    if (!photoswipeContainer) return;

    const isMobile = this.isMobile();

    const thumbsForBounds = Array.from(
      this.element.querySelectorAll(".mainSwiper .ProductSliderCell--Zoom img")
    );

    this.photoSwipeInstance = new PhotoSwipe(photoswipeContainer, false, items, {
      index: selectedImageIndex,
      showHideOpacity: true,
      showAnimationDuration: 450,
      loop: false,
      history: false,

      closeOnVerticalDrag: false,

      allowPanToNext: isMobile ? true : false,

      pinchToClose: false,
      errorMsg: '<p class="pswp__error-msg"></p>',

      scaleMode: isMobile ? "fit" : "orig",

      counterEl: false,
      arrowEl: true,
      preloaderEl: true,

      getDoubleTapZoom: (isMouseClick, item) => {
        if (isMouseClick) return 1.35;
        return item.initialZoomLevel < 0.7 ? 1 : 1.33;
      },

      getThumbBoundsFn: (i) => {
        const thumb = thumbsForBounds[i];
        if (!thumb) return { x: 0, y: 0, w: 0 };
        const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
        const rect = thumb.getBoundingClientRect();
        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
      }
    });

    window.pswp = this.photoSwipeInstance;

    this.photoSwipeInstance.listen("beforeChange", this.onslideChanged.bind(this));
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen("initialZoomIn", this.onInitialZoomIn.bind(this));
    this.photoSwipeInstance.listen("initialZoomOut", this.onInitialZoomOut.bind(this));
    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));

    this.photoSwipeInstance.listen("destroy", () => {
      this.delegateRoot.off("pswpTap");
      this.pswpThumbEls = null;
      this.teardownPswpBulletsUI();
      this.photoSwipeInstance = null;
    });

    this.delegateRoot.on("pswpTap", ".pswp__scroll-wrap", this.onSingleTap.bind(this));

    this.delegateRoot.on("pswpTap", ".pswp__button--close", () => this.photoSwipeInstance?.close());
    this.delegateRoot.on("pswpTap", ".pswp__button--prev", () => this.photoSwipeInstance?.prev());
    this.delegateRoot.on("pswpTap", ".pswp__button--next", () => this.photoSwipeInstance?.next());

    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }

    this.buildPswpThumbsUI(items);
    this.buildPswpBulletsUI(items);

    this.photoSwipeInstance.listen("afterChange", () => {
      this.syncPswpThumbActive();
      this.syncPswpBulletsActive();
    });

    this.photoSwipeInstance.listen("initialZoomInEnd", () => {
      if (!this.isMobile()) {
        const item = this.photoSwipeInstance.currItem;
        if (item) {
          const center = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
          this.photoSwipeInstance.zoomTo(item.initialZoomLevel, center, 0);
        }
      }

      this.syncPswpThumbActive();
      this.syncPswpBulletsActive();
    });

    this.photoSwipeInstance.init();
    this.syncPswpThumbActive();
    this.syncPswpBulletsActive();

    this.enableThumbsScrolling();
  }

  onslideChanged() {
    const prevBtn = this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--prev");
    const nextBtn = this.photoSwipeInstance.scrollWrap.querySelector(".pswp__button--next");

    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      prevBtn?.setAttribute("disabled", "disabled");
      if (prevBtn) prevBtn.style.display = "none";
    } else {
      prevBtn?.removeAttribute("disabled");
      if (prevBtn) prevBtn.style.display = "flex";
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      nextBtn?.setAttribute("disabled", "disabled");
      if (nextBtn) nextBtn.style.display = "none";
    } else {
      nextBtn?.removeAttribute("disabled");
      if (nextBtn) nextBtn.style.display = "flex";
    }
  }

  onSingleTap(event) {
    const inThumbs = event?.target?.closest?.(".pswp__thumbs");
    const inBullets = event?.target?.closest?.(".pswp__bullets");
    if (inThumbs || inBullets) return;

    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
      return;
    }

    if (event.target.classList.contains("pswp__button")) return;

    event.target
      .closest(".pswp")
      .querySelector(".pswp__ui")
      .classList.toggle("pswp__ui--hidden");
  }

  onDoubleTap(point) {
    const initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(initialZoomLevel < 0.7 ? 1 : 1.33, point, 333);
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui")?.classList.remove("pswp__ui--hidden");
  }

  onInitialZoomOut() {
    document.querySelector(".pswp__ui")?.classList.add("pswp__ui--hidden");
  }
}


class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;
    this.mainDropdown = this.element.querySelector(
      ".RevolutionSelectbox--Content"
    );

    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(".RevolutionSelectbox--Button");

    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
      "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(
          ".localizationOverlay"
        );
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }
    this.bindEvents();
    this.initSelectbox();
  }

  bindEvents() {
    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on(
      "click",
      "[data-action=toggle-selectbox]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );

    this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
  }

  selectboxChange() {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    var innerContent = event.target.innerHTML;
    var selEl = this.element.querySelector("#" + selectboxID);
    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else {
      selEl
        .querySelector('[value="' + value + '"]')
        .setAttribute("checked", "true");
    }
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      innerContent;

    if (this.element.classList.contains('dropdownSelector')) {
      this.element.querySelector('.RevolutionSelectbox--Item[disabled="true"]').removeAttribute('disabled');
      event.target.setAttribute('disabled', 'true');
    }
    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.getAttribute("data-value");
    var dataName = event.target.getAttribute("data-name");
    this.selectbox.value = value;
    this.closeDropdown(this.element);
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    const selectedItem = this.mainDropdown.querySelector('[selected="selected"]'),
      titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    if (selectedItem) {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }



    trapFocus(this.element);
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();


    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(new CustomEvent('close:search', { bubbles: true }));
    this.element.dispatchEvent(new CustomEvent('menu:close', { bubbles: true }));

    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(target.parentElement.parentElement.children)
      .filter((item) => item.classList.contains('RevolutionSelectbox'));

    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item.querySelector('.RevolutionSelectbox--Button').setAttribute('aria-expanded', false);
      item.querySelector('.RevolutionSelectbox--Content').setAttribute('aria-hidden', true);
      item.querySelector('.RevolutionSelectbox--Content').style.display = 'none';
    });

    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      this.pageOverlayElement.classList.add('is-visible');
      this.pageOverlayElement.addEventListener('click', this.onClickOutsideListener);
      const focus = this.element.querySelector('[data-scrollable]');
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      document.body.classList.add('scrollLock');
      trapFocus(this.mainDropdown);
      if (document.querySelector('#Drawer').getAttribute('aria-expanded') === 'true') {
        document.querySelector('.Drawer--Wrapper').style.overflow = 'visible';
      }
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector('.RevolutionSelectbox--Content');
    target.setAttribute('aria-expanded', 'true');
    contentElement.style.display = 'block';
    contentElement.style.height = `${contentElement.offsetHeight}px`;

    if (this.popover) {
      setTimeout(() => {
        contentElement.setAttribute('aria-hidden', 'false');
      }, 20);
    } else {
      contentElement.setAttribute('aria-hidden', 'false');
    }


    this.isOpen = true;
    window.addEventListener('click', this.onClickOutsideListener);
  }

  closeDropdown(target) {
    var closestDropdown = target.closest(".RevolutionSelectbox");
    if (closestDropdown === null) {
      var closestDropdown = target.querySelector(
        "[aria-expanded='true']"
      ).parentElement;
    }
    closestDropdown
      .querySelector(".RevolutionSelectbox--Button")
      .setAttribute("aria-expanded", false);
    closestDropdown
      .querySelector(".RevolutionSelectbox--Content")
      .setAttribute("aria-hidden", true);
    setTimeout(() => {
      closestDropdown.querySelector(
        ".RevolutionSelectbox--Content"
      ).style.display = "none";
    }, 300);

    if (this.popover == true) {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );

      const menuDrawer = document.querySelector('#Drawer');
      if (menuDrawer.getAttribute('aria-expanded') == "true") {
        document.querySelector('.Drawer--Wrapper').style.overflow = "auto";
      } else {
        const scrollable = this.element.querySelector('[data-scrollable]');
        if (scrollable) bodyScrollLock.enableBodyScroll(scrollable);
        document.body.classList.remove("scrollLock");
      }


    }
    this.isOpen = false;
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);
  }
}
class FormValidator {
  constructor(formElement, options = {}) {
    this.form = formElement;
    this.options = {
      errorClass: 'field--error',
      fieldSelector: '.field',
      buttonSelector: null,
      validateOnBlur: true,
      validateOnInput: false,
      errorOutputSelector: null,
      showErrorsOnSubmitOnly: false,
      ...options
    };

    this.customValidators = new Map();
    this.hasSubmittedOnce = false;
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.setupButtonListener();

    if (this.options.buttonSelector) {
      if (this.options.showErrorsOnSubmitOnly) {
        this.enableButton();
      } else {
        this.updateButtonState();
      }
    }
  }

  enableButton() {
    if (!this.options.buttonSelector) return;

    const button = document.querySelector(this.options.buttonSelector);
    if (!button) return;

    button.removeAttribute('disabled');
    button.classList.remove('disabled');
    button.setAttribute('aria-disabled', 'false');
  }

  setupButtonListener() {
    if (!this.options.buttonSelector) return;

    const button = document.querySelector(this.options.buttonSelector);
    if (!button) return;

    button.addEventListener('click', (e) => {
      this.markSubmitted();
      const isValid = this.showAllErrors();

      if (button.type === 'submit' && !isValid) {
        e.preventDefault();
      }
    });
  }

  outputErrors(errors) {
    if (!this.options.errorOutputSelector) return;

    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      return;
    }

    const container = typeof this.options.errorOutputSelector === 'string'
      ? document.querySelector(this.options.errorOutputSelector)
      : this.options.errorOutputSelector;
    if (!container) return;

    container.innerHTML = '';
    if (errors.length > 0) {
      container.innerHTML = errors.join('<br>');
    }
  }

  setupEventListeners() {
    const inputs = this.form.querySelectorAll('input, textarea, select');

    inputs.forEach(input => {
      input.addEventListener('input', () => this.handleInputForErrorClearing(input));
      if (this.options.validateOnBlur) {
        input.addEventListener('blur', () => this.handleFieldBlur(input));
      }
      input.addEventListener('change', () => this.handleInputChange(input));
    });
  }

  handleInputChange(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      return;
    }

    // Always clear errors for empty fields
    if (!input.value.trim()) {
      this.clearFieldError(input);
    } else if (this.options.validateOnInput) {
      this.validateField(input, false);
    } else {
      this.handleInputForErrorClearing(input);
    }

    this.updateErrorOutput();

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  updateErrorOutput() {
    if (!this.options.errorOutputSelector) return;
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;

    const errors = this.getAllErrors();
    this.outputErrors(errors);
  }

  // Updated to not include errors for empty fields
  getAllErrors() {
    const errors = [];
    this.form.querySelectorAll('input, textarea, select').forEach(field => {
      // Skip empty fields - don't show errors for them
      if (!field.value.trim()) {
        return;
      }

      if (!this.isFieldValid(field)) {
        if (this.customValidators.has(field.id)) {
          const { validatorFn } = this.customValidators.get(field.id);
          const result = validatorFn(field.value, field);
          if (typeof result === 'string') {
            errors.push(result);
          }
        } else if (field.validationMessage) {
          errors.push(field.validationMessage);
        } else {
          // Only show validation errors for non-empty fields
          if (field.type === 'email' && field.value && !this.isValidEmail(field.value)) {
            errors.push(`Please enter a valid email address`);
          }
        }
      }
    });
    return errors;
  }

  handleInputForErrorClearing(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;

    const fieldContainer = input.closest(this.options.fieldSelector);
    if (!fieldContainer) return;

    // Clear error if field is empty or valid
    if (!input.value.trim() || this.isFieldValid(input)) {
      fieldContainer.classList.remove(this.options.errorClass);
      this.updateErrorOutput();
    }

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  handleFieldBlur(input) {
    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) return;

    // Only validate non-empty fields on blur
    if (input.value.trim()) {
      this.validateField(input, false);
    }

    this.updateErrorOutput();

    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  // New helper method to clear field errors
  clearFieldError(field) {
    const fieldContainer = field.closest(this.options.fieldSelector);
    if (fieldContainer && fieldContainer.classList.contains(this.options.errorClass)) {
      fieldContainer.classList.remove(this.options.errorClass);
    }
  }

  addValidator(fieldId, validatorFn, errorMessage) {
    this.customValidators.set(fieldId, { validatorFn, errorMessage });
  }

  validateField(field, silent = true) {
    const fieldContainer = field.closest(this.options.fieldSelector);
    if (!fieldContainer) return true;

    // Don't show errors for empty fields (but they may still be invalid for form submission)
    if (field.type === 'checkbox' ? !field.checked : !field.value.trim()) {
      fieldContainer.classList.remove(this.options.errorClass);
      return this.isFieldValid(field);
    }


    const isValid = this.isFieldValid(field);
    const shouldShowErrors = !silent && (!this.options.showErrorsOnSubmitOnly || this.hasSubmittedOnce);

    if (shouldShowErrors) {
      if (isValid) {
        fieldContainer.classList.remove(this.options.errorClass);
      } else {
        fieldContainer.classList.add(this.options.errorClass);
      }
    } else if (isValid) {
      fieldContainer.classList.remove(this.options.errorClass);
    }

    return isValid;
  }

  markSubmitted() {
    this.hasSubmittedOnce = true;
    if (this.options.buttonSelector) {
      this.updateButtonState();
    }
  }

  isFieldValid(field) {
    // Check required fields
    if (field.hasAttribute('required')) {
      if (field.type === 'checkbox') {
        if (!field.checked) return false;
      } else {
        if (!field.value.trim()) return false;
      }
    }

    // Check email format (only if field has value)
    if (field.type === 'email' && field.value && !this.isValidEmail(field.value)) {
      return false;
    }

    // Check custom validators
    if (this.customValidators.has(field.id)) {
      const { validatorFn } = this.customValidators.get(field.id);
      const result = validatorFn(field.value, field);
      if (typeof result === 'string') {
        return false;
      }
      return !!result;
    }

    return true;
  }

  validateForm(silent = true) {
    const allFields = this.form.querySelectorAll('input, textarea, select');
    let isFormValid = true;

    allFields.forEach(field => {
      const isFieldValid = this.validateField(field, silent);
      if (!isFieldValid) {
        isFormValid = false;
      }
    });

    if (!silent) {
      this.updateErrorOutput();
    }

    return isFormValid;
  }

  updateButtonState() {
    if (!this.options.buttonSelector) return;

    const button = document.querySelector(this.options.buttonSelector);
    if (!button) return;

    if (this.options.showErrorsOnSubmitOnly && !this.hasSubmittedOnce) {
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
      button.setAttribute('aria-disabled', 'false');
      return;
    }

    const isValid = this.validateForm(true);

    if (isValid) {
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
      button.setAttribute('aria-disabled', 'false');
    } else {
      button.setAttribute('disabled', 'true');
      button.classList.add('disabled');
      button.setAttribute('aria-disabled', 'true');
    }
  }

  clearErrors() {
    const errorFields = this.form.querySelectorAll(`.${this.options.errorClass}`);
    errorFields.forEach(field => {
      field.classList.remove(this.options.errorClass);
    });

    if (this.options.errorOutputSelector) {
      this.outputErrors([]);
    }
  }

  showAllErrors() {
    return this.validateForm(false);
  }


  getFormData() {
    const formData = new FormData(this.form);
    return Object.fromEntries(formData.entries());
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  isValidFutureDate(dateString) {
    if (!dateString) return false;
    const selectedDate = new Date(dateString);
    const now = new Date();
    return selectedDate > now;
  }
}
class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

function normalizeSellingPlanValue(value) {
  if (value == null) return "";

  const plan = String(value).trim();
  if (!plan || /^(0|false|null|undefined|on|off)$/i.test(plan)) return "";

  const gidMatch = plan.match(/SellingPlan\/(\d+)/i);
  if (gidMatch) return gidMatch[1];

  const paramMatch = plan.match(/(?:selling[_-]?plan(?:_id)?|plan[_-]?id)[=:](\d+)/i);
  if (paramMatch) return paramMatch[1];

  return /^\d+$/.test(plan) ? plan : "";
}

function isOneTimePurchaseValue(value) {
  return /one[\s_-]*time|onetime|once|single/i.test(String(value || ""));
}

function readSellingPlanField(scope) {
  if (!scope?.querySelector) return null;

  const checkedPlan = scope.querySelector(
    'input[name="selling_plan"]:checked, input[name="selling_plan_id"]:checked, input[name="sellingPlan"]:checked'
  );
  const checkedValue = normalizeSellingPlanValue(checkedPlan?.value);
  if (checkedValue) return checkedValue;

  const selectors = scope.querySelectorAll(
    'select[name="selling_plan"], select[name="selling_plan_id"], select[name="sellingPlan"], select[data-selling-plan], select[data-selling-plan-id]'
  );
  for (const select of selectors) {
    const value = normalizeSellingPlanValue(select.value);
    if (value) return value;
  }

  const inputs = scope.querySelectorAll(
    'input[name="selling_plan"], input[name="selling_plan_id"], input[name="sellingPlan"], input[data-selling-plan], input[data-selling-plan-id]'
  );
  for (const input of inputs) {
    if (input.disabled || (input.type === "radio" && !input.checked)) continue;
    const value = normalizeSellingPlanValue(input.value || input.dataset.sellingPlan || input.dataset.sellingPlanId);
    if (value) return value;
  }

  const dataElements = scope.querySelectorAll(
    "[data-selling-plan], [data-selling-plan-id], [data-selling-planid], [data-sellingplanid]"
  );
  for (const el of dataElements) {
    const value = normalizeSellingPlanValue(
      el.dataset.sellingPlan || el.dataset.sellingPlanId || el.dataset.sellingPlanid || el.dataset.sellingplanid
    );
    if (value) return value;
  }

  return null;
}

function getAppSubscriptionScopes(scope) {
  if (!scope?.querySelectorAll) return [];

  const directScopes = Array.from(
    scope.querySelectorAll(
      ".appstle_subscription_widget, .appstle_subscription_wrapper, .appstle_widget, .shopify_subscriptions_app_block_container"
    )
  );
  const namedScopes = Array.from(scope.querySelectorAll("[class], [id]")).filter((el) => {
    const marker = `${el.className || ""} ${el.id || ""}`.toLowerCase();
    return marker.includes("appstle") || marker.includes("subscription-widget");
  });

  return Array.from(new Set([...directScopes, ...namedScopes]));
}

function readAppSubscriptionPlan(scope) {
  const appScopes = getAppSubscriptionScopes(scope);

  for (const appScope of appScopes) {
    const checkedPurchase = appScope.querySelector('input[type="radio"]:checked');
    if (checkedPurchase && isOneTimePurchaseValue(checkedPurchase.value)) return "";

    const checkedValue = normalizeSellingPlanValue(
      checkedPurchase?.value ||
      checkedPurchase?.dataset?.sellingPlan ||
      checkedPurchase?.dataset?.sellingPlanId
    );
    if (checkedValue) return checkedValue;

    const fieldValue = readSellingPlanField(appScope);
    if (fieldValue) return fieldValue;
  }

  return null;
}

function getFormProductId(formElement) {
  return String(
    formElement?.dataset?.productid ||
    formElement?.dataset?.productId ||
    formElement?.querySelector?.('input[name="id"][data-productid]')?.dataset?.productid ||
    formElement?.querySelector?.('input[name="id"][data-product-id]')?.dataset?.productId ||
    ""
  );
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );
  }

  getAllowedSellingPlans(formElement, variantId) {
    const mapScript = formElement.querySelector("[data-upsell-selling-plan-map]");

    if (!mapScript) {
      return null;
    }

    try {
      const map = JSON.parse(mapScript.textContent);
      return map?.variants?.[String(variantId)] || [];
    } catch (error) {
      return [];
    }
  }

  applySellingPlan(serialized, formElement) {
    const variantId = String(serialized.id);
    const sellingPlanInput = formElement.querySelector("[data-upsell-selling-plan]");
    const allowedPlans = this.getAllowedSellingPlans(formElement, variantId);
  
    if (sellingPlanInput) {
      serialized.selling_plan = "";
    }
  
    const input = formElement.querySelector('[name="selling_plan"]');
  
    if (input && !input.disabled && input.value) {
      serialized.selling_plan = input.value;
    } else {
      serialized.selling_plan = "";
    }
  
    return serialized;
  }
  addToCart(event) {
    var _this = this;

    event.preventDefault();

    var addToCartButton = event.target.closest("[data-action=add-to-cart]");
    var formElement = addToCartButton.closest("form");

    if (!formElement) {
      return;
    }

    if (this.pageLoader) {
      this.pageLoader.style.width = 100 + "%";
    }

    addToCartButton.setAttribute("disabled", "disabled");

    var variantInput = formElement.querySelector('[name="id"]');

    if (variantInput) {
      variantInput.removeAttribute("disabled");
    }

    var formHelper = new Form();
    const serialized = this.applySellingPlan(
      formHelper.serialize(formElement),
      formElement
    );


    const payload = JSON.stringify(serialized);

    console.log("payload", payload)

    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: payload,
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (window.theme.cartMode === "page") {
          location.href = window.routes.cart_page_url;
        }

        if (window.location.href.indexOf("cart") != -1) {
          location.reload();
          return;
        }

        addToCartButton.removeAttribute("disabled");

        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
              selling_plan: serialized.selling_plan || null,
            },
          })
        );
      } else {
        response.json().then(function (content) {
          var errorMessageElement = document.createElement("span");
          errorMessageElement.className = "u-p4 accent";
          errorMessageElement.innerHTML = content["description"];

          Object.assign(errorMessageElement.style, {
            display: "block",
            position: "relative",
            zIndex: "10",
            backgroundColor: "var(--background_color)",
            padding: "8px 12px",
            marginTop: "8px",
            width: "100%",
            textAlign: "center",
          });

          addToCartButton.removeAttribute("disabled");
          addToCartButton.insertAdjacentElement("afterend", errorMessageElement);

          setTimeout(function () {
            errorMessageElement.remove();
          }, 2500);

          if (_this.pageLoader) {
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";

            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          }
        });
      }
    });
  }
}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Dropdown {
  static FOCUSABLE_SELECTOR = 'a[href], button, input, select, textarea, [tabindex]';

  constructor() {
    this.domDelegate = sharedBodyDelegate;
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll(".Dropdown");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.lock = false;
    this._unlockTimer = null;
    this.bindEvents();
  }

  _setFocusable(container, focusable) {
    container.querySelectorAll(Dropdown.FOCUSABLE_SELECTOR).forEach((el) => {
      if (focusable) {
        const prev = el.getAttribute("data-prev-tabindex");
        if (prev !== null) {
          el.setAttribute("tabindex", prev);
          el.removeAttribute("data-prev-tabindex");
        } else {
          el.removeAttribute("tabindex");
        }
      } else {
        const current = el.getAttribute("tabindex");
        if (current !== "-1") {
          if (current !== null) {
            el.setAttribute("data-prev-tabindex", current);
          }
          el.setAttribute("tabindex", "-1");
        }
      }
    });
  }

  _setLock(ms = 650) {
    this.lock = true;
    clearTimeout(this._unlockTimer);
    this._unlockTimer = setTimeout(() => {
      this.lock = false;
    }, ms);
  }

  _unlockNow() {
    clearTimeout(this._unlockTimer);
    this.lock = false;
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    let selector;
    switch (this.breakpoint) {
      case "desktop":
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "pocket":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  }

  updateAllDropdowns() {
    this.allDropdowns = document.querySelectorAll(".Dropdown");
  }

  openDropdown(elem, target) {
    if (this.lock) return;
    this._setLock(700);

    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    // Cancel any stale close fallback timer for this element (FIX H1)
    if (DropdownContent._closeFallbackTimer) {
      clearTimeout(DropdownContent._closeFallbackTimer);
      DropdownContent._closeFallbackTimer = null;
    }

    // Track if we're closing other dropdowns
    let closingOtherDropdowns = false;

    // Only close other dropdowns if this one does NOT allow multiple open
    if (!elem.classList.contains("allow-multiple")) {
      this.allDropdowns.forEach((dropdown) => {
        if (
          dropdown !== target.closest(".Dropdown") &&
          dropdown.querySelector("[aria-expanded='true']") &&
          !dropdown.contains(target)
        ) {
          closingOtherDropdowns = true;
          this.closeDropdown(dropdown, true);
        }
      });
    }


    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        this._unlockNow();

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);
    // Fallback unlock in case transitionend never fires (FIX H2)
    setTimeout(() => { if (this.lock) this._unlockNow(); }, 500);
    DropdownContent.style.display = '';

    DropdownButton.setAttribute("aria-expanded", "true");
    this._setFocusable(DropdownContent, true);
    new RevolutionAnimation(DropdownContent, "true").slideDown();

    // Scroll to the top of the newly opened dropdown on mobile
    // This handles both regular dropdowns and PDP dropdowns with do-not-close class
    const currentBreakpoint = responsive.getCurrentBreakpoint();
    const isMobile = currentBreakpoint === "pocket" || currentBreakpoint === "phone";
    
    try {
      if (!elem.closest('faq-section') && (isMobile || elem.closest("faq-group")) && closingOtherDropdowns) {
        // When switching from one dropdown to another on mobile,
        // scroll to the newly opened dropdown after animations settle
        setTimeout(() => {
          const dropdownRect = elem.getBoundingClientRect();
          const dropdownTop = dropdownRect.top + window.pageYOffset;
          const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-dynamic-height').replace("px", "") || 54;
          const annBarHeight = getComputedStyle(document.documentElement).getPropertyValue('--announcement-dynamic-height').replace("px", "") || 0;

          window.scrollTo({
            top: dropdownTop - headerHeight - annBarHeight,
            behavior: 'smooth'
          });
        }, 500); // Wait longer for closing animation to complete
      }
    } catch(e) {
      // TypeError in scroll-to-top logic — silently ignored
    }
  }

  closeAllDropdowns(namespace) {
    namespace.querySelectorAll(".Dropdown").forEach((dropdown) => {
      if (
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown);
      }
    });
  }

  closeDropdown(elem, ignore) {
    if (this.lock && !ignore) return;
    this._setLock(700);

    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");
    const transitionEndHandler = (event) => {
      if (!event || event.propertyName === "height") {
        if (DropdownContent.getAttribute("aria-hidden") == "false") {
          DropdownContent.setAttribute("aria-hidden", "true");
        }

        this._unlockNow();

        DropdownContent.style.display = "none";

        DropdownContent.querySelectorAll('.Dropdown--Button').forEach((btn) => {
          btn.setAttribute("aria-expanded", "false");
        });

        DropdownContent.querySelectorAll('.Dropdown--Content').forEach((content) => {
          content.setAttribute("aria-hidden", "true");
          content.style.height = 0;
        });

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    // Store the fallback timer so it can be cancelled if dropdown is reopened (FIX H1)
    DropdownContent._closeFallbackTimer = setTimeout(() => {
      DropdownContent._closeFallbackTimer = null;
      transitionEndHandler();
    }, 500);

    this._setFocusable(DropdownContent, false);
    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (!this.lock) {
      if (isOpen) {
        // If dropdown is open, close it
        this.closeDropdown(mainDropdown, target);

        if (mainDropdown.classList.contains('filter__dropdown')) {
          mainDropdown.dispatchEvent(
            new CustomEvent("close:filters", { bubbles: true })
          );
        }
      } else {
        // If dropdown is closed, open it
        this.openDropdown(mainDropdown, target);

        if (mainDropdown.classList.contains('filter__dropdown')) {
          mainDropdown.dispatchEvent(
            new CustomEvent("open:filters", { bubbles: true })
          );
        }
      }
    }
  }
}

const allDropdowns = new Dropdown();




class RevolutionSwiper {
  // Base defaults for smooth iOS / mobile swiping.
  // Per-instance data-swiper-settings will override any of these.
  static defaults = {
    speed: 400,
    threshold: 5,
    touchRatio: 1,
    resistanceRatio: 0.85,
    touchStartPreventDefault: false,
    passiveListeners: true,
    touchMoveStopPropagation: false,
    preventInteractionOnTransition: true,
  };

  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;

    var parsed = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );
    // Merge: defaults < parsed (template wins)
    this.initialConfig = Object.assign({}, RevolutionSwiper.defaults, parsed);

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {

      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });

    this._patchLastBulletOnEnd();
  }

  /**
   * Fix: When slidesPerView is fractional (e.g. 1.09), the swiper's max
   * scroll position can't reach the snap point for the last slide because
   * there is no "next" slide to fill the peek portion. This means the last
   * pagination bullet never receives the active class.
   *
   * This patch detects when the swiper is at its end position and forces
   * the last bullet to be active. On iOS this is especially noticeable
   * because momentum scrolling / rubber-banding make it impossible to
   * manually snap to the last slide.
   */
  _patchLastBulletOnEnd() {
    const swiper = this.swiperElement;
    if (!swiper || !swiper.params) return;

    // Loop mode handles wrap-around differently; skip it.
    if (swiper.params.loop) return;

    // Only needed when the last slide can't become "active" —
    // i.e. fractional slidesPerView > 1 or slidesPerView "auto".
    const spv = swiper.params.slidesPerView;
    const needsFix =
      spv === "auto" ||
      (typeof spv === "number" && spv > 1 && !Number.isInteger(spv));
    if (!needsFix) return;

    if (!swiper.pagination || !swiper.pagination.el) return;

    const activeCls =
      swiper.params.pagination?.bulletActiveClass ||
      "swiper-pagination-bullet-active";

    const fixLastBullet = () => {
      if (!swiper.isEnd) return;

      const bullets = swiper.pagination?.bullets;
      if (!bullets || !bullets.length) return;

      const lastBullet = bullets[bullets.length - 1];
      if (!lastBullet || lastBullet.classList.contains(activeCls)) return;

      for (let i = 0; i < bullets.length; i++) {
        bullets[i].classList.remove(activeCls);
      }
      lastBullet.classList.add(activeCls);
    };

    // Run after transition completes so it doesn't get overwritten
    // by Swiper's own pagination.update() call.
    swiper.on("transitionEnd", fixLastBullet);

    // Also cover programmatic slideTo / autoplay reaching the end.
    swiper.on("reachEnd", () => requestAnimationFrame(fixLastBullet));

    // When leaving the end, let Swiper restore normal pagination.
    swiper.on("fromEdge", () => {
      if (!swiper.isEnd && swiper.pagination) {
        swiper.pagination.update();
      }
    });
  }
}

class Drawer {
  static instances = [];

  constructor(element, options = {}) {
    this.element = element;
    this.drawerId = this.element.id;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    this.onOpen = options.onOpen || (() => { });
    this.onClose = options.onClose || (() => { });
    this.isOpen = false;
    this._isAnimating = false;
    this._closeTimeoutId = null;
    this._trapFocusTimeoutId = null;
    this._openRafId = null;
    this._onTransitionEnd = null;

    // Add this instance to the static array
    Drawer.instances.push(this);

    this.initViewportHeight();
    this.bindEvents();
  }

  static closeAllExcept(currentDrawer) {
    Drawer.instances.forEach(drawer => {
      if (drawer !== currentDrawer && drawer.isOpen) {
        drawer.closeDrawer();
      }
    });
  }

  initViewportHeight() {
    const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
    if (isIOS) {
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    }
  }

  bindEvents() {
    const drawerId = this.drawerId;

    this.delegateBody.on(
      "click",
      `[data-action="open-drawer"][data-toggle-id="${drawerId}"]`,
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      `[data-action="close-drawer"][data-toggle-id="${drawerId}"]`,
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      `[data-action="toggle-drawer"][data-toggle-id="${drawerId}"]`,
      this.toggleDrawer.bind(this)
    );

    this.delegateBody.on(
      'drawer:close-other',
      this.closeDrawer.bind(this)
    );

    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);

    this._resizeHandle = responsive.addResizeListener(this, this.calculateMaxHeightListener);
  }

  destroy() {
    // Cancel any in-flight timers, rAFs, and listeners
    this._cancelPendingOperations();

    // Remove from static instances array
    const idx = Drawer.instances.indexOf(this);
    if (idx !== -1) Drawer.instances.splice(idx, 1);

    // Remove resize listener
    if (this._resizeHandle) {
      this._resizeHandle.removeResizeListener();
      this._resizeHandle = null;
    }

    // Remove delegate listeners
    this.delegateElement?.off?.();
    this.delegateBody?.off?.();

    // Remove page overlay click listener
    if (this.pageOverlayElement) {
      this.pageOverlayElement.removeEventListener("click", this._closeListener);
    }
  }

  isCartDrawer() {
    return this.drawerId === "cart" || this.drawerId === "sidebarFavorites";
  }

  isMobileMenuDrawer() {
    return this.drawerId === "mobile-menu-drawer";
  }

  maxHeight() {
    this.element.style.height = `${window.innerHeight}px`;

    if (this.isCartDrawer()) {
      this.calculateCartHeight();
    }
  }

  calculateCartHeight() {
    const footer = this.element.querySelector(".CartDrawer--Footer");
    const headerEl = this.element.querySelector(".CartHeader");
    const itemWrapper = this.element.querySelector(".CartItems--Wrapper");

    if (!itemWrapper) return;

    const footerHeight = footer?.offsetHeight || 0;
    const headerHeight = headerEl?.offsetHeight || 0;

    itemWrapper.style.height = `${window.innerHeight - footerHeight - headerHeight}px`;
  }

  toggleDrawer(event) {
    if (event) event.preventDefault();
    if (this._isAnimating) return;
    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  dispatchCustomEvent(eventName) {
    this.element.dispatchEvent(
      new CustomEvent(eventName, { bubbles: true })
    );
  }

  openDrawer() {
    if (this.isOpen || this._isAnimating) return;

    // Cancel any stale pending operations from a previous close
    this._cancelPendingOperations();

    this.dispatchCustomEvent("close:search");

    if (this.drawerId === "cart") {
      this.dispatchCustomEvent("cart-drawer:open");
    }

    if (this.isMobileMenuDrawer()) {
      this.dispatchCustomEvent("mobile-menu:open");
    }

    const sortPopup = document.querySelector('.collection__sort-popup.Popup[aria-expanded="true"]');
    if (sortPopup) {
      window.globalPopup?.closePopup(sortPopup);
    }

    // Close all other open drawers
    Drawer.closeAllExcept(this);

    this.maxHeight();
    this.element.style.display = "";

    this._isAnimating = true;
    this._openRafId = requestAnimationFrame(() => {
      this._openRafId = null;
      this.element.setAttribute("aria-expanded", "true");
    });

    this.pageOverlayElement.classList.add("is-visible");
    this.pageOverlayElement.addEventListener("click", this._closeListener);

    const focusElement = this.element.querySelector("[data-scrollable]");
    if (focusElement) {
      bodyScrollLock.disableBodyScroll(focusElement, bodyScrollLockOptions);
    }

    document.body.classList.add("scrollLock");
    IOSScrollLock.lock();

    this.isOpen = true;

    this._trapFocusTimeoutId = setTimeout(() => {
      this._trapFocusTimeoutId = null;
      this._isAnimating = false;
      trapFocus(this.element);
    }, 400);

    this.dispatchCustomEvent("drawer:opened");
    this.onOpen();
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen || this._isAnimating) return;

    if (event) event.preventDefault();

    // Cancel any stale pending operations from a previous open
    this._cancelPendingOperations();

    if (this.isMobileMenuDrawer()) {
      this.dispatchCustomEvent("mobile-menu:close");
    }

    const drawerScrollable = this.element.querySelector("[data-scrollable]");
    if (drawerScrollable) {
      bodyScrollLock.enableBodyScroll(drawerScrollable);
    }

    // Only remove scrollLock if no other drawer/search is still open
    const anyDrawerOpen = Drawer.instances.some(d => d !== this && d.isOpen);
    const searchEl = document.querySelector('search-bar');
    const searchOpen = searchEl && (searchEl.isOpen || searchEl._isOpening);
    if (!anyDrawerOpen && !searchOpen) {
      document.body.classList.remove("scrollLock");
    }

    this._isAnimating = true;
    this._onTransitionEnd = (e) => {
      if (e.target !== this.element) return;
      this.element.style.display = "none";
      this.element.removeEventListener("transitionend", this._onTransitionEnd);
      this._onTransitionEnd = null;
      this._isAnimating = false;
    };

    this._closeTimeoutId = setTimeout(() => {
      this._closeTimeoutId = null;
      if (this._onTransitionEnd) {
        this._onTransitionEnd({ target: this.element });
      }
    }, 500);

    this.element.addEventListener("transitionend", this._onTransitionEnd);
    this.element.setAttribute("aria-expanded", "false");

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);

    removeTrapFocus(this.element);
    IOSScrollLock.unlock();

    this.isOpen = false;
    this.dispatchCustomEvent("drawer:closed");
    this.onClose();
  }

  _cancelPendingOperations() {
    if (this._closeTimeoutId) {
      clearTimeout(this._closeTimeoutId);
      this._closeTimeoutId = null;
    }
    if (this._trapFocusTimeoutId) {
      clearTimeout(this._trapFocusTimeoutId);
      this._trapFocusTimeoutId = null;
    }
    if (this._openRafId) {
      cancelAnimationFrame(this._openRafId);
      this._openRafId = null;
    }
    if (this._onTransitionEnd) {
      this.element.removeEventListener("transitionend", this._onTransitionEnd);
      this._onTransitionEnd = null;
    }
    this._isAnimating = false;
  }

}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.integer = 0;

      // When a specific element is provided, scope animations to that subtree only
      // and skip the MutationObserver (the global instance already covers future additions)
      var scope = element || document;
      var contentToAnimate = [...scope.querySelectorAll("[data-animation]")];

      // Also include the root element itself if it has data-animation
      // (querySelectorAll only searches descendants, not the element itself)
      if (element && element.matches && element.matches("[data-animation]")) {
        contentToAnimate.unshift(element);
      }

      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Only attach a global MutationObserver for the initial document-wide instance
      if (!element) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                const newContentToAnimate = node.querySelectorAll("[data-animation]");

                newContentToAnimate.forEach((item) => {
                  this.animateElement(item, this.integer);
                  this.integer = this.integer + 1;
                });
              }
            });
          });
        });

        observer.observe(document.body, { childList: true, subtree: true });
      }
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    this.element.style.pointerEvents = "none";
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  elementScaleOut(elements) {
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;
    elements.forEach((element, index) => {
      if (element.hasAttribute("data-loaded")) {
        return;
      }
      element.setAttribute("data-loaded", true);
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];
      setTimeout(() => {
        element.animate(keyframes, {
          duration: animationDuration,
          fill: "forwards",
        });
      }, animationDelay * index);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration * 2,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  // Simple fade-in animation without scaling
  elementFadeIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.hasAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { opacity: "0" },
          { opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  animateElement(animatedItem, index) {
    if (!this._sharedObserver) {
      this._sharedObserver = new IntersectionObserver(
        (entries) => {
          const byType = {};
          entries.forEach((entry) => {
            if (entry.isIntersecting || entry.intersectionRatio > 0) {
              const type = entry.target.closest('[data-animation]')?.dataset.animation;
              if (type) {
                if (!byType[type]) byType[type] = [];
                byType[type].push(entry.target);
              }
              this._sharedObserver.unobserve(entry.target);
            }
          });
          for (const [type, elements] of Object.entries(byType)) {
            if (typeof this[type] === 'function') {
              this[type](elements);
            }
          }
        },
        { threshold: 0.15 }
      );
    }

    if (animatedItem.classList.contains('animatedContent')) {
      this._sharedObserver.observe(animatedItem);
    }
    animatedItem.querySelectorAll('.animatedContent').forEach((item) => {
      this._sharedObserver.observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });

    // ✅ FIX: safe JSON parse (prevents options being null -> noVariants crash)
    const raw = this.element.getAttribute("data-settings") || "{}";
    try {
      this.options = JSON.parse(raw) || {};
    } catch (e) {
      this.options = {};
    }

    this.minusButton =
      this.querySelector('button[name="minus"]') ||
      Array.from(this.querySelectorAll("button")).find((b) => b.name === "minus");

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    this.input.addEventListener("input", this.updateMinusState.bind(this));
    this.input.addEventListener("change", this.updateMinusState.bind(this));

    this.updateMinusState();
  }

  updateMinusState() {
    if (!this.minusButton || !this.input) return;
    const min = Number(this.input.getAttribute("min")) || 1;
    const value = Number(this.input.value) || min;

    const disabled = value <= min;
    this.minusButton.disabled = disabled;
    this.minusButton.setAttribute("aria-disabled", disabled ? "true" : "false");
    this.minusButton.tabIndex = disabled ? -1 : 0;
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    this.updateMinusState();

    // ✅ FIX: null-safe access
    if (this.options?.noVariants == "true") {
      this.toggleAddButton();
    }
  }

  toggleAddButton() {
    if (!this.currentVariant || this.isUpsell) return;

    const root = this.getRoot();
    const available = !!this.currentVariant.available;

    // 1) Always tag wrapper state (this fixes reload + switching issues)
    root.querySelectorAll(".Quantity-ATC--wrapper").forEach((w) => {
      w.classList.toggle("is-in-stock", available);
      w.classList.toggle("is-oos", !available);
    });

    // 2) Your existing logic (keep as-is)
    root.querySelectorAll('form[data-product-form]').forEach((form) => {
      form.dataset.variantAvailable = available ? "true" : "false";

      form.querySelectorAll(".add-to-cart__wrapper").forEach((el) => {
        el.classList.toggle("hideBtn", !available);
      });

      form.querySelectorAll(".notify-wrapper").forEach((el) => {
        el.classList.toggle("hideBtn", available);
      });

      form.querySelectorAll(".QuantityHandler").forEach((el) => {
        el.classList.toggle("hideBtn", !available);
      });
    });

    // 3) Your button label logic (keep, but don’t remove sold-out text incorrectly)
    root.querySelectorAll(".product__atc-button").forEach((btn) => {
      const labelNode = btn.querySelector(".button-txt") || btn.querySelector(".ButtonText");
      if (!labelNode) return;

      Array.from(labelNode.childNodes).forEach((n) => {
        if (n.nodeType === Node.TEXT_NODE) n.remove();
      });

      const inline = labelNode.querySelector(".atc-price-inline");
      const totalInLabel = labelNode.querySelector(".button-total-price");

      if (!available) {
        const soldOutText = window.variantStrings?.soldOut || "SOLD OUT";
        labelNode.insertBefore(document.createTextNode(soldOutText), labelNode.firstChild);

        if (inline) inline.remove();
        if (totalInLabel) totalInLabel.textContent = "";
        return;
      }

      labelNode.insertBefore(
        document.createTextNode((window.variantStrings?.addToCart || "ADD TO CART").toUpperCase()),
        labelNode.firstChild
      );

      if (inline && !labelNode.contains(inline)) labelNode.appendChild(inline);
      if (totalInLabel && !labelNode.contains(totalInLabel)) labelNode.appendChild(totalInLabel);
    });
  }



}

customElements.define("quantity-input", QuantityInput);



function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.productId = this.querySelector('.pc-variant-radios')?.dataset.productId;

    this.variants = JSON.parse(
      this.querySelector(`#variants-json-${this.productId}`)?.textContent || '[]'
    );

    this.swiperInitEl = this.querySelector('swiper-init');
  }

  connectedCallback() {
    const checked = this.querySelector(".pc-variant-radios input[type='radio']:checked");
    if (checked) this.handleVariantChange(checked.value);

    this.setReviewsText();
    this.bindEvents();
  }

  disconnectedCallback() {
    this.delegateElement?.off?.();
    this.removeEventListener('mouseenter', this.onHoverEnter);
    this.removeEventListener('mouseleave', this.onHoverLeave);
  }

  bindEvents() {
    this.delegateElement.on('click', '[data-action="select-variant"]', (e) => {
      const input = e.target.closest("input[type='radio']");
      if (!input) return;
      this.handleVariantChange(input.value);
    });

    if (this.swiperInitEl) {
      this.addEventListener('mouseenter', this.onHoverEnter);
      this.addEventListener('mouseleave', this.onHoverLeave);
    }
  }

  getSwiper() {
    const rev = this.swiperInitEl?.getSwiper?.();
    return rev?.swiperElement || null;
  }

  onHoverEnter = () => {
    if (responsive.currentBreakpoint !== 'desktop') return;

    const sw = this.getSwiper();
    if (!sw?.slides || sw.slides.length < 2) return;

    // Only swap when first slide is active
    if (sw.activeIndex === 0) {
      sw.slideTo(1, 0); // no animation
    }
  };

  onHoverLeave = () => {
    if (responsive.currentBreakpoint !== 'desktop') return;

    const sw = this.getSwiper();
    if (!sw) return;

    if (sw.activeIndex === 1) {
      sw.slideTo(0, 0); // no animation
    }
  };

  handleVariantChange(variantId) {
    const v = this.variants.find((x) => x.id == variantId);
    if (!v) return;

    const priceEl = this.querySelector('[data-price]');
    if (priceEl) {
      priceEl.textContent = Shopify.formatMoney(v.price, window.theme.moneyFormat);
    }

    const compareWrap = this.querySelector('[data-compare-wrap]');
    const compareEl = this.querySelector('[data-compare-at]');
    if (compareWrap && compareEl) {
      if (v.compare_at_price > v.price) {
        compareEl.textContent = Shopify.formatMoney(v.compare_at_price, window.theme.moneyFormat);
        compareWrap.classList.remove('hidden');
      } else {
        compareWrap.classList.add('hidden');
      }
    }

    this.querySelectorAll("form.shopify-product-form input[name='id']").forEach(
      (input) => (input.value = v.id)
    );

    this.querySelectorAll("form.shopify-product-form [data-action='add-to-cart']").forEach(
      (btn) => {
        btn.disabled = !v.available;
        btn.classList.toggle('ProductCard--Sold__Out', !v.available);
      }
    );

    this.querySelectorAll(".pc-variant-radios input[type='radio']").forEach((input) => {
      const label = input.closest('.product-card__variants-radio');
      if (!label) return;
      label.classList.toggle('is-active', input.value == variantId);
    });
  }

  setReviewsText() {
    const reviewsBadge = this.element.querySelector('.jdgm-prev-badge');
    const reviewsText = this.element.querySelector('.jdgm-prev-badge__text');
    if (reviewsBadge && reviewsText) {
      reviewsText.innerHTML =
        `<span class="pc__ratin u-p4">${reviewsBadge.getAttribute('data-average-rating')}</span>` +
        `<span class="pc__rating-count u-p4">(${reviewsBadge.getAttribute('data-number-of-reviews')})</span>`;
    }
  }
}

customElements.define('product-card', ProductCard);




class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector('.component-countDownWrapper');

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options['countdownString'];
    counterString = counterString.replace('{countdown}', '<span class="u-pb6 component-countDown">00:00:00</span>');
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;


    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector(".component-countDown");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options['countdownType'] == 'to_date') {
      countDate = new Date(this.options.countdownDate);
    }



    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;


    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);


    const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
    if (targetHours < currentHours || (targetHours === currentHours && targetMinutes <= currentMinutes) && this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference - 1;
    } else if (this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference;
    }


    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);


var stateWasEmpty = true;
class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.focusElement = false;
    this.drawer = new Drawer(this.element, {
      onClose: () => {
        this.isOpen = false;
        this.recommendationsOpen = false;
        this.onClose();
      },
      onOpen: () => {
        this.isOpen = true;
        this.onOpen();
      },
    });

    this.loader = this.element.querySelector(".itemLoader");

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.emptyCartCollection = this.element.querySelector('.cart-drawer__recommendations');
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.cartIds = false;
    this.isOpen = false;
    this.recommendationsOpen = false;
    this.recommendationLoading = false;
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.cachedUsp = this.cacheUspMarkup();

    this.ensureUspPlacement();

    this.addToCart = new AddToCart(this.element);
    this._recommendationsLoaded = false;

    this.bindEvents();
    const closeBtn = this.element.querySelector('.cart-drawer .Drawer--Close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        closeBtn.classList.add('is-active');
        setTimeout(() => closeBtn.classList.remove('is-active'), 400);
      });
    }

    // Keep third-party injected widgets (e.g. Discounty) from visibly "blinking" if they
    // temporarily remove/re-inject their portal on cart updates.
    this.setupDiscountyPortalGuard();
  }

  bindEvents() {
    if (this._listenersBound) return;
    this._listenersBound = true;

    this._onProductAdded = this.onProductAdded.bind(this);
    this._onBreakpointChanged = this.updateCartFooterHeight.bind(this);

    document.addEventListener("product:added", this._onProductAdded);

    this.delegateElement.on(
      "click",
      '[data-action="update-item-quantity"], [data-action="remove-item"]',
      this.updateItemQuantity.bind(this)
    );
    this.delegateElement.on(
      "change",
      '[data-action="update-change-quantity"]',
      this.updateItemQuantity.bind(this)
    );
    this.delegateElement.on(
      "quantity:changed",
      ".cart-item__quantity",
      this.updateItemQuantity.bind(this)
    );

    this.delegateBody.on(
      "click",
      '[data-action="replace-cart-item"]',
      this.handleReplaceCartItem.bind(this)
    );

    document.addEventListener("breakpoint:changed", this._onBreakpointChanged);

  }
  disconnectedCallback() {
    document.removeEventListener("product:added", this._onProductAdded);
    document.removeEventListener("breakpoint:changed", this._onBreakpointChanged);

    this._onProductAdded = null;

    if (this._discountyObserver) {
      this._discountyObserver.disconnect();
      this._discountyObserver = null;
    }
    if (this._discountySyncInterval) {
      clearInterval(this._discountySyncInterval);
      this._discountySyncInterval = null;
    }
    this._discountySyncScheduled = false;

    // Destroy the inner Drawer to clean up its listeners and instances
    if (this.drawer) {
      this.drawer.destroy();
      this.drawer = null;
    }

    this.delegateElement?.off?.();
    this.delegateBody?.off?.();

    this._listenersBound = false;
  }

  setupDiscountyPortalGuard() {
    // Keep the always-visible mirror in sync with Discounty's injected portal.
    // We hide `.discounty-portal` via CSS to avoid flicker/FOUC, but still read its values.
    if (this._discountyObserver) return;

    const scheduleSync = () => {
      if (this._discountySyncScheduled) return;
      this._discountySyncScheduled = true;
      requestAnimationFrame(() => {
        this._discountySyncScheduled = false;
        this.syncDiscountyMirror();
      });
    };

    this._discountyObserver = new MutationObserver(scheduleSync);
    // Observe both this drawer and the body so we catch portal injections even if
    // Discounty temporarily mounts outside the drawer during refresh.
    this._discountyObserver.observe(this.element, { childList: true, subtree: true, characterData: true });
    this._discountyObserver.observe(document.body, { childList: true, subtree: true, characterData: true });

    // Poll as a safety net for cases where mutations are missed.
    this._discountySyncInterval = setInterval(() => this.syncDiscountyMirror(), 1000);

    scheduleSync();
  }

  syncDiscountyMirror() {
    const mirror = this.element.querySelector("[data-discounty-mirror]");
    if (!mirror) return;

    const portal =
      this.element.querySelector('.discounty-portal, [data-fragment-id].discounty-portal') ||
      document.querySelector('.discounty-portal, [data-fragment-id].discounty-portal');

    const totalFromPortal = portal
      ?.querySelector(".discounty-cart-widget__total-amount")
      ?.textContent?.trim();
    const savingFromPortal = portal
      ?.querySelector(".discounty-cart-widget__saving-amount")
      ?.textContent?.trim();
    const subCartItems = this.element.querySelectorAll(".cart-item__subscription").length > 0;

    requestAnimationFrame(() => {
      // Show the mirror if Discounty portal exists OR if the cart contains subscription items.
      // (Subscription carts may rely on theme-rendered totals while Discounty initializes.)
      if (portal || subCartItems) {
        mirror.style.display = 'block';
      }else{
        mirror.style.display = 'none';
      }
    });

    // Fallback for first open after refresh: use theme-rendered totals if portal values
    // aren't available yet.
    const fallbackTotal = this.element.querySelector(
      ".cart_drawer__footer-totals .cd__subtotal-container span:last-child"
    )?.textContent?.trim();
    const fallbackSaving = this.element.querySelector(
      ".cart_drawer__footer-totals .cd__total-discount-value"
    )?.textContent?.trim();

    if (totalFromPortal) this._lastDiscountyTotal = totalFromPortal;
    if (savingFromPortal) this._lastDiscountySaving = savingFromPortal;
    if (!this._lastDiscountyTotal && fallbackTotal) this._lastDiscountyTotal = fallbackTotal;
    if (!this._lastDiscountySaving && fallbackSaving) this._lastDiscountySaving = fallbackSaving;

    const totalEl = mirror.querySelector(".discounty-mirror__total");
    if (totalEl && this._lastDiscountyTotal && totalEl.textContent !== this._lastDiscountyTotal) {
      totalEl.textContent = this._lastDiscountyTotal;
    }
    const savingEl = mirror.querySelector(".discounty-mirror__saving");
    if (savingEl && this._lastDiscountySaving && savingEl.textContent !== this._lastDiscountySaving) {
      savingEl.textContent = this._lastDiscountySaving;
    }
  }

  updateCartFooterHeight() {
    const footer = this.element.querySelector(".cart-drawer__footer");
    if (!footer) return;
    document.documentElement.style.setProperty(
      "--cart-drawer__footer-height",
      footer.offsetHeight + "px"
    );
  }

  updateCartDrawerHeights() {
    const header = this.element.querySelector(".cart-drawer__header");
    const footer = this.element.querySelector(".cart-drawer__footer");
    const shipping = this.element.querySelector(".cart-drawer__shipping");

    // Batch reads
    const headerHeight = header ? header.offsetHeight : 0;
    const footerHeight = footer ? footer.offsetHeight : 0;
    const shippingHeight = shipping ? shipping.offsetHeight : 0;

    // Batch writes
    const style = document.documentElement.style;
    if (header) style.setProperty("--cart-drawer__header-height", headerHeight + "px");
    if (footer) style.setProperty("--cart-drawer__footer-height", footerHeight + "px");
    if (shipping) style.setProperty("--cart-drawer__shipping-height", shippingHeight + "px");
  }

  cacheUspMarkup() {
    const temp = this.element.querySelector('.main-cart__usp-bar--temp');
    if (!temp) return null;

    const usp = temp.querySelector('cart-drawer-usp-bar');
    if (!usp) return null;

    return usp;
  }

  ensureUspPlacement() {
    if (!this.cachedUsp) return;

    const checkoutBtn = this.element.querySelector('.cart-drawer__checkout');
    if (!checkoutBtn) return;

    if (this.cachedUsp.previousElementSibling === checkoutBtn) return;

    checkoutBtn.after(this.cachedUsp);

    if (this.cachedUsp.animationEnabled) {
      requestAnimationFrame(() => {
        if (typeof this.cachedUsp.init === 'function') this.cachedUsp.init();
        if (typeof this.cachedUsp.measure === 'function') this.cachedUsp.measure();
      });
    }
  }



  onOpen() {
    if (this.element.getAttribute("aria-expanded") == "false") {
      setTimeout(() => {
        if (this.element.hasAttribute('data-open-drawer')) {
          this.focusElement = this.element.querySelector("[data-scrollable]");
          if (this.focusElement) {
            bodyScrollLock.disableBodyScroll(this.focusElement, bodyScrollLockOptions);
          }
        }

      }, 500);

    }
    this.updateCartDrawerHeights();

    const usp = this.element.querySelector("cart-drawer-usp-bar");
    if (usp?.animationEnabled) {
      requestAnimationFrame(() => {
        usp.init?.();
        usp.measure?.();
      });
    }

    // Lazy-load recommendations on first open instead of on page load
    if (!this._recommendationsLoaded) {
      this._recommendationsLoaded = true;
      this.loadRecommendations();
    }

    // Mirror should never be empty on first open after refresh.
    this.syncDiscountyMirror();
    setTimeout(() => this.syncDiscountyMirror(), 150);
    setTimeout(() => this.syncDiscountyMirror(), 600);
  }

  onClose() {
    setTimeout(() => {
      this.resetAllSwipers();
    }, 400);
  }

  resetAllSwipers() {
    const swiperEls = this.element.querySelectorAll("swiper-init");

    swiperEls.forEach((el) => {
      const swiper = el.swiper.swiperElement;

      if (!swiper) return;

      try {
        if (swiper.autoplay) {
          swiper.autoplay.stop();
        }

        swiper.slideTo(0, 0);

        swiper.update();

      } catch (err) {
      }
    });
  }


  async handleReplaceCartItem(e) {
    e.preventDefault();

    // Step 1: Get the current line item ID from localStorage
    const currentLineId = localStorage.getItem("current-line-item");
    if (!currentLineId) {
      return;
    }

    // Step 2: Get the quick-add form
    const form = document.querySelector('.quick-add-product form');
    if (!form) {
      return;
    }

    // Step 3: Extract form data
    const formData = new FormData(form);
    const newVariantId = formData.get('id');
    const newQuantity = parseInt(formData.get('quantity') || 1, 10);

    // Step 4: Collect custom properties
    const newProperties = {};
    for (let [key, value] of formData.entries()) {
      if (key.startsWith('properties[')) {
        const propName = key.match(/properties\[(.*?)\]/)?.[1];
        if (propName) {
          newProperties[propName] = value;
        }
      }
    }

    // Step 5: Call the existing replaceCartItem method
    await this.replaceCartItem(e, currentLineId, newVariantId, newQuantity, newProperties);

    if (window.theme.cartMode === 'page') {
      location.href = window.routes.cart_page_url;
    }
  }

  async replaceCartItem(e, currentLineId, newVariantId, newQuantity = 1, newProperties = {}) {
    e.preventDefault();
    try {
      const addToCartButton = e.target;
      addToCartButton.setAttribute("disabled", "disabled");
      // Show loader for the current item if visible
      const cartItem = document.querySelector(`[data-line-id="${currentLineId}"]`)?.closest('.cart-item');
      if (cartItem) {
        const itemLoader = cartItem.querySelector('.itemLoader');
        if (itemLoader) itemLoader.classList.add('is-visible');
      }

      // Step 1: Remove the current item
      const removeResponse = await fetch(`${window.routes.localeRootUrl}/cart/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ id: currentLineId, quantity: 0 })
      });

      if (!removeResponse.ok) throw new Error('Failed to remove current item');

      // Step 2: Add the new item
      const addResponse = await fetch(`${window.routes.localeRootUrl}/cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{ id: newVariantId, quantity: newQuantity, properties: newProperties }]
        })
      });

      if (!addResponse.ok) throw new Error('Failed to add new item');
      const addData = await addResponse.json();

      // Step 3: Refresh the cart drawer
      await this.renderCart(false, false);

      // Step 4: Cleanup
      localStorage.removeItem("current-line-item");
      this.currentLineId = null;

      // Step 5: Fire success event
      this.element.dispatchEvent(new CustomEvent('cart:item-replaced', {
        bubbles: true,
        detail: { oldLineId: currentLineId, newVariantId, newQuantity, newProperties, cartData: addData }
      }));

      return addData;
    } catch (error) {
      throw error;
    } finally {
      const cartItem = document.querySelector(`[data-line-id="${currentLineId}"]`)?.closest('.cart-item');
      const itemLoader = cartItem.querySelector('.itemLoader');
      if (itemLoader) itemLoader.classList.remove('is-visible');
    }
  }

  async updateItemQuantity(event, target) {
    event.preventDefault();

    const cartItem = target.closest(".cart-item");
    const itemLoader = cartItem?.querySelector(".itemLoader");
    if (itemLoader) itemLoader.classList.add("is-visible");

    let quantity;
    if (target.tagName === "INPUT") {
      quantity = Math.max(parseInt(target.value, 10) || 0, 0);
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"), 10);
    }

    const lineId = target.getAttribute("data-line-id");
    const payload = { id: lineId, quantity };

    try {
      // 🧩 Debounce quick clicks (wait 150ms before sending)
      if (this._quantityTimeout) clearTimeout(this._quantityTimeout);
      await new Promise((resolve) => {
        this._quantityTimeout = setTimeout(resolve, 150);
      });

      const response = await fetch(`${window.routes.localeRootUrl}/cart/change.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(payload),
      });

      // ⚙️ Handle harmless errors gracefully
      if (!response.ok) {
        if (itemLoader) itemLoader.classList.remove("is-visible");
        // Re-render cart to sync
        await this.renderCart(false, false);
        return;
      }

      const data = await response.json();

      if (data.item_count == 0) {
        this.loader.classList.add("is-visible");
        this.renderCart(false, false);
      } else if (quantity == 0) {
        const nextItem = cartItem.nextElementSibling;
        setTimeout(() => {
          cartItem.remove();
          if (nextItem) {
            nextItem.classList.add("repo--top");
            setTimeout(() => nextItem.classList.remove("repo--top"), 350);
          }
        }, 350);
        if (data.item_count > 0 && this.options.showRecommendations) {
          this.options["productId"] = data.items[0].product_id;
          this.renderCart(false, false, false, null, true);
          return;
        }
      } else {
        this.renderCart(target.getAttribute("data-id"), true);
      }
    } catch (error) {
    } finally {
      if (itemLoader) itemLoader.classList.remove("is-visible");
    }
  }




  onProductAdded(event) {
    let details = false;
    if (event.detail) {
      details = event.detail;
    }

    if (window.theme.cartCount == 0 && this.isOpen == true) {
      this.loader.classList.add("is-visible");
    }

    this.renderCart(false, false, true, details).then(async () => {
      if (this.options.showRecommendations && this.options.itemCount > 0) {
        await this.loadRecommendations();
      }

      if (this.element.hasAttribute('data-open-drawer')) {
        if (this.isOpen == false) {

          this.drawer.openDrawer();
        }
      }
    });
    const headerCount = document.querySelector('.header__cart-count');
    if (headerCount) headerCount.textContent = window.theme.cartCount;
  }

  renderCart(lineNumber, quantityChange, productAdd, productAddEvent, updateCount) {
    this.pageLoader.style.width = 90 + "%";
    var _this = this;
    return fetch(
      window.routes.localeRootUrl + "/?section_id=main-cart_drawer",
      {
        credentials: "same-origin",
        method: "GET",
      }
    ).then(function (content) {
      return content.text().then(function (html) {
        _this.replaceContent(
          html,
          lineNumber,
          quantityChange,
          productAdd,
          productAddEvent,
          updateCount
        );

      });
    });
  }

  replaceContent(
    html,
    lineNumber,
    quantityChange,
    productAdd,
    productAddEvent,
    updateCount
  ) {

    // Prepare the page loader animation
    this.pageLoader.style.width = "100%";
    setTimeout(() => {
      this.pageLoader.style.left = "unset";
      this.pageLoader.style.right = "0px";
      this.pageLoader.style.width = "0%";

      setTimeout(() => {
        this.pageLoader.style.left = "0px";
        this.pageLoader.style.right = "unset";
      }, 550);


    }, 100)


    // Create a temporary element to parse the new HTML content
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    // Extract options and update cart count
    const newOptions = JSON.parse(
      tempElement.querySelector("#cart-drawer").getAttribute("data-settings")
    );
    this.options = newOptions;

    // In your replaceContent method, update this section:

    if (tempElement.querySelector("[data-ids]")) {
      this.cartIds = tempElement
        .querySelector("[data-ids]")
        .dataset.ids.split(",")
        .filter((item) => item !== "");
      if (updateCount) {
        this.cartIds = this.cartIds.filter((item) => item !== this.removeId);
        this.removeid = null;
      }
    } else {
      // Fixed: Initialize as empty array when no items in cart
      this.cartIds = [];
    }

    const itemCount = parseInt(newOptions.itemCount || 0);
    window.theme.cartCount = itemCount;

    const wasEmptyBeforeUpdate = stateWasEmpty;
    const isFullAfterUpdate = itemCount > 0;
    const transitioningEmptyState = wasEmptyBeforeUpdate !== isFullAfterUpdate;

    if (updateCount) {
      this.updateCartFooter(tempElement);
      this.updateHeaderCartCount();
      if (this.options.itemCount > 0 && this.options.showRecommendations) {
        this.loadRecommendations();
      }
      return;
    }
    if (lineNumber && tempElement.querySelector(`#${lineNumber}`)) {
      this.updateCartItem(lineNumber, tempElement);
    } else if (productAdd && stateWasEmpty == false && lineNumber) {
      this.addContent(tempElement, productAddEvent);
    } else {
      // Avoid swapping the entire wrapper (causes 3rd-party injected DOM to blink/remount).
      // Only do a full swap when cart transitions between empty/non-empty layouts.
      if (transitioningEmptyState) {
        this.replaceCartContent(tempElement);
      } else {
        this.replaceCartInnerContent(tempElement);
      }
    }


    this.updateCartFooter(tempElement);
    this.updateHeaderCartCount();

    this.ensureUspPlacement();
    this.syncDiscountyMirror();

    // Some injected cart apps (e.g. Discounty) listen to our "cart:render" event and
    // may fully remount their UI, causing visible flicker. When their portal is present
    // and we only performed a partial update, emit a softer event instead.
    const hasDiscountyPortal = !!this.element.querySelector(
      '.discounty-portal, [data-fragment-id].discounty-portal'
    );
    if (hasDiscountyPortal && !transitioningEmptyState) {
      this.element.dispatchEvent(
        new CustomEvent("cart:render:partial", { bubbles: true })
      );
    } else {
      this.element.dispatchEvent(
        new CustomEvent("cart:render", { bubbles: true })
      );
    }

    const transitioningToFull = wasEmptyBeforeUpdate && isFullAfterUpdate;

    if (itemCount == 0) {
      stateWasEmpty = true;
    } else {
      stateWasEmpty = false;
    }

    setTimeout(() => {
      if (
        this.options.showRecommendations &&
        !quantityChange &&
        this.isOpen == true &&
        !transitioningToFull
      ) {
        this.loadRecommendations();
      }

      if (this.element.hasAttribute('data-open-drawer')) {
        this.focusElement = this.element.querySelector("[data-scrollable]");
        if (this.focusElement) {
          bodyScrollLock.disableBodyScroll(this.focusElement, bodyScrollLockOptions);
        }
      }

      this.syncDiscountyMirror();


    }, 200);
  }

  replaceCartInnerContent(tempElement) {
    const wrapper = this.element.querySelector(".cart-drawer__wrapper");
    if (!wrapper) {
      this.replaceCartContent(tempElement);
      return;
    }

    // Preserve scroll position within the drawer.
    const currentScrollPosition = wrapper.scrollTop;

    // Prefer swapping the form if present (it typically contains items + inputs).
    // Note: in our markup it's an id, not a class.
    const newForm = tempElement.querySelector("#cart-drawer__form");
    const oldForm = this.element.querySelector("#cart-drawer__form");
    if (newForm && oldForm && oldForm.parentNode) {
      oldForm.parentNode.replaceChild(newForm, oldForm);
      this.element.querySelector(".cart-drawer__wrapper").scrollTop = currentScrollPosition;
      return;
    }

    // Fallback: swap just the items list.
    const newItems = tempElement.querySelector(".cart-drawer__items");
    const oldItems = this.element.querySelector(".cart-drawer__items");
    if (newItems && oldItems && oldItems.parentNode) {
      oldItems.parentNode.replaceChild(newItems, oldItems);
      this.element.querySelector(".cart-drawer__wrapper").scrollTop = currentScrollPosition;
      return;
    }

    // As a last resort, fall back to the full wrapper replacement.
    this.replaceCartContent(tempElement);
  }

  updateCartItem(lineNumber, tempElement) {
    const cartItemParent = this.element.querySelector(`#${lineNumber}`);
    const newCartItemInfo = tempElement.querySelector(
      `#${lineNumber} .cart-item__info `
    );
    const oldCartItemInfo = cartItemParent.querySelector(`#${lineNumber} .cart-item__info`);



    if (!cartItemParent) {
      this.element
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    } else {
      cartItemParent
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    }

    if (newCartItemInfo) {
      cartItemParent.querySelector('.cart-item__inner').replaceChild(
        newCartItemInfo,
        oldCartItemInfo
      );
    } else if (cartItemParent) {
      this.removeCartItem(cartItemParent);
    }
  }

  addContent(tempElement, productAddEvent) {
    if (this.isOpen) {
      this.element.querySelector(".cart-drawer__wrapper").scrollTop = 0;

    }
    const itemToAdd = tempElement.querySelector(
      `#cart-item__${productAddEvent.variant}`
    );
    const cartWrapper = this.element.querySelector(".cart-drawer__items");
    const firstItem = cartWrapper.firstElementChild;
    if (cartWrapper.querySelector(`#cart-item__${productAddEvent.variant}`)) {
      this.updateCartItem(`cart-item__${productAddEvent.variant}`, tempElement);
    } else {
      const height = this.calculateDetachedElement(itemToAdd);
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );
      firstItem.classList.add("repo--bottom");
      this.loader.classList.remove("is-visible");
      setTimeout(() => {
        cartWrapper.prepend(itemToAdd);
        itemToAdd.classList.add("repo--adding");
        firstItem.classList.remove("repo--bottom");


        setTimeout(() => {
          itemToAdd.classList.remove("repo--adding");
        }, 350);
      }, 350);
    }
  }

  calculateDetachedElement(element) {
    // 1. Create a detached container
    const detachedContainer = document.createElement("div");
    detachedContainer.style.position = "absolute";
    detachedContainer.style.visibility = "hidden";
    detachedContainer.style.height = "auto";
    detachedContainer.style.width = "auto";
    detachedContainer.style.top = "-9999px"; // Off-screen positioning

    // 2. Append the new item to the detached container
    detachedContainer.appendChild(element);

    // 3. Append the detached container to the body (but off-screen)
    this.element.appendChild(detachedContainer);

    // 4. Get the offset height of the new item
    const newItemHeight = element.offsetHeight + 16;

    // 5. Remove the detached container from the DOM
    this.element.removeChild(detachedContainer);

    // Now you have the height of the new item without it ever being visible
    return newItemHeight;
  }

  updateCartFooter(tempElement) {
    const itemCount = this.options.itemCount;
    if (itemCount > 0) {

      const footerParent = document.querySelector(".cart-drawer__footer");

      const newFooterTotals = tempElement.querySelector(
        ".cart_drawer__footer-totals"
      );
      const oldFooterTotals = document.querySelector(".cart_drawer__footer-totals");

      if (!footerParent || !newFooterTotals) return;
      // If a 3rd-party app injected a portal into the totals container, do NOT replace
      // the entire totals node. Replacing it will destroy/remount the injected UI and
      // can cause visible flicker.
      const hasDiscountyPortal = !!oldFooterTotals?.querySelector(
        '.discounty-portal, [data-fragment-id].discounty-portal'
      );
      // Preserve app-injected nodes (e.g. Discounty) to avoid remounts.
      // Note: this is a localized swap of `.cart_drawer__footer-totals`; we keep this logic
      // simple and avoid adding extra wrapper-level DOM nodes that could affect layout.
      let preservedDiscountyNodes = [];
      if (oldFooterTotals) {
        preservedDiscountyNodes = Array.from(
          oldFooterTotals.querySelectorAll('.discounty-portal, [data-fragment-id].discounty-portal')
        );
        preservedDiscountyNodes.forEach((node) => {
          try {
            node.remove();
          } catch { }
        });
      }

      if (preservedDiscountyNodes.length) {
        const alreadyHas = newFooterTotals.querySelector(
          '.discounty-portal, [data-fragment-id].discounty-portal'
        );
        if (!alreadyHas) {
          preservedDiscountyNodes.forEach((node) => newFooterTotals.appendChild(node));
        }
      }

      if (!hasDiscountyPortal) {
        if (oldFooterTotals) {
          footerParent.replaceChild(
            newFooterTotals,
            oldFooterTotals
          );
        } else {
          footerParent.prepend(newFooterTotals);
        }
      } else {
        // Re-attach preserved nodes into the existing totals container immediately.
        preservedDiscountyNodes.forEach((node) => {
          try {
            oldFooterTotals.appendChild(node);
          } catch { }
        });
      }

      const newShippingBar = tempElement.querySelector(
        ".cart-drawer__shipping-progress-bar"
      );
      if (newShippingBar) {
        const currentShippingBar = document.querySelector(
          ".cart-drawer__shipping-progress-bar"
        );
        if (currentShippingBar) {
          let percent = newShippingBar.dataset.percent;
          if (percent > 100) {
            percent = 100;
          }
          currentShippingBar.dataset.percent = percent;
          currentShippingBar.style.width = `${percent}%`;
          if (percent == 100) {
            currentShippingBar.classList.add("done");
            currentShippingBar.classList.remove("active");
          } else {
            currentShippingBar.classList.remove("done");
            currentShippingBar.classList.add("active");
          }
          this.element.querySelector(".cart-drawer__shipping-text").innerHTML =
            tempElement.querySelector(".cart-drawer__shipping-text").innerHTML;
        } else {
          const headerParent = this.element.querySelector(
            ".cart-drawer__header"
          );
          headerParent.appendChild(
            tempElement.querySelector(".cart-drawer__shipping")
          );
        }
      }

    } else {
      this.clearCartFooter(tempElement);
      stateWasEmpty = true;
    }

    this.updateCartDrawerHeights();

    // 🧩 Update total price dynamically
    const newTotal = tempElement.querySelector('.cd__subtotal-final');
    const oldTotal = this.element.querySelector('.cd__subtotal-final');
    if (newTotal && oldTotal) {
      oldTotal.innerHTML = newTotal.innerHTML;
    }
  }

  updateHeaderCartCount() {
    const itemCount = this.options.itemCount;
    const headerCount = document.querySelector('.header-cart__item-count');
    headerCount.innerHTML = itemCount;
    if (itemCount > 0) headerCount.style.display = '';
    else headerCount.style.display = 'none';
  }

  clearCartFooter(tempElement) {
    if (!tempElement.querySelector(".cart-drawer__wrapper")) return;
    if (document.querySelector(".cart-drawer__footer")) {
      document
        .querySelector(".cart-drawer__footer")
        .classList.add("removing");
    }

    const wrapperParent = this.element.querySelector(".cart-drawer__wrapper");
    if (wrapperParent) {
      wrapperParent.innerHTML = tempElement.querySelector(
        ".cart-drawer__wrapper"
      ).innerHTML;
    }
  }

  replaceCartContent(tempElement) {

    const cartWrapperParent = this.element.querySelector(
      ".cart-drawer__wrapper"
    ).parentNode;
    const currentScrollPosition = this.element.querySelector(
      ".cart-drawer__wrapper"
    ).scrollTop;

    // Preserve app-injected nodes (e.g. Discounty) without adding new top-level children.
    // We create a "parking lot" as a sibling of `.cart-drawer__wrapper`, so drawer layout
    // (which may assume a specific child structure) isn't affected.
    const ensureParkingLot = () => {
      let lot = cartWrapperParent.querySelector("#discounty-portal-parking");
      if (!lot) {
        lot = document.createElement("div");
        lot.id = "discounty-portal-parking";
        lot.style.display = "contents";
        cartWrapperParent.insertBefore(lot, this.element.querySelector(".cart-drawer__wrapper"));
      }
      return lot;
    };
    const parkingLot = ensureParkingLot();
    const currentWrapper = this.element.querySelector(".cart-drawer__wrapper");
    let preservedInjectedNodes = [];
    if (currentWrapper) {
      preservedInjectedNodes = Array.from(
        currentWrapper.querySelectorAll('.discounty-portal, [data-fragment-id].discounty-portal')
      );
      preservedInjectedNodes.forEach((node) => {
        try {
          parkingLot.appendChild(node); // move, don't remove
        } catch { }
      });
    }

    cartWrapperParent.replaceChild(
      tempElement.querySelector(".cart-drawer__wrapper"),
      this.element.querySelector(".cart-drawer__wrapper")
    );

    // Re-attach preserved nodes into the new wrapper, preferring the totals area if present.
    if (preservedInjectedNodes.length) {
      const newWrapper = this.element.querySelector(".cart-drawer__wrapper");
      const target =
        newWrapper?.querySelector(".cart_drawer__footer-totals") ||
        newWrapper?.querySelector(".cart-drawer__footer") ||
        newWrapper;
      if (target) {
        const alreadyHas = target.querySelector?.('.discounty-portal, [data-fragment-id].discounty-portal');
        if (!alreadyHas) {
          preservedInjectedNodes.forEach((node) => target.appendChild(node));
        }
      }
    }

    setTimeout(() => {
      this.loader.classList.remove("is-visible");
    }, 200);
    this.element.querySelector(".cart-drawer__wrapper").scrollTop =
      currentScrollPosition;

    setTimeout(() => {
      this.updateCartDrawerHeights();
    }, 100);
  }

  async loadRecommendations() {
    const container = this.element.querySelector(".cart-drawer__recommendations");
    if (!container) {
      return;
    }

    // Abort any in-flight recommendation fetch to avoid concurrent DOM thrashing
    if (this._recAbortController) {
      this._recAbortController.abort();
    }
    this._recAbortController = new AbortController();
    const signal = this._recAbortController.signal;

    this.recommendationLoading = true;

    const baseUrl = window.routes.localeRootUrl;
    const productId = this.options["productId"];
    const hasItems = this.options["itemCount"] > 0;
    const enabled = container.dataset.enabled === "true";
    const collection = container.dataset.collection;
    const limit = this.element.getAttribute("product-limit") || 4;
    let url = null;


    // 🛒 CART EMPTY
    if (!hasItems) {
      if (enabled && collection && collection !== "blank") {
        url = `${baseUrl}?section_id=helper-recommendations&collection=${collection}`;

      } else {
        container.innerHTML = "";
        this.recommendationLoading = false;
        return;
      }
    }

    // 📦 CART HAS ITEMS
    else {
      if (productId) {
        url = `${baseUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&limit=${limit}`;

      } else {
        this.recommendationLoading = false;
        return;
      }
    }


    try {
      const response = await fetch(url, { signal });
      const html = await response.text();
      const temp = document.createElement("div");
      temp.innerHTML = html;

      const upsell = temp.querySelector(".cart-drawer__upsell");
      // 🧠 Intent-aware validation before rendering
      const slides = upsell ? upsell.querySelectorAll('.swiper-slide').length : 0;
      const intent = this.options.intent;

      // 🚫 Hide if no products match for complementary or related
      if ((intent === 'complementary' || intent === 'related') && slides === 0) {
        container.innerHTML = '';
        container.style.display = 'none';
        this.recommendationLoading = false;
        return;
      }

      // ✅ Proceed to render only when valid slides exist
      if (upsell && slides > 0) {
        container.innerHTML = upsell.innerHTML;
        container.style.display = '';
        requestAnimationFrame(() => {
          new RevolutionAnimation(container);
        });
      } else {
        container.innerHTML = "";
        container.style.display = 'none';
      }


    } catch (err) {
      if (err.name === 'AbortError') return; // Superseded by a newer call
    } finally {
      this.recommendationLoading = false;
    }
  }
}
customElements.define("cart-drawer", CartDrawer);



class MainCart extends HTMLElement {
  connectedCallback() {
    const container = this.querySelector(".cart-drawer__recommendations");
    if (!container) return;

    const productId = this.dataset.productId;
    const collection = container.dataset.collection;
    const limit = this.dataset.limit || 4;
    const baseUrl = window.routes?.localeRootUrl || "";

    let url = "";

    if (!productId) {
      url = `${baseUrl}?section_id=helper-recommendations-main-cart&collection=${collection}`;
    } else {
      url = `${baseUrl}/recommendations/products?section_id=helper-recommendations-main-cart&product_id=${productId}&limit=${limit}`;
    }


    fetch(url)
      .then(r => r.text())
      .then(html => {
        const temp = document.createElement("div");
        temp.innerHTML = html;
        const upsell = temp.querySelector(".cart-drawer__upsell");

        if (upsell) {
          container.innerHTML = upsell.outerHTML;
          new AddToCart(this);
          new RevolutionAnimation(container);

          // ✅ Run Swiper AFTER DOM updates
          // ✅ Force re-upgrade all <swiper-init> elements inside the container
          setTimeout(() => {
            const swipers = container.querySelectorAll("swiper-init");
            swipers.forEach(swiperEl => {
              if (typeof swiperEl.connectedCallback === "function") {
                swiperEl.connectedCallback();
              }
            });

            if (window.SwiperInit) {
              window.SwiperInit(container);
            }
          }, 500);



        } else {
          container.style.display = "none";
        }
      })
      .catch(() => {});
  }
}

customElements.define("main-cart", MainCart);

class CarouselTest extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    this.element = this;
    this.domDelegate = new Delegate(this.element);

    this.bindEvents();

    new AddToCart(this.element);
  }

  bindEvents() {

  }


}
customElements.define("carousel-test", CarouselTest);

class CollectionShowcase extends HTMLElement {
  connectedCallback() {
    this.updateOnlyButtonState();
    this.bindSwiperPaginationPosition();
    this._currentBp = responsive.getCurrentBreakpoint();
    responsive.addResizeListener(this, this.handleResize.bind(this));


    const isControls = (t) =>
      !!t.closest(".vjs-control-bar, .vjs-control, .vjs-big-play-button, .vjs-menu, .vjs-slider");

    const isVideoArea = (t) => !!t.closest(".video-js");

    this.addEventListener(
      "pointerdown",
      (e) => {
        if (!isVideoArea(e.target) || isControls(e.target)) return;
        e.stopPropagation();
        e.stopImmediatePropagation();
      },
      true
    );

    this.addEventListener(
      "click",
      (e) => {
        if (isControls(e.target)) {
          const a = e.target.closest("a");
          if (!a) return;
          const href = a.getAttribute("href");
          if (!href) return;
          e.preventDefault();
          a.dataset.__cs_href__ = href;
          a.removeAttribute("href");
          requestAnimationFrame(() => {
            a.setAttribute("href", href);
            delete a.dataset.__cs_href__;
          });
          return;
        }

        if (!isVideoArea(e.target)) return;

        const a = e.target.closest("a");
        if (!a) return;
        const href = a.getAttribute("href");
        if (!href) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        window.location.assign(href);
      },
      true
    );



  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.boundResize);


  }

  updateOnlyButtonState() {
    this.querySelectorAll(".collection-showcase--text .group-text-button__block-wrapper")
      .forEach((wrapper) => {
        const buttons = wrapper.querySelectorAll("a.Button, button.Button");

        if (buttons.length !== 1) {
          wrapper.classList.remove("is-only-button");
          return;
        }

        const meaningful = Array.from(wrapper.childNodes).some((node) => {
          if (node.nodeType === Node.TEXT_NODE) return node.textContent.trim().length > 0;
          if (node.nodeType !== Node.ELEMENT_NODE) return false;

          const el = node;
          if (el.matches("a.Button, button.Button")) return false;
          if (el.matches("a") && el.textContent.trim() === "" && el.children.length === 0) return false;
          return true;
        });

        wrapper.classList.toggle("is-only-button", !meaningful);
      });
  }
  positionPagination() {
    const container = this.querySelector(".swiper");
    const pag = this.querySelector(".swiper-pagination");
    const slide = this.querySelector(".swiper-slide-active");
    if (!container || !pag || !slide) return;

    const media =
      slide.querySelector(".collection-showcase--media-wrapper") ||
      slide.querySelector(".AspectRatio") ||
      slide;

    const cb = container.getBoundingClientRect();
    const mb = media.getBoundingClientRect();

    const offset = 20;
    pag.style.bottom = Math.max(0, cb.height - ((mb.bottom - cb.top) - offset)) + "px";
  }

  bindSwiperPaginationPosition() {
    if (this.__bound) return;
    this.__bound = true;

    const swiperInit = this.querySelector("swiper-init");
    if (!swiperInit) return;

    const run = () => requestAnimationFrame(() => this.positionPagination());

    run();
    setTimeout(run, 120);
    setTimeout(run, 300);

    swiperInit.addEventListener("swiper:initialized", () => {
      const inst = swiperInit.getSwiper?.();
      const swiper = inst?.swiperElement || inst;

      run();
      swiper?.on?.("slideChangeTransitionEnd", run);
      swiper?.on?.("resize", run);
    });

    swiperInit.addEventListener("swiper:slide-changed", run);

    responsive.addResizeListener(this, run);

    window.addEventListener("shopify:section:load", run);
    window.addEventListener("shopify:section:select", run);
  }

  handleResize() {
    const next = responsive.getCurrentBreakpoint();
    const prev = this._currentBp;

    if (next === prev) return;
    this._currentBp = next;

    document.dispatchEvent(
      new CustomEvent("breakpoint:changed", {
        detail: {
          previousBreakpoint: prev,
          currentBreakpoint: next,
        },
      })
    );
    requestAnimationFrame(() => this.positionPagination());
  }

}

customElements.define("collection-showcase", CollectionShowcase);




class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);


  }
}
customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.previousRealIndex = 0;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.swiperElement = this.querySelector('swiper-init');

    if (this.options.numberOfSlides > 1) {
      this.swiperElement.addEventListener('swiper:initialized', () => {
        this.carousel = this.swiperElement.getSwiper();
        this.fixPagination();
      });

      responsive.addResizeListener(this, this.onResize.bind(this));

      this.onImagesReady = this.createObserver.bind(this);
      this.swiperElement.addEventListener("swiper:slide-changed", this.onImagesReady);

      this.createObserver();
    } else {
      this.createObserver();
    }

    this.bindEvents();
  }

  bindEvents() {
    let hasSlideChanged = false;
    this.swiperElement?.addEventListener('swiper:initialized', () => {
      this.carousel?.swiperElement?.on("slideChange", function () {
        if (!hasSlideChanged) {
          // Add class after first slide change
          const pagination = document.querySelector('.media-slideshow__pagination--autoplay');
          if (pagination) {
            pagination.classList.add('slideshow-started');
          }
          hasSlideChanged = true;
        }
      });
    });
  }

  onResize() {
    const newBreakpoint = responsive.getCurrentBreakpoint();

    if (this.currentBreakpoint !== newBreakpoint) {
      this.currentBreakpoint = newBreakpoint;

      if (this.options.numberOfSlides > 1) {
        this.changeImageQuality();

        setTimeout(() => {
          this.fixPagination();
        }, 100);
      }
    }
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), { 
      threshold: 0,
      rootMargin: "200px 0px 200px 0px"
    });
    this.observer.observe(this.element);
    
    // Check if already visible on page load
    const rect = this.element.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
    if (isVisible) {
      if (this.options["numberOfSlides"] > 1) {
        this.changeImageQuality();
      } else {
        this.changeImageQuality(true);
      }
    }
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio >= 0 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }

  changeImageQuality(singleItem) {
    const breakpoint = responsive.getCurrentBreakpoint();

    let imageContainers;
    if (singleItem) {
      imageContainers =
        Array.from(this.element.querySelectorAll(".image__element")).slice(0, 2);

    } else {
      if (!this.carousel || !this.carousel.swiperElement) return;
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];

      imageContainers = Array.from(
        cellElement.querySelectorAll(".image__element")).slice(0, 2);
    }

    if (imageContainers.length === 0) {
      return;
    }

    let imageToReveal;
    if (
      breakpoint === "pocket" ||
      breakpoint === "phone" ||
      breakpoint === "tablet"
    ) {
      imageToReveal = imageContainers[0];
    } else {
      if (imageContainers.length == 2) {
        imageToReveal = imageContainers[1];
      } else {
        imageToReveal = imageContainers[0];
      }
    }


    if (!imageToReveal || imageToReveal.dataset.loadedImage === "true") {
      return;
    }

    if (imageToReveal.dataset.src) {
      const replaceUrl = imageToReveal.dataset.src.replace(
        "{width}x",
        "width=2600"
      );
      imageToReveal.src = replaceUrl;
      imageToReveal.dataset.loadedImage = "true";
    }
  }

  fixPagination() {
    const paginationEl = this.element.querySelector(".media-slideshow__pagination");

    if (!paginationEl) {
      return;
    }

    if (this.carousel && this.carousel.swiperElement) {
      this.carousel.swiperElement.pagination.render();
      this.carousel.swiperElement.pagination.update();
    }

    paginationEl.style.display = "flex";
    paginationEl.style.opacity = "1";
  }
}
customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.scrollableElement = this.element.querySelector("[data-scrollable]");
    this.headerTransparent = false;
    this._isClosing = false;
    this.wasTransparentBeforeDrawer = false;
    this.drawerBlocksTransparency = false;

    if (this.options.sticky) {
      this.toggleSticky();
    }

    // Batch reads
    const headerHeight = this.element.offsetHeight;
    const clientHeight = this.element.clientHeight;

    // Batch writes
    const style = document.documentElement.style;
    style.setProperty("--header-height-fixed", `${headerHeight}px`);
    style.setProperty("--header-height", `${clientHeight}px`);
    const menuItems = this.element.querySelector(".header-menu-items");
    if (menuItems) menuItems.style.opacity = 1;

    this.updateVisibleHeight();
    window.onload = () => setTimeout(() => this.updateVisibleHeight(), 500);
    this.bindEvents();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty(
      "--header-height",
      this.element.clientHeight + "px"
    );
    const menuItems = this.element.querySelector(".header-menu-items");
    if (menuItems) menuItems.style.opacity = 1;
  }

  toggleSticky() {
    this.element.parentElement.classList.add("header--Sticky");
  }

  bindEvents() {
    const _this = this;

    document.addEventListener("shopify:section:load", function () {
      _this.setHeaderHeight();
    });

    this.toggleColorListener = this.toggleColor.bind(this);
    this.toggleTopBarListener = this.toggleTopBar.bind(this);

    if (this.options.transparent || this.options.sticky) {
      scrollListener.addScrollListener(this, this.toggleColorListener);
    }

    // toggleColor is already registered via scrollListener above (rAF-throttled).
    // Route toggleTopBar through the same global scroll system.
    scrollListener.addScrollListener(this, this.toggleTopBarListener);

    // Run once on init so the header state is correct if the browser
    // restored a scroll position after refresh (no scroll event fires).
    this.toggleColor();

    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);

    this.delegateBody.on("mobile-menu:open", this.handleHamburgerMenu.bind(this));
    this.delegateBody.on("mobile-menu:close", this.handleHamburgerMenu.bind(this));

    // Listen for drawer/popup events
    this.delegateBody.on("drawer:opened", this.onDrawerOpened.bind(this), true);
    this.delegateBody.on("drawer:closed", this.onDrawerClosed.bind(this), true);

    this.delegateElement.on(
      "mouseenter",
      "[aria-haspopup='true']",
      this.openMenu.bind(this),
      true
    );
    this.delegateElement.on(
      "focusin",
      "[aria-haspopup='true']",
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseleave",
      "[aria-haspopup='true']",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseenter",
      "[data-single-menu]",
      (e, target) => {
        const openElement =
          this.element.querySelector('.header-menu-items [aria-expanded="true"]') ||
          this.element.querySelector('[aria-haspopup="true"][aria-expanded="true"]');

        if (openElement && openElement !== target) {
          if (this._menuCloseTimer) {
            clearTimeout(this._menuCloseTimer);
            this._menuCloseTimer = null;
          }
          this.closeSiblingMenu(openElement, false);
          this.hideOverlay();
          this.toggleColor();
          bodyScrollLock.enableBodyScroll(this.scrollableElement);
        }
      },
      true
    );

    this.delegateElement.on(
      "focusin",
      "[data-single-menu]",
      (e, target) => {
        const openElement =
          this.element.querySelector('.header-menu-items [aria-expanded="true"]') ||
          this.element.querySelector('[aria-haspopup="true"][aria-expanded="true"]');

        if (openElement && openElement !== target) {
          if (this._menuCloseTimer) {
            clearTimeout(this._menuCloseTimer);
            this._menuCloseTimer = null;
          }
          this.closeSiblingMenu(openElement, false);
          this.hideOverlay();
          this.toggleColor();
          bodyScrollLock.enableBodyScroll(this.scrollableElement);
        }
      },
      true
    );

    this.delegateElement.on(
      "mouseenter",
      ".desktop-menu__dropdown-wrapper, [aria-submenu], .header-row-desktop",
      () => clearTimeout(this._menuCloseTimer),
      true
    );

    this.delegateElement.on(
      "mouseleave",
      ".desktop-menu__dropdown-wrapper, [aria-submenu], .header-row-desktop",
      (e, submenuEl) => {
        const to = e.relatedTarget;
        if (to && (submenuEl.contains(to) || to.closest('[aria-haspopup="true"]'))) return;
        this.closeMenu(e, submenuEl);
      },
      true
    );

    scrollListener.addScrollListener(this, this.updateVisibleHeight.bind(this));
    responsive.addResizeListener(this, this.updateVisibleHeight.bind(this));

    this.onDocClick = (e) => {
      const toggle = e.target.closest('[data-action="toggle-drawer"]');
      if (toggle) return;

      const logoClick = e.target.closest('.header-logo-wrapper');
      if (logoClick) return;

      const selectorClick = e.target.closest('.language-selector__item, .country-selector__item');
      if (selectorClick) return;

      const drawerEl = document.querySelector('.Drawer--wrapper');
      const overlayEl = document.querySelector(".pageOverlay");

      const drawerOpen = drawerEl?.getAttribute("aria-expanded") === "true";
      if (!drawerOpen) return;

      const clickedInsideDrawer = drawerEl.contains(e.target);
      const clickedOverlay = overlayEl?.contains(e.target);

      if ((clickedOverlay || !clickedInsideDrawer) && !e.target.closest('.header--Wrapper')) {
        e.preventDefault();
        this.forceCloseMenu();
        this.hideOverlay();
      }
    };

    document.addEventListener("click", this.onDocClick);

    this.onKeyDown = (e) => {
      if (e.key === "Escape") this.forceCloseMenu();
    };
    document.addEventListener("keydown", this.onKeyDown);

    /*  this.initSearch(); */

  }

  updateVisibleHeight() {
    setTimeout(() => {
      // Batch reads
      const rect = this.element.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const headerHeight = this.element.offsetHeight;

      let visibleHeight =
        Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
      visibleHeight = Math.max(visibleHeight, 0);

      // Batch writes
      const style = document.documentElement.style;
      style.setProperty("--header-dynamic-height", `${visibleHeight}px`);
      style.setProperty("--header-height-fixed", `${headerHeight}px`);
    }, 550);
  }

  toggleTopBar() {
    if (this.options.sticky) return;

    let current = window.scrollY;
    let annBar = document.querySelector(".announcement-bar");
    let annHeight = annBar ? annBar.offsetHeight : 0;
    let element_height = this.element.offsetHeight;

    // Add fixed top bar class if scrolled far enough
    if ((element_height + annHeight) * 2 < current) {
      this.element.parentElement.classList.add("header--fixed-top-bar");
    }

    // Remove fixed class if near the top
    if (current <= annHeight) {
      this.element.parentElement.classList.remove("header--fixed-top-bar");
    }

    // Hide header on scroll down
    if (
      this.prevOffset < current &&
      current >= annHeight + element_height
    ) {
      this.element.parentElement.classList.add("header--hide");
      document.documentElement.style.setProperty("--header-dynamic-height", `0px`);
    } else {
      this.element.parentElement.classList.remove("header--hide");
      this.updateVisibleHeight();
    }

    this.prevOffset = current;
  }

  updateMenuPosition() {
    document.documentElement.style.setProperty(
      "--submenu-position",
      `${this.element.offsetHeight}px`
    );
  }

  showOverlay() {
    const overlay = document.querySelector(".pageOverlay");
    if (!overlay) return;

    overlay.classList.add("is-visible");
  }

  hideOverlay() {

    const overlay = document.querySelector(".pageOverlay");
    if (!overlay) return;

    overlay.classList.remove("is-visible");
  }


  async openMenu(event, target) {
    clearTimeout(this._menuCloseTimer);
    this._menuCloseTimer = null;

    if (this._isClosing || target.getAttribute("aria-expanded") === "true") {
      return;
    }

    this.showOverlay();

    this.element.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));
    this.updateMenuPosition(target);

    if (this.element.classList.contains("Header--Transparent")) {
      this.element.classList.remove("Header--Transparent");
      this.headerTransparent = true;
    }

    const siblings = Array.from(target.parentElement.children).filter(
      (child) => child !== target && child.getAttribute("aria-expanded") === "true"
    );

    this._isClosing = true;
    await Promise.all(siblings.map(s => this.closeSiblingMenu(s, true)));
    this._isClosing = false;

    if (this._menuCloseTimer) return;

    const wrapper = target.querySelector(".desktop-menu__dropdown-wrapper");
    if (wrapper) {
      // Remove display:none style if it exists
      wrapper.style.display = '';
      wrapper.classList.remove("slide-in", "fade-in", "slide-out", "fade-out");
    }

    target.setAttribute("aria-hidden", "false");
    target.setAttribute("aria-expanded", "true");

    if (wrapper && siblings.length === 0) {
      wrapper.classList.add("slide-in");
    }

    bodyScrollLock.disableBodyScroll(this.scrollableElement, bodyScrollLockOptions);
  }

  closeMenu(event, target) {
    if (event && event.type === "mouseleave") {
      const to = event.relatedTarget;

      if (to && (
        target.contains(to) ||
        to.closest('.desktop-menu__dropdown-wrapper, [aria-submenu], .header-row-desktop')
      )) {
        return;
      }
    }

    if (this._menuCloseTimer) {
      clearTimeout(this._menuCloseTimer);
    }

    // Use a shorter delay for better UX, then use animation events for the actual closing
    this._menuCloseTimer = setTimeout(async () => {
      this._menuCloseTimer = null;

      const openElement =
        this.element.querySelector('.header-menu-items [aria-expanded="true"]') ||
        this.element.querySelector('[aria-haspopup="true"][aria-expanded="true"]');

      if (openElement) {
        await this.closeSiblingMenu(openElement, false);
      }

      // If no menus remain open, hide overlay
      const stillOpen = this.element.querySelector('[aria-haspopup="true"][aria-expanded="true"]');
      if (!stillOpen && !document.querySelector('.search[aria-expanded=true]') && !document.querySelector('.Drawer[aria-expanded=true]')) this.hideOverlay();

      this.toggleColor();
      // Only release scroll lock if a menu was actually open and being closed
      if (openElement) {
        bodyScrollLock.enableBodyScroll(this.scrollableElement);
      }
    }, 250);

  }

  closeSiblingMenu(element, isSwitch = false) {
    return new Promise(resolve => {
      if (!element) return resolve();

      const wrapper = element.querySelector('.desktop-menu__dropdown-wrapper');
      if (!wrapper) return resolve();

      wrapper.classList.remove("slide-out", "fade-out", "slide-in", "fade-in");

      if (isSwitch) {
        element.setAttribute('aria-expanded', 'false');
        element.setAttribute('aria-hidden', 'true');
        resolve();
        return;
      }

      element.setAttribute('aria-expanded', 'false');
      wrapper.classList.add("slide-out");

      // Use animationend event instead of timeout
      const handleAnimationEnd = (e) => {
        if (e.target === wrapper && e.animationName === 'slideOut') {
          wrapper.removeEventListener('animationend', handleAnimationEnd);
          if (element.getAttribute('aria-hidden') !== 'true') {
            element.setAttribute('aria-hidden', 'true');
            wrapper.classList.remove("slide-out");
          }
          resolve();
        }
      };

      wrapper.addEventListener('animationend', handleAnimationEnd);

      // Fallback timeout in case animation doesn't trigger
      setTimeout(() => {
        wrapper.removeEventListener('animationend', handleAnimationEnd);
        if (element.getAttribute('aria-hidden') !== 'true') {
          element.setAttribute('aria-hidden', 'true');
          wrapper.classList.remove("slide-out");
        }
        resolve();
      }, 250);
    });
  }

  forceCloseMenu() {
    if (!this.element) return;

    this.element
      .querySelectorAll('[aria-haspopup="true"][aria-expanded="true"]')
      .forEach(el => {
        el.setAttribute('aria-expanded', 'false');
        el.setAttribute('aria-hidden', 'true');
      });

    if (this.scrollableElement) {
      try { bodyScrollLock.enableBodyScroll(this.scrollableElement); } catch (e) { }
    }

    this.toggleColor();
  }

  toggleColor() {
    if (window.pageYOffset > 25) {
      this.element.classList.add("header--scrolled");
    } else {
      this.element.classList.remove("header--scrolled");
    }

    // Don't add transparency if drawer is blocking it
    if (this.drawerBlocksTransparency) {
      return;
    }

    if (this.options.transparent) {
      if (window.pageYOffset > 25 && this.options.sticky) {
        this.element.classList.remove("Header--Transparent");
      } else {
        this.element.classList.add("Header--Transparent");
      }
    }
  }

  onDrawerOpened(event) {
    // Check if header is currently transparent and store the state
    if (this.element.classList.contains("Header--Transparent")) {
      this.wasTransparentBeforeDrawer = true;
      this.element.classList.remove("Header--Transparent");
    } else {
      this.wasTransparentBeforeDrawer = false;
    }
    // Block toggleColor from restoring transparency while drawer is open
    this.drawerBlocksTransparency = true;
  }

  onDrawerClosed(event) {
    // Unblock transparency
    this.drawerBlocksTransparency = false;
    // Restore transparency if it was transparent before drawer opened
    if (this.wasTransparentBeforeDrawer && this.options.transparent) {
      // Only restore if scroll conditions allow it
      if (window.pageYOffset <= 25 || !this.options.sticky) {
        this.element.classList.add("Header--Transparent");
      }
    }
    this.wasTransparentBeforeDrawer = false;
  }

  // Direct methods for drawer/popup control
  handleDrawerOpening() {
    // Check if header SHOULD be transparent based on current conditions
    const shouldBeTransparent = this.options.transparent &&
      (window.pageYOffset <= 25 || !this.options.sticky);

    if (shouldBeTransparent) {
      // If it should be transparent but isn't, something else removed it
      if (!this.element.classList.contains("Header--Transparent")) {
        this.wasTransparentBeforeDrawer = true;
      } else {
        this.wasTransparentBeforeDrawer = true;
        this.element.classList.remove("Header--Transparent");
      }
    } else {
      this.wasTransparentBeforeDrawer = false;
    }

    // Block transparency while drawer is open
    this.drawerBlocksTransparency = true;
  }

  handleDrawerClosing() {
    // Unblock transparency
    this.drawerBlocksTransparency = false;



    if (this.wasTransparentBeforeDrawer && this.options.transparent) {
      if (window.pageYOffset <= 25 || !this.options.sticky) {
        this.element.classList.add("Header--Transparent");
      }
    }

    this.wasTransparentBeforeDrawer = false;
  }

  handleHamburgerMenu(event) {
    const hamburgerButton = document.querySelector('[data-action="toggle-drawer"]');
    if (hamburgerButton) {
      if (event.type === "mobile-menu:open") {
        hamburgerButton.classList.add("is-active");
      } else if (event.type === "mobile-menu:close") {
        hamburgerButton.classList.remove("is-active");
      }
    }
  }

}
customElements.define("header-component", Header);

class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.mobileMenuDrawer = new Drawer(this.element);
  }

  connectedCallback() {
    this.initialize();
    this.bindEvents();
  }

  initialize() {
    const firstMobileMenuContent = this.element.querySelector(".mobile-menu__link-content");
    const firstMobileMenuButton = this.element.querySelector(".mobile-menu__link-button");

    if (firstMobileMenuButton && firstMobileMenuContent) {
      firstMobileMenuContent.setAttribute("aria-hidden", "false");
      firstMobileMenuContent.setAttribute("aria-expanded", "true");
      firstMobileMenuButton.setAttribute("aria-expanded", "true");
    }
  }

  bindEvents() {
    this.delegateElement.on(
      'click',
      '[data-action="toggle-mobile-content"]',
      this.openMenu.bind(this)
    );
  }

  openMenu(e) {
    const targetButton = e.target;
    const targetId = targetButton.getAttribute("data-id");

    if (!targetId) {
      return;
    }

    const targetContent = this.element.querySelector(`.mobile-menu__link-content[data-id="${targetId}"]`);

    if (!targetContent) {
      return;
    }

    const currentButton = this.element.querySelector('.mobile-menu__link-button[aria-expanded="true"]');
    const currentContent = this.element.querySelector('.mobile-menu__link-content[aria-expanded="true"]');

    // Don't do anything if clicking the same menu item
    if (targetButton === currentButton) {
      return;
    }

    // Update button states immediately
    if (currentButton) {
      currentButton.setAttribute("aria-expanded", "false");
    }
    targetButton.setAttribute("aria-expanded", "true");

    // Handle content transition
    if (currentContent && currentContent !== targetContent) {
      this.transitionContent(currentContent, targetContent);
    } else if (!currentContent) {
      // No current content, just show target
      this.showContent(targetContent);
    }
  }

  transitionContent(currentContent, targetContent) {
    currentContent.setAttribute("aria-expanded", "false");

    const onTransitionEnd = () => {
      currentContent.setAttribute("aria-hidden", "true");
      targetContent.setAttribute("aria-hidden", "false");

      requestAnimationFrame(() => {
        targetContent.setAttribute("aria-expanded", "true");
      });

      // Clean up event listener properly
      currentContent.removeEventListener("transitionend", onTransitionEnd);
    };

    currentContent.addEventListener("transitionend", onTransitionEnd);
  }

  showContent(content) {
    content.setAttribute("aria-hidden", "false");
    requestAnimationFrame(() => {
      content.setAttribute("aria-expanded", "true");
    });
  }

  closeMenu() {
    const currentButton = this.element.querySelector('.mobile-menu__link-button[aria-expanded="true"]');
    const currentContent = this.element.querySelector('.mobile-menu__link-content[aria-expanded="true"]');

    if (currentButton) {
      currentButton.setAttribute("aria-expanded", "false");
    }

    if (currentContent) {
      currentContent.setAttribute("aria-expanded", "false");
      const onTransitionEnd = () => {
        currentContent.setAttribute("aria-hidden", "true");
        currentContent.removeEventListener("transitionend", onTransitionEnd);
      };
      currentContent.addEventListener("transitionend", onTransitionEnd);
    }
  }
}

customElements.define("mobile-menu", MobileMenu);

class Transition {
  constructor() {
    // Skip old overlay-based transition if View Transitions API is supported
    this.hasViewTransitions = CSS.supports("view-transition-name", "root");
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {
      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.hasViewTransitions) return;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (this.hasViewTransitions) return;
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault();

    if (this.pageOverlay) {
      this.pageOverlay.animate(
        [{ opacity: 0, visibility: 'visible' }, { opacity: 1, visibility: 'visible' }],
        { duration: 250, fill: 'forwards', easing: 'linear' }
      ).onfinish = () => {
        window.location.href = target.href;
      };
    }
  }
}
new Transition();


class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.isTextDisabled = this.element.getAttribute("data-text-disable");
    this.sectionId = this.element.getAttribute("data-section-id");
    this.trueObserver = false;
    this.delegateElement = new Delegate(this.element);
    this.videoPlayer = null; // Initialize videoPlayer property
    this.isInitialized = false; // Track if video has been initialized

    const isDesktop = !responsive.matchesBreakpoint("phone") || !responsive.matchesBreakpoint("pocket");
    const position = this.element.dataset.position;

    // Defer video init when an eager poster is present to keep the poster as the LCP element
    const hasPoster = this.element.parentElement?.querySelector('.video-poster-eager')
      || this.element.querySelector('.videoHolder--Placeholder');

    if (hasPoster) {
      // Init video only on user interaction — poster stays as LCP element
      const initVideo = () => {
        if (!this.isInitialized) {
          this.isInitialized = true;
          this._originalInit();
        }
      };
      ['scroll', 'click', 'touchstart', 'keydown', 'mousemove', 'mouseenter', 'pointermove'].forEach(evt => {
        window.addEventListener(evt, initVideo, { once: true, passive: true });
      });
    } else {
      this._originalInit();
    }
  }

  _originalInit() {
    const isDesktop = !responsive.matchesBreakpoint("phone") || !responsive.matchesBreakpoint("pocket");
    const position = this.element.dataset.position;

    if (this.options["using_fade"] == "fade") {
      // On desktop with custom scroll, use IntersectionObserver for all videos
      if (isDesktop) {
        this.setupScrollBasedLoading();
      } else {
        this.bindEvents();

        // Only load video if it's the first slide or currently active
        if (
          position == 0 ||
          this.element
            .closest(".swiper-slide")
            ?.classList.contains("swiper-slide-active") ||
          this.element
            .closest(".swiper-slide")
            ?.classList.contains("swiper-slide-duplicate-active")
        ) {
          this.checkLoaded();
        }
      }
    } else {
      this.checkLoaded();
    }
  }

  setupScrollBasedLoading() {
    // Use IntersectionObserver to load videos when they come into view
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.isInitialized) {
          observer.unobserve(this.element); // Stop observing once loaded
          this.checkLoaded();
        }
      });
    }, {
      threshold: 0.1, // Load when 10% visible
      rootMargin: "100px" // Start loading 100px before entering viewport
    });

    observer.observe(this.element);
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  bindHoverEvents() {
    if (this.options["play_in_view_mob_hover_desk"]) {
      this.onMouseEnterListener = this.onMouseEnter.bind(this);
      this.onMouseLeaveListener = this.onMouseLeave.bind(this);

      this.element.addEventListener("mouseenter", this.onMouseEnterListener);
      this.element.addEventListener("mouseleave", this.onMouseLeaveListener);
    }
  }

  onMouseEnter() {
    const isMobile = responsive.matchesBreakpoint("pocket");

    // Only handle hover for play_in_view_mob_hover_desk setting
    if (!isMobile && this.videoPlayer && this.options["play_in_view_mob_hover_desk"] && !this.options["play_in_view"]) {
      if (this.options["muted"]) {
        this.videoPlayer.muted("true");
      }
      const playPromise = this.videoPlayer.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // Silently catch autoplay prevention
        });
      }
    }
  }

  onMouseLeave() {
    const isMobile = responsive.matchesBreakpoint("pocket");

    // Only handle hover for play_in_view_mob_hover_desk setting
    if (!isMobile && this.videoPlayer && this.options["play_in_view_mob_hover_desk"] && !this.options["play_in_view"]) {
      if (this.videoPlayer.el_.classList.contains("vjs-playing")) {
        this.videoPlayer.pause();
      }
    }
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
      // Prevent autoplay if viewport is false
      if (this.videoPlayer && !this.options.viewport) {
        this.videoPlayer.pause();
      }
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    const isMobile = responsive.matchesBreakpoint("pocket");

    if (event.detail.currentIndex == this.elementPosition) {
      // Active slide - resume or initialize video
      if (this.element.getAttribute("loaded")) {
        if (this.videoPlayer) {
          // Already loaded — just resume playback
          if ((this.options["play_in_view"]) || (this.options["play_in_view_mob_hover_desk"] && isMobile)) {
            const playPromise = this.videoPlayer.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {});
            }
          }
        } else {
          this.checkLoaded();
        }
      } else {
        // First time loading
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        this.checkLoaded();
      }

      // Handle autoplay if enabled
      if ((this.options["play_in_view"]) || (this.options["play_in_view_mob_hover_desk"] && isMobile)) {
        setTimeout(() => {
          if (this.videoPlayer) {
            const playPromise = this.videoPlayer.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                // Silently catch autoplay prevention
              });
            }
            this.createObserver();
          }
        }, 200);
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      // Not active slide - pause if playing
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const isMobile = responsive.matchesBreakpoint("pocket");

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );

        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }
    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
          ? "video/vimeo"
          : "video/mp4";

    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      bigPlayButton: true,
      controlBar: this.options["controls"]
        ? {
          children: [
            "playToggle",
            "progressControl",
            "currentTimeDisplay",
            "timeDivider",
            "durationDisplay",
            "CustomControlSpacer",
            "volumePanel",
            "fullscreenToggle"
          ]
        }
        : false,
      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("playing", function () {
      _this.element.classList.add("video-playing");
    });

    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      // Bind hover events for desktop behavior
      _this.bindHoverEvents();

      // Force controls to be interactive on desktop
      const isMobile = responsive.matchesBreakpoint("pocket");
      if (!isMobile) {
        setTimeout(() => {
          _this.ensureDesktopControls();
        }, 100);
      }

      if (_this.trueObserver == false && (_this.options["play_in_view_mob_hover_desk"] || _this.options["play_in_view"])) {
        _this.createObserver();
      }
    });

    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", function () {
        _this.videoPlayer.muted("true");
      });
    }

    if (this.options["controls"]) {
      if (host == "html5") {
        this.videoPlayer.on("touchstart", function () {
          if (event.target.closest(".vjs-control-bar")) {
            return;
          }

          if (_this.videoPlayer.paused()) {
            const playPromise = _this.videoPlayer.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                // Silently catch autoplay prevention
              });
            }
          } else {
            _this.videoPlayer.pause();
          }
        });
      }
      if (host == "html5") return;
      this.videoPlayer.on("click", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          const playPromise = _this.videoPlayer.play();
          if (playPromise !== undefined) {
            playPromise.catch(() => {});
          }
        } else {
          _this.videoPlayer.pause();
        }
      });
    } else {
      // Disable click interactions completely
      this.videoPlayer.off('click');
      this.videoPlayer.off('touchstart');

      // Hide controls completely
      this.videoPlayer.controls(false);

      // Keep hover/mouseover functionality for desktop autoplay but disable manual clicking
      const videoEl = this.element.querySelector('.video-js');
      if (videoEl) {
        // Don't disable pointer events completely - we need hover to work
        // videoEl.style.pointerEvents = 'none';
        videoEl.style.cursor = 'default';

        // Add a custom click handler that does nothing to prevent any manual control
        videoEl.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }, true);

        videoEl.addEventListener('touchstart', function (e) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }, true);
      }
    }
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    const element = this.element;
    observer.observe(element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    const isMobile = responsive.matchesBreakpoint("pocket");

    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        // Handle play_in_view setting (both devices)
        if (this.options["play_in_view"] && this.videoPlayer) {
          if (this.options["muted"]) {
            this.videoPlayer.muted("true");
          }

          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              const playPromise = this.videoPlayer.play();
              if (playPromise !== undefined) {
                playPromise.catch(() => {});
              }
              setTimeout(checkIfPlaying, 100);
            }
          };

          checkIfPlaying();
        }
        // Handle play_in_view_mob_hover_desk setting (mobile only)
        else if (this.options["play_in_view_mob_hover_desk"] && this.videoPlayer && isMobile) {
          if (this.options["muted"]) {
            this.videoPlayer.muted("true");
          }

          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              const playPromise = this.videoPlayer.play();
              if (playPromise !== undefined) {
                playPromise.catch(() => {});
              }
              setTimeout(checkIfPlaying, 100);
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        // Handle play_in_view setting (both devices)
        if (this.options["play_in_view"] && this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
        // Handle play_in_view_mob_hover_desk setting (mobile only)
        else if (this.options["play_in_view_mob_hover_desk"] && isMobile &&
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }

  disposeVideoPlayer() {
    if (this.videoPlayer) {
      try {
        this.videoPlayer.dispose();
        this.videoPlayer = null;
      } catch (e) {
        this.videoPlayer = null; // Force null even if dispose fails
      }
    }
  }

  ensureDesktopControls() {
    if (!this.videoPlayer) return;

    // Only enable controls if they are supposed to be enabled
    if (this.options["controls"]) {
      // Force controls to be enabled
      this.videoPlayer.controls(true);

      // The main issue was CSS pointer-events, but we can still ensure controls are clickable
      const isMobile = responsive.matchesBreakpoint("pocket");
      if (!isMobile) {
        // Make sure text track display doesn't block clicks
        const textTrackDisplay = this.element.querySelector('.vjs-text-track-display');
        if (textTrackDisplay) {
          textTrackDisplay.style.pointerEvents = 'none';
        }
      }
    } else {
      // Make sure controls stay disabled
      this.videoPlayer.controls(false);

      // Ensure video is non-interactive
      const videoEl = this.element.querySelector('.video-js');
      if (videoEl) {
        videoEl.style.pointerEvents = 'none';
        videoEl.style.cursor = 'default';
      }
    }
  }

  reinitializeVideoPlayer() {
    this.disposeVideoPlayer();

    // Clear the loaded attribute so video can be reinitialized
    this.element.removeAttribute('loaded');
    this.element.removeAttribute('data-loaded');

    // Remove existing video holder completely
    const existingHolder = this.element.querySelector('.videoHolder');
    if (existingHolder) {
      existingHolder.remove();
    }

    // Force a fresh start
    setTimeout(() => {
      this.checkLoaded();
    }, 50);
  }
}
customElements.define("video-component", VideoComponent);





class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.successText = this.element.querySelector(".footer__success-text");
    this.inputsWrapper = this.element.querySelector(".newsletter__inputs");

    // give this footer instance a stable unique id for scoping selectors
    if (!this.element.id) {
      this.element.id = `footer-newsletter-${Math.random().toString(36).slice(2)}`;
    }

    this.bindEvents();
  }

  connectedCallback() {
    this.initFormValidation();

    this.updateFooterHeight();
    window.addEventListener("load", this.updateFooterHeight);
    responsive.addResizeListener(this, this.updateFooterHeight);

    // ensure initial state
    if (this.validator) this.validator.updateButtonState();
    this.fixLongFooterLinks();
    this.limitFooterMenusToFive();
    this.applySuccessStateFromUrl()
  }

  applySuccessStateFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const posted = params.get("customer_posted") === "true";

    const hashMatchesThisForm =
      window.location.hash === `#${this.element.querySelector("form")?.id || ""}`;

    if (posted && hashMatchesThisForm) {
      this.showSuccessMessage();

    }
  }

  fixLongFooterLinks = () => {
    this.querySelectorAll(".custom__dropdown-inner-content a").forEach((a) => {
      const text = (a.textContent || "").trim();
      if (!text) return;

      a.innerHTML = text.replace(/(\S{10})(?=\S)/g, "$1<wbr>");
    });

    requestAnimationFrame(() => requestAnimationFrame(this.updateFooterHeight));
  };



  initFormValidation() {
    const form = this.element.querySelector("form");
    if (!form) return;

    this.validator = new FormValidator(form, {
      errorClass: "field--error",
      fieldSelector: ".footer .newsletter__email-input-wrapper",
      buttonSelector: `#${this.element.id} .newsletter__subscribe-button`,
      validateOnBlur: true,
      validateOnInput: true,
      errorOutputSelector: ".footer .newsletter__error-wrapper",
      showErrorsOnSubmitOnly: false
    });
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.clearInput.bind(this)
    );

    const formEl = this.element.querySelector("form");
    if (formEl) {
      formEl.addEventListener("submit", this.onSubmit.bind(this));
    }
  }

  updateFooterHeight = () => {
    const footerHeight = this.offsetHeight + "px";
    document.documentElement.style.setProperty("--footer-dynamic-height", footerHeight);
    document.documentElement.style.setProperty("--footer-height", footerHeight);
  };

  clearInput() {
    const emailInput = this.querySelector(".input-placeholder");
    const errorWrapper = this.querySelector(".newsletter__error-wrapper");
    const emailWrapper = this.querySelector(".footer__newsletter-form-inputs");

    if (emailInput) emailInput.value = "";
    if (errorWrapper) errorWrapper.innerHTML = "";
    if (emailWrapper) emailWrapper.classList.remove("alert");

    if (this.validator) {
      this.validator.clearErrors();
      this.validator.updateButtonState();
    }
  }

  async onSubmit(e) {
    e.preventDefault();

    if (this.validator && !this.validator.showAllErrors()) {
      return;
    }

    const emailEl = this.element.querySelector(".newsletter__email-input");
    const email = emailEl ? emailEl.value.trim() : "";

    if (!email) {
      return;
    }

    const submitButton = this.element.querySelector(".newsletter__subscribe-button");
    if (submitButton) submitButton.setAttribute("disabled", true);

    try {
      // Simulate form success (Shopify handles the form submission)
      this.showSuccessMessage();
    } catch (error) {
    } finally {
      if (submitButton) submitButton.removeAttribute("disabled");
    }
  }

  showSuccessMessage() {
    const privacyText = this.element.querySelector(".newsletter__privacy-text");

    if (privacyText) privacyText.style.display = "none";
    if (this.inputsWrapper) this.inputsWrapper.style.display = "none";
    if (this.successText) this.successText.style.display = "block";
  }

  limitFooterMenusToFive() {
    const group = this.querySelector(".links__dropdown-group");
    if (!group) return;

    const mq = window.matchMedia("(min-width: 1025px)");

    const apply = () => {
      const dropdowns = [...group.querySelectorAll(".custom__dropdown, .Dropdown")];

      if (mq.matches) {
        dropdowns.forEach((el, i) => {
          el.style.display = i < 5 ? "" : "none";
        });
      } else {
        dropdowns.forEach((el) => {
          el.style.display = "";
        });
      }
    };

    apply();
    requestAnimationFrame(apply);

    this._footerMenuObserver?.disconnect();
    this._footerMenuObserver = new MutationObserver(apply);
    this._footerMenuObserver.observe(group, { childList: true, subtree: false });

    this._footerMenuMqHandler = apply;
    if (mq.addEventListener) mq.addEventListener("change", this._footerMenuMqHandler);
    else mq.addListener(this._footerMenuMqHandler);
  }

  disconnectedCallback() {
    this._footerMenuObserver?.disconnect();

    const mq = window.matchMedia("(min-width: 1025px)");
    if (this._footerMenuMqHandler) {
      if (mq.removeEventListener) mq.removeEventListener("change", this._footerMenuMqHandler);
      else mq.removeListener(this._footerMenuMqHandler);
    }
  }


}

customElements.define("footer-component", FooterComponent);



class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.options = JSON.parse(this.element.getAttribute("data-section-settings") || "{}");
    this.boundEventHandlers = new Map();

    this._atcInlineScheduled = false;
    this._atcInlineTimer = null;

    // qty mirror state
    this._qtyMirrorCleanup = null;
    this._qtySyncing = false;

    // hover preview cleanup
    this._colorHoverUnbinders = [];

    // sticky internal state
    this.hideSticky = false;
    this._desktopStickyBound = false;
    this._mobileBottomScrollBound = false;
    this._atcObserver = null;
    this._desktopStickyScrollHandler = null;
    this._mobileBottomScrollHandler = null;

    new AddToCart(this.element);
  }

  connectedCallback() {
    // DOM refs
    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.carouselElementThumbs = this.element.querySelector(".main-product__thumbs");
    this.uspSwiperElement = this.element.querySelector(".product-usp__swiper.swiper");
    this.tintElement = this.element.querySelector(".ProductSlider--Tint");
    this.wrapperElement = this.element.querySelector(".main-product__slider");
    this.mainAtc = this.element.querySelector(".product-info__actions");

    // sticky wrapper (✅ ALWAYS same selector everywhere)
    this.stickyAtcWrapper = this.element.querySelector(
      ".pdp-sticky-product-atc, .product-module__sticky-atc"
    );

    // Ensure sticky is hidden by default until logic decides to show it
    if (this.stickyAtcWrapper && !this.stickyAtcWrapper.hasAttribute("aria-hidden")) {
      this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
    }
    // Don't force has-sticky at load. Let toggleStickyAtc control it.
    document.body.classList.remove("has-sticky");

    // sticky sentinel (some themes)
    if (this.mainAtc) {
      const existing = this.element.querySelector(".sticky-atc-sentinel");
      this._stickySentinel = existing || null;

      if (!this._stickySentinel) {
        const sentinel = document.createElement("div");
        sentinel.className = "sticky-atc-sentinel";
        sentinel.setAttribute("aria-hidden", "true");
        this.mainAtc.insertAdjacentElement("afterend", sentinel);
        this._stickySentinel = sentinel;
      }
    }

    this.valuesWrap = this.element.querySelectorAll(".ProductOption--ValusWrapper");

    // swiper init
    const slides = this.carouselElement?.querySelectorAll(".swiper-slide") || [];
    if (slides.length > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement, this.carouselElementThumbs);
    } else {
      this.element
        .querySelectorAll(".pdp_swiperButton")
        .forEach((btn) => (btn.style.display = "none"));
    }

    if (slides.length <= 1) this.element.classList.add("has-single-image");
    else this.element.classList.remove("has-single-image");

    // zoom
    if (this.options["enable_zoom"]) {
      setTimeout(() => {
        try {
          const zoom = new RevolutionImageZoom(this.element, this.carousel);
          zoom.syncHeight = zoom.syncHeight.bind(zoom);
          responsive.addResizeListener(zoom, zoom.syncHeight);
        } catch (err) {
        }
      }, 200);
    }

    // usp swiper
    if (this.uspSwiperElement) this.uspSwiper = new RevolutionSwiper(this.uspSwiperElement);

    this.bindEvents();
    this.bindVariantEvents();
    this.setupQuantityMirror();
    this.bindColorHoverPreview();

    requestAnimationFrame(() => setTimeout(() => this.syncThumbnailHeight(), 100));
    responsive.addResizeListener(this, this.syncThumbnailHeight);

    // initial totals/inline
    this.updatePriceButtonATC();
    this.scheduleAtcInlinePriceUpdate();
    
    // Navigate to variant's image on page load if not first image
    this.initializeVariantImage();

    // keep availability + totals in sync with VariantSelects
    this._onVariantPriceUpdated = () => {
      const v = this.getCurrentVariantFromSection();
      if (v) this.applyVariantAvailabilityUI(!!v.available);

      this.updatePriceButtonATC();
      this.scheduleAtcInlinePriceUpdate();
    };
    document.addEventListener("variant:price-updated", this._onVariantPriceUpdated);

    this._onVariantIdChanged = () => {
      const v = this.getCurrentVariantFromSection();
      if (v) this.applyVariantAvailabilityUI(!!v.available);
    };
    document.addEventListener("variant:id-changed", this._onVariantIdChanged);

    // set correct initial availability
    const initialVariant = this.getCurrentVariantFromSection();
    if (initialVariant) this.applyVariantAvailabilityUI(!!initialVariant.available);

    // init sticky after paint so measurements/observer behave
    if (this.options["sticky_atc"]) {
      setTimeout(() => this.showStickyAtc(), 120);
    }

    this.initReloadWithoutRefresh?.();
    this.updateNotifyButtonState?.();
    this.runPDPAnimations?.();
  }

  disconnectedCallback() {
    this.cleanupEvents();
  }

  cleanupEvents() {
    try {
      this.domDelegate?.off?.();
    } catch (e) { }
    try {
      this.delegateBody?.off?.();
    } catch (e) { }

    if (this.carousel?.destroy) {
      this.carousel.destroy(true, true);
      this.carousel = null;
    }
    if (this.uspSwiper?.destroy) {
      this.uspSwiper.destroy(true, true);
      this.uspSwiper = null;
    }

    if (this.boundEventHandlers?.has?.("popstate")) {
      window.removeEventListener("popstate", this.boundEventHandlers.get("popstate"));
    }

    if (this._atcObserver) {
      try {
        this._atcObserver.disconnect();
      } catch (e) { }
      this._atcObserver = null;
    }

    if (this._desktopStickyScrollHandler) {
      window.removeEventListener("scroll", this._desktopStickyScrollHandler);
      window.removeEventListener("resize", this._desktopStickyScrollHandler);
      this._desktopStickyScrollHandler = null;
    }
    this._desktopStickyBound = false;

    if (this._mobileBottomScrollHandler) {
      window.removeEventListener("scroll", this._mobileBottomScrollHandler);
      this._mobileBottomScrollHandler = null;
    }
    this._mobileBottomScrollBound = false;

    if (typeof responsive !== "undefined" && typeof responsive.removeResizeListener === "function") {
      try {
        responsive.removeResizeListener(this, this.syncThumbnailHeight);
      } catch (e) { }
      try {
        responsive.removeResizeListener(this);
      } catch (e) { }
    }

    if (this._onVariantPriceUpdated) {
      document.removeEventListener("variant:price-updated", this._onVariantPriceUpdated);
      this._onVariantPriceUpdated = null;
    }
    if (this._onVariantIdChanged) {
      document.removeEventListener("variant:id-changed", this._onVariantIdChanged);
      this._onVariantIdChanged = null;
    }
    if (this._onVariantChanged) {
      this.element.removeEventListener("variant:changed", this._onVariantChanged);
      this._onVariantChanged = null;
    }

    if (this._atcInlineTimer) {
      clearTimeout(this._atcInlineTimer);
      this._atcInlineTimer = null;
    }
    this._atcInlineScheduled = false;

    if (this._colorHoverUnbinders?.length) {
      this._colorHoverUnbinders.forEach((off) => {
        try {
          off();
        } catch (e) { }
      });
      this._colorHoverUnbinders = [];
    }

    this._qtyMirrorCleanup?.();
    this._qtyMirrorCleanup = null;

    this.boundEventHandlers?.clear?.();
  }

  /* =========================
     AVAILABILITY UI
     ========================= */
  applyVariantAvailabilityUI(available) {
    const wrappers = this.element.querySelectorAll(".Quantity-ATC--wrapper");

    wrappers.forEach((wrap) => {
      const qtyHandler = wrap.querySelector(".QuantityHandler");
      const qtyEl = wrap.querySelector("quantity-input.Quantity, quantity-input");
      const qtyInput = wrap.querySelector('input[name="quantity"]');
      const minusBtn = wrap.querySelector('button[name="minus"]');
      const plusBtn = wrap.querySelector('button[name="plus"]');

      const atc = wrap.querySelector(".add-to-cart__wrapper");
      const submitBtn =
        atc?.querySelector('button[type="submit"], button[name="add"], .product__atc-button') || null;

      const notify = wrap.querySelector(".notify-wrapper");

      // ✅ Buttons should ALWAYS be visible
      if (qtyHandler) qtyHandler.classList.remove("hideBtn");
      if (atc) atc.classList.remove("hideBtn");
      if (qtyEl) qtyEl.style.display = "";

      // ✅ Notify: show only when OOS
      if (notify) notify.classList.toggle("hideBtn", available);

      // ✅ Disable ATC + qty when OOS (but keep visible)
      const shouldDisable = !available;

      if (qtyInput) qtyInput.disabled = shouldDisable;
      if (minusBtn) minusBtn.disabled = shouldDisable;
      if (plusBtn) plusBtn.disabled = shouldDisable;

      if (submitBtn) {
        submitBtn.disabled = shouldDisable;
        submitBtn.setAttribute("aria-disabled", shouldDisable ? "true" : "false");
      }

      if (qtyHandler) qtyHandler.setAttribute("aria-hidden", "false");
      if (atc) atc.setAttribute("aria-hidden", "false");
      if (notify) notify.setAttribute("aria-hidden", available ? "true" : "false");
    });
  }



  bindVariantEvents() {
    // Clean up old listeners first
    if (this._onVariantChanged) {
      this.element.removeEventListener("variant:changed", this._onVariantChanged);
    }

    // listen for variant image changes
    this._onVariantChanged = (event) => {
      this.updateImage(event);
    };
    this.element.addEventListener("variant:changed", this._onVariantChanged);
  }

  bindEvents() {
    this.domDelegate.on("input", 'input[name="quantity"]', () => {
      this.scheduleAtcInlinePriceUpdate();
      this.updatePriceButtonATC();
    });

    this.domDelegate.on("change", 'input[name="quantity"]', () => {
      this.scheduleAtcInlinePriceUpdate();
      this.updatePriceButtonATC();
    });

    // keep totals responsive while VariantSelects does its work
    this.domDelegate.on("change", 'input[name^="options["], select[name^="options["]', () => {
      this.updateVariantAvailability();
      this.updatePriceButtonATC();
      this.scheduleAtcInlinePriceUpdate();
    });

    // Recalculate ATC totals when the subscription selector changes
    // (radio toggle or plan-option click). Uses microtask so the
    // SubscriptionSelector handler finishes updating data-effective-price
    // before ProductElement recalculates.
    const recalcAfterSubscriptionChange = () => {
      queueMicrotask(() => {
        this.updatePriceButtonATC();
        this.scheduleAtcInlinePriceUpdate();
      });
    };
    this.domDelegate.on("change", ".subscription-selector__radio", recalcAfterSubscriptionChange);
    this.domDelegate.on("click", "[data-action='select-plan']", recalcAfterSubscriptionChange);

    // sticky show/hide hooks
    if (this.options["sticky_atc"]) {
      // if add-to-cart feedback hides sticky temporarily
      this.delegateBody.on("product:added", this.hideStickyTimeout.bind(this));
      this.delegateBody.on("product:error", this.hideStickyTimeout.bind(this));

      if (document.readyState === "loading") {
        window.addEventListener("DOMContentLoaded", () => this.showStickyAtc());
      } else {
        setTimeout(() => this.showStickyAtc(), 100);
      }
    }

    const reloadPageHandler = this.reloadPage.bind(this);
    this.boundEventHandlers.set("popstate", reloadPageHandler);
    window.addEventListener("popstate", reloadPageHandler);
  }

  /* ---------- VARIANT HELPERS ---------- */

  getCurrentVariantPriceCents() {
    // 0) If a subscription plan is active, use the plan-adjusted price
    const subPrice = this._getSubscriptionEffectivePrice();
    if (subPrice !== null) return subPrice;

    // Get the current form variant ID so we can verify we read the right price
    const idInput = this.element.querySelector('form[data-product-form] input[name="id"]');
    const currentId = idInput?.value;

    // 1) Preferred: VariantSelects.currentVariant — but only if it matches the
    //    form's variant ID. On bundle pages the first variant-selects may belong
    //    to an upsell/connected product, not the main product.
    const vs = this.element.querySelector("variant-selects");
    if (vs && vs.currentVariant && Number.isFinite(vs.currentVariant.price)) {
      if (!currentId || String(vs.currentVariant.id) === String(currentId)) {
        return vs.currentVariant.price;
      }
    }

    // 2) Try all variant-selects to find one that contains this variant
    if (currentId) {
      const allVS = this.element.querySelectorAll("variant-selects");
      for (const sel of allVS) {
        const script = sel.querySelector("script[type='application/json']");
        if (!script) continue;
        try {
          const variants = JSON.parse(script.textContent);
          const match = variants.find((x) => String(x.id) === String(currentId));
          if (match && Number.isFinite(match.price)) return match.price;
        } catch {}
      }
    }

    // 3) Fallback: read the server-rendered data-price attribute, which Liquid
    //    sets from the actual product's selectedVariant.price (always correct,
    //    even for bundles with a different price than their connected products).
    const priceEl = this.element.querySelector(".product-info__price--value[data-price]");
    if (priceEl) {
      const domPrice = parseFloat(priceEl.getAttribute("data-price"));
      if (Number.isFinite(domPrice)) return domPrice;
    }

    return NaN;
  }

  /**
   * Returns the subscription-adjusted price in cents when a selling plan is
   * active, or null when the customer chose one-time purchase (or no
   * subscription-selector exists on the page).
   */
  _getSubscriptionEffectivePrice() {
    const subSelector = this.element.querySelector("subscription-selector");
    if (!subSelector) return null;
    const isSubscription = subSelector.querySelector(
      '.subscription-selector__radio[value="subscription"]:checked'
    );
    if (!isSubscription) return null;
    const raw = subSelector.getAttribute("data-effective-price");
    if (raw === null) return null;
    const val = Number(raw);
    return Number.isFinite(val) ? val : null;
  }

  getCurrentVariantFromSection() {
    const variantJson = this.element.querySelector("variant-selects script[type='application/json']");
    if (!variantJson) return null;

    let variants;
    try {
      variants = JSON.parse(variantJson.textContent);
    } catch {
      return null;
    }

    const idInput = this.element.querySelector('form[data-product-form] input[name="id"]');
    const byId = idInput ? variants.find((v) => String(v.id) === String(idInput.value)) : null;
    if (byId) return byId;

    const opts = Array.from(
      this.element.querySelectorAll('input[name^="options["]:checked, select[name^="options["]')
    ).map((el) => el.value);

    return (
      variants.find((v) => {
        if (Array.isArray(v.options)) {
          return v.options.every((val, idx) => (opts[idx] ? opts[idx] === val : true));
        }
        return (
          (!v.option1 || v.option1 === opts[0]) &&
          (!v.option2 || v.option2 === opts[1]) &&
          (!v.option3 || v.option3 === opts[2])
        );
      }) || null
    );
  }

  updateVariantAvailability() {
    const variantDataEl = this.element.querySelector("variant-selects script[type='application/json']");
    if (!variantDataEl) return;

    let variants;
    try {
      variants = JSON.parse(variantDataEl.textContent);
    } catch {
      return;
    }

    const currentOptions = Array.from(this.element.querySelectorAll('input[name^="options["]:checked')).map(
      (el) => el.value
    );

    this.element.querySelectorAll(".inputSelectboxCheckbox").forEach((input) => {
      const optionPos = parseInt(input.name.match(/\d+/)?.[0] || "0", 10);
      if (!optionPos) return;

      const testOptions = [...currentOptions];
      testOptions[optionPos - 1] = input.value;

      const match = variants.find(
        (v) =>
          (!v.option1 || v.option1 === testOptions[0]) &&
          (!v.option2 || v.option2 === testOptions[1]) &&
          (!v.option3 || v.option3 === testOptions[2])
      );

      const available = !!(match && match.available);
      const label = input.nextElementSibling;
      input.classList.toggle("variant-disabled", !available);
      label?.classList.toggle?.("opacity-50", !available);
    });
  }

  /* ---------- INLINE PRICE ---------- */

  scheduleAtcInlinePriceUpdate() {
    if (this._atcInlineScheduled) return;
    this._atcInlineScheduled = true;

    requestAnimationFrame(() => {
      this._atcInlineScheduled = false;
      this.updateAtcInlinePrice();
    });
  }

  updateAtcInlinePrice() {
    const baseCents = this.getCurrentVariantPriceCents();
    if (!Number.isFinite(baseCents)) return;

    const moneyFormat = window.theme?.moneyFormat || "{{amount}}";
    const fmt = (cents) => Shopify.formatMoney(cents, moneyFormat);

    const updateForRoot = (root) => {
      if (!root) return;
      const btn = root.querySelector(".product__atc-button");
      if (!btn) return;

      const label = btn.querySelector(".button-txt") || btn.querySelector(".ButtonTextContainer") || btn.querySelector(".ButtonText");
      if (!label) return;

      const form = btn.closest("form");
      const qtyInput = form?.querySelector('input[name="quantity"]');
      const qty = Math.max(1, parseInt(qtyInput?.value || "1", 10) || 1);

      let inline = label.querySelector(".atc-price-inline");
      if (!inline) {
        inline = document.createElement("span");
        inline.className = "atc-price-inline";
        inline.setAttribute("aria-hidden", "true");
        label.appendChild(inline);
      }

      inline.textContent = ` (${fmt(baseCents * qty)})`;
    };

    updateForRoot(this.element.querySelector(".product-info__actions") || this.element);
    updateForRoot(this.element.querySelector(".product-module__sticky-atc"));
    updateForRoot(this.element.querySelector(".pdp-sticky-product-atc"));
  }

  /* ---------- TOTAL PRICE ---------- */

  calculateTotalPrice() {
    let total = 0;

    const baseCents = this.getCurrentVariantPriceCents();
    if (Number.isFinite(baseCents)) total += baseCents;

    const checkedAddons = this.element.querySelectorAll(".pdp-addon-product-card__checkbox:checked[data-price]");
    checkedAddons.forEach((input) => {
      const price = parseFloat(input.getAttribute("data-price")) || 0;
      total += price;
    });

    const checkedAccessories = this.element.querySelectorAll(
      ".pdp-accessory-product-card__checkbox:checked[data-price]"
    );
    checkedAccessories.forEach((input) => {
      const price = parseFloat(input.getAttribute("data-price")) || 0;
      const productId = input.getAttribute("data-productid");
      const qtyInput = this.element.querySelector(`.quantity-input[data-productid="${productId}"]`);
      const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      total += price * qty;
    });

    return total;
  }

  updatePriceButtonATC() {
    const total = this.calculateTotalPrice();
    const formatted = Shopify.formatMoney(total, window.theme.moneyFormat);

    this.element.querySelectorAll(".product__atc-button .button-total-price").forEach((span) => {
      const button = span.closest(".product__atc-button");
      if (button && button.hasAttribute("disabled")) return;
      span.textContent = ` - ${formatted}`;
    });
  }

  /* ---------- STICKY ATC ---------- */

  // ✅ Make sure we always have the sticky wrapper (important after DOM swaps)
  ensureStickyRefs() {
    if (!this.stickyAtcWrapper) {
      this.stickyAtcWrapper = this.element.querySelector(
        ".pdp-sticky-product-atc, .product-module__sticky-atc"
      );
    }
    if (!this.mainAtc) {
      this.mainAtc = this.element.querySelector(".product-info__actions");
    }
  }

  hideStickyTimeout() {
    this.ensureStickyRefs();
    if (!this.stickyAtcWrapper) return;

    this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
    document.body.classList.remove("has-sticky");

    this.hideSticky = true;
    setTimeout(() => {
      this.hideSticky = false;
      this.showStickyAtc();
    }, 3000);
  }

  showStickyAtc() {
    this.ensureStickyRefs();
    if (!this.options["sticky_atc"]) return;
    if (!this.stickyAtcWrapper || this.hideSticky) return;

    const footer = document.querySelector("footer");

    // Desktop
    if (window.matchMedia("(min-width: 1025px)").matches) {
      if (this._desktopStickyBound) return;
      this._desktopStickyBound = true;

      const onScroll = () => {
        if (this.hideSticky) return;

        const showAfter = 150;
        const shouldShow = window.scrollY > showAfter;

        let atTheBottom = false;
        if (footer) {
          const footerHeight = footer.offsetHeight;
          atTheBottom =
            window.innerHeight + window.scrollY >=
            document.body.offsetHeight - footerHeight + 60;
        } else {
          atTheBottom =
            window.innerHeight + window.scrollY >=
            document.body.offsetHeight - 100;
        }

        this.toggleStickyAtc(shouldShow && !atTheBottom);
      };

      this._desktopStickyScrollHandle = scrollListener.addScrollListener(this, onScroll);
      responsive.addResizeListener(this, onScroll);

      onScroll();
      return;
    }

    // Mobile: observer on main ATC visibility
    if (!this.mainAtc) return;

    if (this._atcObserver) {
      try {
        this._atcObserver.disconnect();
      } catch (e) { }
      this._atcObserver = null;
    }

    this._atcObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const isVisible = entry.isIntersecting;

          let atTheBottom = false;
          if (footer) {
            const footerHeight = footer.offsetHeight;
            atTheBottom =
              window.innerHeight + window.scrollY >=
              document.body.offsetHeight - footerHeight + 60;
          } else {
            atTheBottom =
              window.innerHeight + window.scrollY >=
              document.body.offsetHeight - 100;
          }

          if (atTheBottom) this.toggleStickyAtc(false);
          else this.toggleStickyAtc(!isVisible);
        });
      },
      { root: null, threshold: 0 }
    );

    this._atcObserver.observe(this.mainAtc);

    // bottom check (bind once)
    if (!this._mobileBottomScrollBound) {
      this._mobileBottomScrollBound = true;
      const mobileBottomCheck = () => {
        let atTheBottom = false;

        if (footer) {
          const footerHeight = footer.offsetHeight;
          atTheBottom =
            window.innerHeight + window.scrollY >=
            document.body.offsetHeight - footerHeight;
        } else {
          atTheBottom =
            window.innerHeight + window.scrollY >=
            document.body.offsetHeight - 100;
        }

        if (atTheBottom) {
          this.toggleStickyAtc(false);
        } else if (this.mainAtc) {
          const rect = this.mainAtc.getBoundingClientRect();
          const mainAtcHidden = rect.bottom < 0 || rect.top > window.innerHeight;
          if (mainAtcHidden) this.toggleStickyAtc(true);
        }
      };
      this._mobileBottomScrollHandle = scrollListener.addScrollListener(this, mobileBottomCheck);
    }
  }

  toggleStickyAtc(show) {
    this.ensureStickyRefs();
    if (!this.stickyAtcWrapper) return;
    if (this.hideSticky) return;

    this.stickyAtcWrapper.setAttribute("aria-hidden", show ? "false" : "true");
    document.body.classList.toggle("has-sticky", !!show);
  }

  /* ---------- QTY MIRROR ---------- */

  setupQuantityMirror() {
    this.teardownQuantityMirror();
    this._qtyMirrorCleanup = () => this.teardownQuantityMirror();

    const getForms = () => {
      const mainForm = this.element.querySelector(".product-info__actions form[data-product-form]");
      const stickyForm =
        this.element.querySelector(".pdp-sticky-product-atc form[data-product-form]") ||
        this.element.querySelector(".product-module__sticky-atc form[data-product-form]");
      return { mainForm, stickyForm };
    };

    const getInputs = () => {
      const { mainForm, stickyForm } = getForms();

      let mainQty = mainForm?.querySelector('input[name="quantity"]') || null;
      if (!mainQty && mainForm?.id) {
        mainQty = this.element.querySelector(`input[name="quantity"][form="${CSS.escape(mainForm.id)}"]`);
      }

      const stickyQty = stickyForm?.querySelector('input[name="quantity"]') || null;
      return { mainQty, stickyQty };
    };

    const clampQty = (targetInput, raw) => {
      let v = parseInt(raw, 10);
      if (Number.isNaN(v)) v = 1;

      const min = targetInput?.min ? parseInt(targetInput.min, 10) : 1;
      const max = targetInput?.max ? parseInt(targetInput.max, 10) : null;

      if (!Number.isNaN(min)) v = Math.max(v, min);
      if (max && !Number.isNaN(max)) v = Math.min(v, max);

      return v;
    };

    const sync = (fromInput, toInput) => {
      if (!fromInput || !toInput) return;
      if (this._qtySyncing) return;

      this._qtySyncing = true;
      try {
        const v = clampQty(toInput, fromInput.value);
        if (String(toInput.value) !== String(v)) {
          toInput.value = v;
          toInput.dispatchEvent(new Event("input", { bubbles: true }));
          toInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
      } finally {
        this._qtySyncing = false;
      }
    };

    const bind = () => {
      const { mainQty, stickyQty } = getInputs();
      if (!mainQty || !stickyQty) return;

      this._mainQty = mainQty;
      this._stickyQty = stickyQty;

      sync(mainQty, stickyQty);

      this._onMainQtyInput = () => sync(mainQty, stickyQty);
      this._onStickyQtyInput = () => sync(stickyQty, mainQty);

      mainQty.addEventListener("input", this._onMainQtyInput);
      mainQty.addEventListener("change", this._onMainQtyInput);

      stickyQty.addEventListener("input", this._onStickyQtyInput);
      stickyQty.addEventListener("change", this._onStickyQtyInput);

      this._onQtyButtonClick = (e) => {
        const btn = e.target.closest('button[name="plus"], button[name="minus"]');
        if (!btn) return;

        setTimeout(() => {
          const { mainQty: m, stickyQty: s } = getInputs();
          if (!m || !s) return;

          if (btn.closest(".pdp-sticky-product-atc, .product-module__sticky-atc")) sync(s, m);
          else sync(m, s);
        }, 0);
      };

      this.element.addEventListener("click", this._onQtyButtonClick, true);
    };

    bind();
    this._qtyMirrorRebindTimer = setTimeout(bind, 50);
  }

  teardownQuantityMirror() {
    if (this._qtyMirrorRebindTimer) {
      clearTimeout(this._qtyMirrorRebindTimer);
      this._qtyMirrorRebindTimer = null;
    }

    if (this._mainQty && this._onMainQtyInput) {
      this._mainQty.removeEventListener("input", this._onMainQtyInput);
      this._mainQty.removeEventListener("change", this._onMainQtyInput);
    }

    if (this._stickyQty && this._onStickyQtyInput) {
      this._stickyQty.removeEventListener("input", this._onStickyQtyInput);
      this._stickyQty.removeEventListener("change", this._onStickyQtyInput);
    }

    if (this._onQtyButtonClick) {
      this.element.removeEventListener("click", this._onQtyButtonClick, true);
    }

    this._mainQty = null;
    this._stickyQty = null;
    this._onMainQtyInput = null;
    this._onStickyQtyInput = null;
    this._onQtyButtonClick = null;
  }

  /* ---------- MISC / YOUR EXISTING METHODS ---------- */

  reloadPage() {
    window.location.reload();
  }

  /* NOTE: duplicate definition exists later in the class — the later one
     takes precedence.  Kept in sync for clarity. */
  initializeVariantImage() {
    this._doInitializeVariantImage();
  }

  upgradeEagerImages() {
    // Upgrade all images with loading="eager" (first image + variant image)
    const eagerImages = this.element.querySelectorAll('img[loading="eager"][data-src]');
    eagerImages.forEach(img => {
      const replaceUrl = img.getAttribute("data-src")?.replace("{width}x", "2600x");
      if (replaceUrl) img.src = replaceUrl;
    });
  }

  changeImageQuality() {
    // Upgrade currently active slide image
    const activeSlide = this.element.querySelector(".swiper-slide-active img[data-src]");
    if (activeSlide) {
      const activeUrl = activeSlide.getAttribute("data-src")?.replace("{width}x", "2600x");
      if (activeUrl) activeSlide.src = activeUrl;
    }
  }

  bindColorHoverPreview() {
    const currentLabelEl = this.element.querySelector(".connected-products-option-info--current");
    if (!currentLabelEl) return;

    if (!currentLabelEl.dataset.originalText) {
      currentLabelEl.dataset.originalText = (currentLabelEl.textContent || "").trim();
    }

    this._colorHoverUnbinders.forEach((off) => {
      try {
        off();
      } catch (e) { }
    });
    this._colorHoverUnbinders = [];

    const links = this.element.querySelectorAll('.filterColor--item a[data-action="handle-reload"]');

    links.forEach((link) => {
      const item = link.closest(".filterColor--item");
      if (!item) return;

      const input = item.querySelector('input[id^="Color-"]');
      const prettyName = (input?.id?.slice(6) || "")
        .replace(/-/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());

      const enter = () => {
        if (prettyName) currentLabelEl.textContent = prettyName;
      };
      const leave = () => {
        currentLabelEl.textContent = currentLabelEl.dataset.originalText || "";
      };

      link.addEventListener("mouseenter", enter);
      link.addEventListener("mouseleave", leave);

      this._colorHoverUnbinders.push(() => {
        link.removeEventListener("mouseenter", enter);
        link.removeEventListener("mouseleave", leave);
      });
    });
  }

  /* ---------- RELOAD WITHOUT REFRESH (kept compatible) ---------- */

  initReloadWithoutRefresh() {
    sessionStorage.setItem("elementaryLoad", "true");

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        this.preloadConnectedProducts?.();
        this.preloadVariants?.();
      });
    } else {
      this.preloadConnectedProducts?.();
      this.preloadVariants?.();
    }
  }

  // keep your existing preloadConnectedProducts/preloadVariants/updateContentWithoutReload/fetchAndNavigate
  // (not included here because you asked specifically for ProductElement;
  //  paste your existing ones below this class if they’re outside)

  reinitializeAfterContentUpdate() {
    // Re-grab refs after innerHTML swap
    this.carousel = null;
    this.uspSwiper = null;

    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.carouselElementThumbs = this.element.querySelector(".main-product__thumbs");
    this.uspSwiperElement = this.element.querySelector(".product-usp__swiper.swiper");
    this.tintElement = this.element.querySelector(".ProductSlider--Tint");
    this.wrapperElement = this.element.querySelector(".main-product__slider");
    this.mainAtc = this.element.querySelector(".product-info__actions");
    this.stickyAtcWrapper = this.element.querySelector(".pdp-sticky-product-atc, .product-module__sticky-atc");
    this.valuesWrap = this.element.querySelectorAll(".ProductOption--ValusWrapper");

    this.options = JSON.parse(this.element.getAttribute("data-section-settings") || "{}");

    const slides = this.carouselElement?.querySelectorAll(".swiper-slide") || [];
    if (slides.length > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement, this.carouselElementThumbs);
    } else {
      this.element.querySelectorAll(".pdp_swiperButton").forEach((btn) => (btn.style.display = "none"));
    }

    if (slides.length <= 1) this.element.classList.add("has-single-image");
    else this.element.classList.remove("has-single-image");

    if (this.options["enable_zoom"]) {
      setTimeout(() => {
        try {
          const zoom = new RevolutionImageZoom(this.element, this.carousel);
          zoom.syncHeight = zoom.syncHeight.bind(zoom);
          responsive.addResizeListener(zoom, zoom.syncHeight);
        } catch (err) {

        }
      }, 200);
    }

    if (this.uspSwiperElement) this.uspSwiper = new RevolutionSwiper(this.uspSwiperElement);

    new AddToCart(this.element);

    // Rebind events + behaviors
    this.bindEvents();
    this.bindVariantEvents();
    this.setupQuantityMirror();
    this.bindColorHoverPreview();
    this.updateNotifyButtonState();

    if (this.options["sticky_atc"]) {
      document.body.classList.add("has-sticky");
      setTimeout(() => this.showStickyAtc?.(), 200);
    } else {
      document.body.classList.remove("has-sticky");
    }

    requestAnimationFrame(() => setTimeout(() => this.syncThumbnailHeight(), 100));
    responsive.addResizeListener(this, this.syncThumbnailHeight);

    this.updatePriceButtonATC();
    this.scheduleAtcInlinePriceUpdate();
    this.initializeVariantImage();

    // ✅ force correct availability after DOM swap
    const v = this.getCurrentVariantFromSection();
    if (v) this.applyVariantAvailabilityUI(!!v.available);
  }

  updateNotifyButtonState() {
    const translationsEl = document.querySelector("#notify-translations");
    if (!translationsEl) return;

    const soldOutText = translationsEl.dataset.soldOut || "";
    const outOfStockText = translationsEl.dataset.outOfStock || "";

    const hasPopup = !!document.querySelector("notify-me-popup");

    this.element.querySelectorAll(".notify-wrapper button, .notify-wrapper [role='button']").forEach((notifyBtn) => {
      const txtEl = notifyBtn.querySelector(".button-txt");
      if (!txtEl) return;

      if (hasPopup) {
        txtEl.textContent = soldOutText;
        notifyBtn.removeAttribute("disabled");
        notifyBtn.setAttribute("data-action", "toggle-popup");
        notifyBtn.setAttribute("aria-controls", "notify-me-popup");
      } else {
        txtEl.textContent = outOfStockText;
        notifyBtn.setAttribute("disabled", "disabled");
        notifyBtn.removeAttribute("data-action");
        notifyBtn.removeAttribute("aria-controls");
      }
    });
  }



  async fetchAndNavigate(url) {
    const currentProductComponent = document.querySelector("product-component");
    if (currentProductComponent) {
      currentProductComponent.style.opacity = '0.5';
      currentProductComponent.style.pointerEvents = 'none';
    }

    try {
      const response = await fetch(url);
      if (response.ok) {
        const htmlContent = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, "text/html");

        contentCache[url] = doc;

        if (currentProductComponent) {
          currentProductComponent.style.opacity = '';
          currentProductComponent.style.pointerEvents = '';
        }

        this.updateContentWithoutReload({
          preventDefault: () => { },
          target: { closest: () => ({ href: url }) }
        });
      } else {
        window.location.href = url;
      }
    } catch (error) {
      window.location.href = url;
    }
  }

  reinitializeAfterContentUpdate() {
    this.carousel = null;
    this.uspSwiper = null;

    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.carouselElementThumbs = this.element.querySelector(".main-product__thumbs");
    this.uspSwiperElement = this.element.querySelector(".product-usp__swiper.swiper");
    this.tintElement = this.element.querySelector('.ProductSlider--Tint');
    this.wrapperElement = this.element.querySelector('.main-product__slider');
    this.mainAtc = this.element.querySelector(".product-info__actions");
    this.stickyAtcWrapper = this.element.querySelector(".pdp-sticky-product-atc");
    this.valuesWrap = this.element.querySelectorAll(".ProductOption--ValusWrapper");

    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

    const slides = this.carouselElement?.querySelectorAll('.swiper-slide') || [];

    if (slides.length > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement, this.carouselElementThumbs);
    } else {
      const buttons = this.element.querySelectorAll('.pdp_swiperButton');
      buttons.forEach(btn => btn.style.display = 'none');
    }

    if (slides.length <= 1) {
      this.element.classList.add('has-single-image');
    } else {
      this.element.classList.remove('has-single-image');
    }

    if (this.options["enable_zoom"]) {
      setTimeout(() => {
        try {
          const zoom = new RevolutionImageZoom(this.element, this.carousel);
          zoom.syncHeight = zoom.syncHeight.bind(zoom);
          responsive.addResizeListener(zoom, zoom.syncHeight);
        } catch (err) {

        }
      }, 200);
    }

    if (this.uspSwiperElement) {
      this.uspSwiper = new RevolutionSwiper(this.uspSwiperElement);
    }

    new AddToCart(this.element);
    this.bindEvents();

    // ✅ IMPORTANT: mirror must be rebound after DOM swap
    this.setupQuantityMirror();

    if (this.options["sticky_atc"]) {
      document.body.classList.add('has-sticky');
      setTimeout(() => {
        if (this.stickyAtcWrapper) {
          this.showStickyAtc();
        }
      }, 200);
    } else {
      document.body.classList.remove('has-sticky');
    }

    requestAnimationFrame(() => {
      setTimeout(() => {
        this.syncThumbnailHeight();
      }, 100);
    });

    responsive.addResizeListener(this, this.syncThumbnailHeight);
    this.updatePriceButtonATC();
    this.scheduleAtcInlinePriceUpdate();
    this.initializeVariantImage();

    setTimeout(() => {
      const swiperEl = document.querySelector("#productSwiperElement");
      const awardsEl = document.querySelector(".product-awards_wrapper");

      if (swiperEl && awardsEl && swiperEl.swiper) {
        const swiper = swiperEl.swiper;
        const toggleAwards = () => {
          awardsEl.style.display = swiper.activeIndex === 0 ? "flex" : "none";
        };
        toggleAwards();
        swiper.on("slideChange", toggleAwards);
      }
    }, 100);

    const forms = this.element.querySelectorAll('form[data-product-form]');
    forms.forEach((form) => {
      const atcWrapper = form.querySelector('.add-to-cart__wrapper');
      const notifyWrapper = form.querySelector('.notify-wrapper');
      const idInput = form.querySelector('input[name="id"]');
      const variantId = idInput?.value;

      if (!variantId) return;

      const variantData = this.element.querySelector('variant-selects script[type="application/json"]');
      if (!variantData) return;

      try {
        const variants = JSON.parse(variantData.textContent);
        const currentVariant = variants.find(v => v.id == variantId);
        if (!currentVariant) return;

        if (currentVariant.available) {
          atcWrapper?.classList.remove('hideBtn');
          notifyWrapper?.classList.add('hideBtn');
        } else {
          atcWrapper?.classList.add('hideBtn');
          notifyWrapper?.classList.remove('hideBtn');
        }
      } catch (err) {
      }
    });
  }

  reloadPage(e) {
    window.location.reload();
  }

  // ========== EXISTING METHODS ==========

  updateImage(event) {
    let imageID = this.options.variant_image_id;
    if (event?.detail?.new_image) {
      imageID = event.detail.new_image;
    }
    const selector = "#Image--" + imageID;
    const imageEl = this.element.querySelector(selector);
    if (!imageEl) return;

    const slideElement = imageEl.closest('.swiper-slide');
    if (!slideElement) return;
    const realIndex = Array.from(slideElement.parentNode.children).indexOf(slideElement);

    if (this.carousel && this.carousel.swiperElement) {
      this.carousel.selectCell(realIndex);
    }
    
    // Upgrade the new active image after slide changes
    setTimeout(() => {
      this.changeImageQuality();
    }, 150);
  }

  syncThumbnailHeight() {
    if (window.matchMedia("(min-width: 1025px)").matches) {
      const mainWrapper = this.element.querySelector('.main-product__slider');
      const thumbsWrapper = this.element.querySelector('.main-product__thumbs-wrapper');
      if (mainWrapper && thumbsWrapper) {
        const img = mainWrapper.querySelector('.swiper-slide-active img.ProductSlider--Image');
        if (img && img.complete) {
          const h = img.getBoundingClientRect().height;
          thumbsWrapper.style.height = `${h}px`;
          thumbsWrapper.style.maxHeight = `${h}px`;
        }
      }
    }

    const mainWrapper = this.element.querySelector('.main-product__slider');
    const thumbsWrapper = this.element.querySelector('.main-product__thumbs-wrapper');
    const thumbsSwiper = this.element.querySelector('.main-product__thumbs.swiper')?.swiper;

    if (!mainWrapper || !thumbsWrapper) return;

    const getImageHeight = () => {
      const visibleImg = mainWrapper.querySelector('.swiper-slide-active img.ProductSlider--Image');
      return visibleImg ? visibleImg.getBoundingClientRect().height : 0;
    };

    const updateThumbHeight = () => {
      if (window.innerWidth < 1025) {
        thumbsWrapper.style.height = '';
        thumbsWrapper.style.maxHeight = '';
        thumbsWrapper.style.overflow = '';
        return;
      }

      const imgHeight = getImageHeight();
      if (imgHeight > 50 && imgHeight < window.innerHeight * 2) {
        thumbsWrapper.style.height = `${imgHeight}px`;
        thumbsWrapper.style.maxHeight = `${imgHeight}px`;
        thumbsWrapper.style.overflow = 'hidden';

        const innerSwiper = thumbsWrapper.querySelector('.swiper');
        if (innerSwiper) {
          innerSwiper.style.height = `${imgHeight}px`;
          innerSwiper.style.overflowY = 'auto';
        }

        thumbsSwiper?.update?.();
      }
    };

    updateThumbHeight();

    responsive.addResizeListener(this, updateThumbHeight);

    mainWrapper.querySelectorAll('img.ProductSlider--Image').forEach(img => {
      img.addEventListener('load', updateThumbHeight);
    });

    const mainSwiper = mainWrapper.querySelector('.swiper.mainSwiper')?.swiper;
    if (mainSwiper) mainSwiper.on('slideChangeTransitionEnd', updateThumbHeight);

    const observer = new ResizeObserver(updateThumbHeight);
    observer.observe(mainWrapper);
  }



  selectConnectedProductCard(event) {
    const clickedCard = event.target.closest(".pdp-connected-product-card");
    if (!clickedCard) return;

    const allCards = this.element.querySelectorAll(".pdp-connected-product-card");
    allCards.forEach(card => card.classList.remove("pdp-connected-product-card--selected"));

    clickedCard.classList.add("pdp-connected-product-card--selected");
  }

  updateTintOpacity() {
    const wrapperRect = this.wrapperElement.getBoundingClientRect();

    const overlapTop = Math.max(wrapperRect.top, infoRect.top);
    const overlapBottom = Math.min(wrapperRect.bottom, infoRect.bottom);
    const overlapHeight = Math.max(0, overlapBottom - overlapTop);

    const wrapperHeight = wrapperRect.height;
    const overlapRatio = Math.min(overlapHeight / wrapperHeight, 1);

    const scaledOpacity = Math.max(0, Math.min(overlapRatio * 2, 1));

    this.tintElement.style.opacity = scaledOpacity.toFixed(2);
  }

  calculateTotalPrice() {
    let total = 0;

    // If a subscription plan is active, use the plan-adjusted price instead
    // of the main PDP price element (which always stores the one-time price).
    const subPrice = this._getSubscriptionEffectivePrice();
    if (subPrice !== null) {
      total += subPrice;
    } else {
      const mainPriceEl = this.element.querySelector('[data-price].product-info__price--value');
      if (mainPriceEl) {
        const price = parseFloat(mainPriceEl.getAttribute("data-price"));
        total += isNaN(price) ? 0 : price;
      }
    }

    const checkedAddons = this.element.querySelectorAll('.pdp-addon-product-card__checkbox:checked[data-price]');
    checkedAddons.forEach(input => {
      const price = parseFloat(input.getAttribute("data-price")) || 0;
      total += price;
    });

    const checkedAccessories = this.element.querySelectorAll('.pdp-accessory-product-card__checkbox:checked[data-price]');
    checkedAccessories.forEach(input => {
      const price = parseFloat(input.getAttribute("data-price")) || 0;
      const productId = input.getAttribute("data-productid");
      const qtyInput = this.element.querySelector(`.quantity-input[data-productid="${productId}"]`);
      const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      total += price * qty;
    });

    return total;
  }

  updatePriceButtonATC() {
    const total = this.calculateTotalPrice();
    const formatted = Shopify.formatMoney(total, window.theme.moneyFormat);

    this.element.querySelectorAll(".product__atc-button .button-total-price").forEach(span => {
      const button = span.closest(".product__atc-button");
      if (button && button.hasAttribute("disabled")) return;

      span.textContent = ` - ${formatted}`;
    });
  }

  hideStickyTimeout() {
    this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
    this.hideSticky = true;
    setTimeout(() => {
      this.hideSticky = false;
      this.showStickyAtc();
    }, 3000);
  }

  showStickyAtc() {
    if (!this.stickyAtcWrapper || this.hideSticky) return;

    const footer = document.querySelector("footer");

    if (window.matchMedia("(min-width: 1025px)").matches) {
      if (this._desktopStickyBound) return;
      this._desktopStickyBound = true;

      const onScroll = () => {
        if (this.hideSticky) return;

        const showAfter = 150;
        const shouldShow = window.scrollY > showAfter;

        let atTheBottom = false;
        if (footer) {
          const footerHeight = footer.offsetHeight;
          atTheBottom =
            window.innerHeight + window.scrollY >=
            document.body.offsetHeight - footerHeight + 60;
        } else {
          atTheBottom =
            window.innerHeight + window.scrollY >=
            document.body.offsetHeight - 100;
        }

        this.toggleStickyAtc(shouldShow && !atTheBottom);
      };

      this._desktopStickyScrollHandle = scrollListener.addScrollListener(this, onScroll);
      responsive.addResizeListener(this, onScroll);

      // initial state
      onScroll();
      return;
    }

    // --- Mobile behavior (<1025): keep your IntersectionObserver logic ---
    const mainAtc = this.mainAtc;
    if (!mainAtc) return;

    // prevent multiple observers
    if (this._atcObserver) {
      try { this._atcObserver.disconnect(); } catch (e) { }
    }

    this._atcObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const isVisible = entry.isIntersecting;

        let atTheBottom = false;

        if (footer) {
          const footerHeight = footer.offsetHeight;
          atTheBottom =
            window.innerHeight + window.scrollY >=
            document.body.offsetHeight - footerHeight + 60;
        } else {
          atTheBottom =
            window.innerHeight + window.scrollY >=
            document.body.offsetHeight - 100;
        }

        if (atTheBottom) {
          this.toggleStickyAtc(false);
        } else {
          this.toggleStickyAtc(!isVisible);
        }
      });
    }, {
      root: null,
      threshold: 0
    });

    this._atcObserver.observe(mainAtc);

    // keep your bottom check on scroll (but don’t stack endlessly)
    if (!this._mobileBottomScrollBound) {
      this._mobileBottomScrollBound = true;
      const mobileBottomCheck = () => {
        let atTheBottom = false;

        if (footer) {
          const footerHeight = footer.offsetHeight;
          atTheBottom =
            window.innerHeight + window.scrollY >=
            document.body.offsetHeight - footerHeight;
        } else {
          atTheBottom =
            window.innerHeight + window.scrollY >=
            document.body.offsetHeight - 100;
        }

        if (atTheBottom) {
          this.toggleStickyAtc(false);
        } else if (mainAtc) {
          const rect = mainAtc.getBoundingClientRect();
          const mainAtcHidden = rect.bottom < 0 || rect.top > window.innerHeight;
          if (mainAtcHidden) this.toggleStickyAtc(true);
        }
      };
      this._mobileBottomScrollHandle = scrollListener.addScrollListener(this, mobileBottomCheck);
    }
  }


  toggleStickyAtc(show) {
    if (this.hideSticky) return;
    this.stickyAtcWrapper.setAttribute("aria-hidden", show ? "false" : "true");
    document.body.classList.toggle("has-sticky", show);
  }

  initializeVariantImage() {
    this._doInitializeVariantImage();
  }

  _doInitializeVariantImage() {
    // Immediately upgrade all eagerly loaded images (first + variant)
    this.upgradeEagerImages();

    // After eager images upgrade, tell Swiper to recalculate layout
    // so slide dimensions are correct for the full-size images
    if (this.carousel && this.carousel.swiperElement) {
      this.carousel.swiperElement.update();
    }

    // Then navigate to variant slide if needed
    if (!this.options.variant_image_id) return;

    const selector = "#Image--" + this.options.variant_image_id;
    const imageEl = this.element.querySelector(selector);
    if (!imageEl) return;

    const slideElement = imageEl.closest('.swiper-slide');
    if (!slideElement) return;
    const realIndex = Array.from(slideElement.parentNode.children).indexOf(slideElement);

    // If Swiper already started on this slide (via initialSlide), skip navigation
    if (this.carousel && this.carousel.swiperElement &&
        this.carousel.swiperElement.activeIndex === realIndex) return;

    // If it's the first slide, nothing to navigate to
    if (realIndex === 0) return;

    // Navigate to variant slide when carousel is ready
    const navigateToVariant = () => {
      if (this.carousel && this.carousel.swiperElement) {
        this.carousel.selectCell(realIndex);
      } else {
        // Carousel not ready, try again
        setTimeout(navigateToVariant, 50);
      }
    };

    setTimeout(navigateToVariant, 50);
  }

  upgradeEagerImages() {
    // Upgrade all images with loading="eager" (first image + variant image)
    const eagerImages = this.element.querySelectorAll('img[loading="eager"][data-src]');
    eagerImages.forEach(img => {
      const replaceUrl = img.getAttribute("data-src")?.replace("{width}x", "2600x");
      if (replaceUrl) img.src = replaceUrl;
    });
  }

  changeImageQuality() {
    // Upgrade currently active slide image
    const activeSlide = this.element.querySelector(".swiper-slide-active img[data-src]");
    if (activeSlide) {
      const activeUrl = activeSlide.getAttribute("data-src")?.replace("{width}x", "2600x");
      if (activeUrl) activeSlide.src = activeUrl;
    }
  }

  runPDPAnimations() {
    const items = this.element.querySelectorAll("[data-animation]:not([data-loaded])");

    items.forEach((item, i) => {
      const type = item.dataset.animation;

      const animations = {
        elementFadeIn: [
          { opacity: 0 },
          { opacity: 1 }
        ],
        elementFromTop: [
          { transform: "translateY(-30px)", opacity: 0 },
          { transform: "translateY(0)", opacity: 1 }
        ],
        elementFromBottom: [
          { transform: "translateY(30px)", opacity: 0 },
          { transform: "translateY(0)", opacity: 1 }
        ]
      };

      const keyframes = animations[type] || animations.elementFadeIn;

      item.setAttribute("data-loaded", "true");

      setTimeout(() => {
        item.animate(keyframes, {
          duration: window.theme.animationDuration || 400,
          fill: "forwards"
        });
      }, (window.theme.animationBetweenElements || 50) * i);
    });
  }
}

customElements.define("product-component", ProductElement);

class VariantSelectBox extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this._resizeHandler = null;
  }

  connectedCallback() {
    this.selectBoxWrapper =
      this.selectBoxWrapper ||
      this.querySelector(".variant-selectbox__items") ||
      this.querySelector(".RevolutionSelectbox") ||
      this;

    this.variants =
      this.variants ||
      Array.from(this.querySelectorAll("[data-variant-item], .variant-item, .Selectbox, .RevolutionSelectbox--Item")).filter(Boolean);

    this.plusButton = this.plusButton || this.querySelector('[data-action="show-more"]');
    this.minusButton = this.minusButton || this.querySelector('[data-action="show-less"]');
    this.totalVariants = this.variants?.length || 0;

    this.observeResize();
    this.bindEvents();
    this.calculateLayout();
  }

  disconnectedCallback() {
    try {
      this.delegateElement?.off?.();
    } catch (e) { }
    this.delegateElement = null;

    if (typeof responsive !== "undefined" && responsive.removeResizeListener) {
      try {
        responsive.removeResizeListener(this, this.handleResize);
      } catch (e) { }
    } else if (this._resizeHandler) {
      window.removeEventListener("resize", this._resizeHandler);
    }
    this._resizeHandler = null;
  }

  observeResize() {
    this.handleResize = this.handleResize.bind(this);

    if (typeof responsive !== "undefined" && responsive.addResizeListener) {
      responsive.addResizeListener(this, this.handleResize);
    } else {
      this._resizeHandler = debounce(this.handleResize, 150);
      window.addEventListener("resize", this._resizeHandler);
    }
  }

  bindEvents() {
    if (!this.selectBoxWrapper) return;

    try {
      this.delegateElement?.off?.();
    } catch (e) { }

    this.delegateElement = new Delegate(this.selectBoxWrapper);
    this.delegateElement.on("click", '[data-action="show-more"]', this.showAllVariants.bind(this));
    this.delegateElement.on("click", '[data-action="show-less"]', this.showLessVariants.bind(this));
  }

  calculateLayout() {
    if (!this.selectBoxWrapper || !this.variants || !this.variants.length) {
      if (this.plusButton) this.plusButton.style.display = "none";
      if (this.minusButton) this.minusButton.style.display = "none";
      return;
    }

    this.variants.forEach((variant) => {
      variant.style.display = "";
    });
    if (this.plusButton) this.plusButton.style.display = "";
    if (this.minusButton) this.minusButton.style.display = "none";

    const availableWidth = this.selectBoxWrapper.offsetWidth;
    if (!availableWidth) return;

    this.totalVariants = this.variants.length;

    const singleVariantWidth = this.variants[0].offsetWidth || 0;
    const variantGap = 8;
    const plusButtonWidth = this.plusButton ? this.plusButton.offsetWidth : 0;

    let itemsInFirstRow = 0;
    let totalWidthSoFar = 0;

    for (let i = 0; i < this.variants.length; i++) {
      const widthNeeded = variantGap + singleVariantWidth;
      const stillMoreVariantsRemain = i < this.variants.length - 1;
      const spaceNeededForPlus = stillMoreVariantsRemain ? plusButtonWidth : 0;

      if (totalWidthSoFar + widthNeeded + spaceNeededForPlus <= availableWidth) {
        itemsInFirstRow++;
        totalWidthSoFar += widthNeeded;
      } else {
        break;
      }
    }

    if (itemsInFirstRow >= this.totalVariants) {
      if (this.plusButton) this.plusButton.style.display = "none";
      if (this.minusButton) this.minusButton.style.display = "none";
    } else {
      this.variants.forEach((variant, idx) => {
        variant.style.display = idx < itemsInFirstRow ? "" : "none";
      });

      if (this.plusButton) {
        this.remaining = this.totalVariants - itemsInFirstRow;
        this.plusButton.style.display = "";
        this.plusButton.innerText = `+ ${this.remaining} more`;
      }
      if (this.minusButton) this.minusButton.style.display = "none";
    }
  }

  handleResize() {
    this.calculateLayout();
  }

  showAllVariants(event) {
    event?.preventDefault?.();
    (this.variants || []).forEach((variant) => {
      variant.style.display = "";
    });
    if (this.plusButton) this.plusButton.style.display = "none";
    if (this.minusButton) {
      const remaining = this.remaining ?? Math.max(0, (this.totalVariants || 0) - 1);
      this.minusButton.innerText = `- ${remaining} less`;
      this.minusButton.style.display = "";
    }
  }

  showLessVariants(event) {
    event?.preventDefault?.();
    this.calculateLayout();
  }
}

customElements.define("variant-selectbox", VariantSelectBox);

/* =========================
   variant-selects (THIS is the main fix)
   - supports options[...] inputs
   - scopes everything to the current product-component
   - after renderProductInfo swap: re-applies JS price attributes
   - dispatches variant:price-updated reliably
   ========================= */
class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");

    this.isUpsell =
      this.element.classList.contains("upsell-variants") ||
      !!this.closest(".upsell-product") ||
      !!this.closest("form.upsell-form");

    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this._availabilitySyncing = false;

    // ✅ lowest price animation state
    this._lastHadLowest = null;

    // (if you also use these)
    // this._hasHydrated = false;
    // this._lastVariantId = null;

    this._onChange = this.onVariantChange.bind(this);
    this._onClickAtc = this.clickAtc.bind(this);
    this._onQtyBtnClick = () => this.initAccessoryStateSync?.();

    this.bindEvents();
  }


  connectedCallback() {
    if (!this.isUpsell) this.preselectFromUrlOrInput();

    queueMicrotask(() => {
      // initial run (NO animation)
      this.onVariantChange();

      // mark hydrated after first paint so later changes animate
      requestAnimationFrame(() => {
        this._hasHydrated = true;
        this._lastVariantId = this.currentVariant?.id || null;
        document.dispatchEvent(new CustomEvent("variant:price-updated"));
      });
    });
  }

  disconnectedCallback() {
    try { this.delegateElement?.off?.(); } catch (e) { }
    try { this.delegateBody?.off?.(); } catch (e) { }
    this.delegateElement = null;
    this.delegateBody = null;
  }

  getRoot() {
    return this.closest("product-component") || document;
  }

  refreshUIRefs() {
    const root = this.getRoot();
    this.atcButtons = root.querySelectorAll(".product__atc-button");
    this.notifyButtons = root.querySelectorAll(".product-module__product-atc-notify");
    this.stickyAtcWrapper = root.querySelector(".product-module__sticky-atc, .pdp-sticky-product-atc");
    this.notifyStickyAddButton = root.querySelector(".product-module__product-atc");
    this.pricesWrapper = root.querySelector(".product-info__price");
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      'select, input, input[name^="options["], select[name^="options["]',
      this._onChange
    );

    if (!this.isUpsell) {
      this.delegateBody.on("click", '[data-action="click-atc"]', this._onClickAtc);
      this.delegateElement.on("click", ".quantity-btn.increase, .quantity-btn.decrease", this._onQtyBtnClick);
    }
  }

  clickAtc(event) {
    event.preventDefault();
    const root = this.getRoot();
    const btn = root.querySelector(".product-info__actions .product__atc-button");
    if (btn) btn.click();
  }

  setNoVariantsFlag() {
    const root = this.closest("product-component");
    if (!root) return;

    const data = this.getVariantData();
    const noVariants = !Array.isArray(data) || data.length <= 1;
    root.dataset.noVariants = noVariants ? "true" : "false";
  }

  preselectFromUrlOrInput() {
    const data = this.getVariantData();
    if (!Array.isArray(data) || !data.length) return;

    const root = this.getRoot();

    const urlVariantId = new URL(window.location.href).searchParams.get("variant");
    let targetVariant = urlVariantId
      ? data.find((v) => String(v.id) === String(urlVariantId))
      : null;

    if (!targetVariant) {
      const input = root.querySelector(`#product-form-${this.productID} input[name="id"]`);
      const currentId = input?.value;
      targetVariant = currentId ? data.find((v) => String(v.id) === String(currentId)) : null;
    }

    if (!targetVariant || !targetVariant.available) {
      targetVariant = data.find((v) => v.available) || data[0];
    }

    if (!targetVariant) return;

    const optionInputs = root.querySelectorAll('input[name^="options["], select[name^="options["]');
    if (optionInputs.length) {
      (targetVariant.options || []).forEach((optValue, idx) => {
        const radios = root.querySelectorAll(`input[name="options[${idx}]"][type="radio"]`);
        if (radios.length) {
          const match = Array.from(radios).find((r) => r.value === optValue);
          if (match) match.checked = true;
        } else {
          const select = root.querySelector(`select[name="options[${idx}]"]`);
          if (select) select.value = optValue;
        }
      });
    } else {
      (targetVariant.options || []).forEach((optValue, idx) => {
        const position = idx + 1;
        const radios = this.querySelectorAll(
          `input[type="radio"][name="option-${this.productID}-${position}"]`
        );
        if (radios?.length) {
          const match = Array.from(radios).find((r) => r.value === optValue);
          if (match) match.checked = true;
        } else {
          const selects = this.querySelectorAll("select");
          if (selects && selects[idx]) selects[idx].value = optValue;
        }
      });
    }

    root.querySelectorAll('form[data-product-form] input[name="id"]').forEach((inp) => {
      // Guard: only touch inputs that belong to the same product.
      // Multiple forms (main + upsell) can live inside one product-component.
      if (this.productID) {
        const inputProductId = inp.getAttribute("data-productid") || inp.closest("form")?.getAttribute("data-product-id");
        if (inputProductId && String(inputProductId) !== String(this.productID)) return;
      }
      inp.value = targetVariant.id;
      inp.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  onVariantChange() {
    if (!this.isUpsell) this.refreshUIRefs();

    this.updateOptions();
    this.updateOptionAvailability();
    this.updateMasterId();
    if (!this.currentVariant) return;

    // ✅ Prevent double-runs per variant id (optional but recommended)
    const currentId = String(this.currentVariant.id);
    if (this._lastProcessedVariantId === currentId) return;
    this._lastProcessedVariantId = currentId;

    this.updateSelectedTexts();

    if (this.isUpsell) {
      this.updateUpsellAvailabilityUI();
      return;
    }

    this.updateVariantInput();

    // ✅ animate only after initial load + only when variant id changes
    const prevId = this._lastVariantId ? String(this._lastVariantId) : null;
    const shouldAnimateLowest = !!(this._hasHydrated && prevId && prevId !== currentId);

    // ✅ remember previous had-lowest state (used to force fade-in)
    const prevHadLowest = this._lastHadLowest;

    // update ids for next run
    this._lastVariantId = currentId;

    this.toggleAddButton();
    this.updateAvailability();
    this.updatePdpPricesUI();
    this.updateStickyAtcUI();
    this.updateStockUI();

    this.updateMedia();
    this.updateURL();

    // ✅ swap + animate inside renderProductInfo
    this.renderProductInfo({
      animateLowest: shouldAnimateLowest,
      prevHadLowest: prevHadLowest
    });

    document.dispatchEvent(new CustomEvent("variant:price-updated"));

    queueMicrotask(() => {
      if (this._lastProcessedVariantId === currentId) this._lastProcessedVariantId = null;
    });
  }



  updateOptions() {
    const root = this.getRoot();

    const radios = Array.from(root.querySelectorAll('input[name^="options["]:checked')).map((el) => el.value);
    const selects = Array.from(root.querySelectorAll('select[name^="options["]')).map((el) => el.value);

    if (radios.length || selects.length) {
      this.options = radios.length ? radios : selects;
      return;
    }

    this.options = Array.from(this.querySelectorAll("select, input:checked"), (el) => el.value);
  }

  updateMasterId() {
    const data = this.getVariantData();
    if (!Array.isArray(data) || !data.length) {
      this.currentVariant = null;
      return null;
    }

    const opts = Array.isArray(this.options) ? this.options : [];
    if (!opts.length) {
      this.currentVariant = null;
      return null;
    }

    this.currentVariant =
      data.find((v) => {
        if (!v) return false;
        if (Array.isArray(v.options) && v.options.length) {
          return v.options.every((val, idx) => (opts[idx] ? opts[idx] === val : true));
        }
        return (
          (!v.option1 || v.option1 === opts[0]) &&
          (!v.option2 || v.option2 === opts[1]) &&
          (!v.option3 || v.option3 === opts[2])
        );
      }) || null;

    return this.currentVariant;
  }

  updateOptionAvailability() {
    if (this._availabilitySyncing) return;

    const data = this.getVariantData();
    if (!Array.isArray(data) || !data.length) return;

    const optionCount = data[0]?.options?.length || 0;
    if (!optionCount) return;

    const selections = Array.isArray(this.options) ? [...this.options] : [];

    const isOptionValueAvailable = (positionIndex, value) => {
      for (let i = 0; i < data.length; i++) {
        const v = data[i];
        if (!v || !v.available) continue;
        if (v.options[positionIndex] !== value) continue;

        let ok = true;
        for (let p = 0; p < optionCount; p++) {
          if (p === positionIndex) continue;
          const sel = selections[p];
          if (sel && v.options[p] !== sel) {
            ok = false;
            break;
          }
        }
        if (ok) return true;
      }
      return false;
    };

    for (let pos = 0; pos < optionCount; pos++) {
      const root = this.getRoot();
      const radios =
        root.querySelectorAll(`input[type="radio"][name="options[${pos}]"]`).length
          ? root.querySelectorAll(`input[type="radio"][name="options[${pos}]"]`)
          : this.querySelectorAll(`input[type="radio"][name="option-${this.productID}-${pos + 1}"]`);

      if (radios && radios.length) {
        radios.forEach((input) => {
          const available = isOptionValueAvailable(pos, input.value);
          input.disabled = false;

          const wrapper = input.closest(".Selectbox");
          if (wrapper) wrapper.classList.toggle("is-disabled", !available);

          const label =
            root.querySelector(`label[for="${input.id}"]`) ||
            this.querySelector(`label[for="${input.id}"]`);
          if (label) label.setAttribute("aria-disabled", (!available).toString());
        });

        continue;
      }

      const selects =
        root.querySelectorAll(`select[name="options[${pos}]"]`).length
          ? root.querySelectorAll(`select[name="options[${pos}]"]`)
          : this.querySelectorAll("select");

      const select = selects && selects[pos] ? selects[pos] : null;
      if (select) {
        Array.from(select.options).forEach((opt) => {
          const available = isOptionValueAvailable(pos, opt.value);
          opt.disabled = false;

          const wrapper = select.closest(".Selectbox");
          if (wrapper) wrapper.classList.toggle("is-disabled", !available);
        });
      }
    }
  }

  updateVariantInput() {
    if (!this.currentVariant) return;

    const root = this.getRoot();
    const inputs = root.querySelectorAll('form[data-product-form] input[name="id"]');
    inputs.forEach((inp) => {
      // Guard: only touch inputs that belong to the same product.
      // Multiple forms (main + upsell) can live inside one product-component.
      if (this.productID) {
        const inputProductId = inp.getAttribute("data-productid") || inp.closest("form")?.getAttribute("data-product-id");
        if (inputProductId && String(inputProductId) !== String(this.productID)) return;
      }
      inp.value = this.currentVariant.id;
      inp.dispatchEvent(new Event("change", { bubbles: true }));
    });

    document.dispatchEvent(
      new CustomEvent("variant:id-changed", {
        detail: { productId: this.productID, variantId: this.currentVariant.id }
      })
    );
  }

  updateUpsellAvailabilityUI() {
    const wrapper = this.closest(".upsell-product");
    const form =
      wrapper?.querySelector("form.upsell-form") ||
      this.closest("form.upsell-form") ||
      this.closest("form");
    if (!form) return;

    const submit = form.querySelector('button[type="submit"], [type="submit"]');
    if (!submit) return;

    submit.disabled = !this.currentVariant.available;

    // Update upsell prices
    if (!this.currentVariant) return;
    
    const pricingContainer = wrapper?.querySelector(".upsell-pricing");
    if (!pricingContainer) return;

    const moneyFormat = window.theme?.moneyFormat || "{{amount}}";
    const currentPrice = this.currentVariant.price;
    const comparePrice = this.currentVariant.compare_at_price;

    // Clear existing content
    pricingContainer.innerHTML = "";

    if (comparePrice && comparePrice > currentPrice) {
      // Show both compare and sale price
      const compareSpan = document.createElement("span");
      compareSpan.className = "price--compare u-p4";
      compareSpan.textContent = Shopify.formatMoney(comparePrice, moneyFormat);
      
      const saleSpan = document.createElement("span");
      saleSpan.className = "price--sale u-p4";
      saleSpan.textContent = Shopify.formatMoney(currentPrice, moneyFormat);
      
      pricingContainer.appendChild(compareSpan);
      pricingContainer.appendChild(document.createTextNode(" "));
      pricingContainer.appendChild(saleSpan);
    } else {
      // Show regular price only
      const priceSpan = document.createElement("span");
      priceSpan.className = "price u-p4";
      priceSpan.textContent = Shopify.formatMoney(currentPrice, moneyFormat);
      
      pricingContainer.appendChild(priceSpan);
    }

    // Update upsell image
    if (this.currentVariant.featured_image?.src) {
      const upsellImage = wrapper?.querySelector("[data-upsell-image]");
      if (upsellImage) {
        // Get the image URL with proper sizing
        const imageUrl = this.currentVariant.featured_image.src.replace(/\.(jpg|jpeg|png|gif|webp)/, '_400x.$1');
        upsellImage.src = imageUrl;
        upsellImage.alt = this.currentVariant.featured_image.alt || this.currentVariant.name || "";
      }
    }
  }

  updatePdpPricesUI() {
    if (!this.currentVariant) return;

    const root = this.getRoot();
    const priceValueEls = root.querySelectorAll(".product-info__price--value");
    const compareEls = root.querySelectorAll(".product-info__price--compare");
    if (!priceValueEls.length) return;

    const moneyFormat = window.theme?.moneyFormat || "{{amount}}";

    priceValueEls.forEach((el) => {
      el.setAttribute("data-price", String(this.currentVariant.price));
      el.textContent = Shopify.formatMoney(this.currentVariant.price, moneyFormat);
    });

    const compare = this.currentVariant.compare_at_price;
    compareEls.forEach((el) => {
      if (compare && compare > this.currentVariant.price) {
        el.style.display = "";
        el.textContent = Shopify.formatMoney(compare, moneyFormat);
        el.setAttribute("data-price", String(compare));
      } else {
        el.textContent = "";
        el.removeAttribute("data-price");
        el.style.display = "none";
      }
    });
  }

  updateStickyAtcUI() {
    if (!this.currentVariant) return;

    const root = this.getRoot();
    const stickyRoot = root.querySelector(".product-module__sticky-atc, .pdp-sticky-product-atc");
    if (!stickyRoot) return;

    const moneyFormat = window.theme?.moneyFormat || "{{amount}}";

    stickyRoot
      .querySelectorAll(".product-module__price--current")
      .forEach((el) => (el.textContent = Shopify.formatMoney(this.currentVariant.price, moneyFormat)));

    const compare = this.currentVariant.compare_at_price;
    stickyRoot.querySelectorAll(".product-module__price--compare").forEach((el) => {
      if (compare && compare > this.currentVariant.price) {
        el.style.display = "";
        el.textContent = Shopify.formatMoney(compare, moneyFormat);
      } else {
        el.style.display = "none";
        el.textContent = "";
      }
    });

    const variantTitle =
      this.currentVariant.public_title && this.currentVariant.public_title !== "Default Title"
        ? this.currentVariant.public_title
        : this.currentVariant.title !== "Default Title"
          ? this.currentVariant.title
          : "";

    stickyRoot.querySelectorAll("[data-sticky-variant-title]").forEach((el) => {
      el.textContent = variantTitle;
      el.style.display = variantTitle ? "" : "none";
    });
  }

  updateStockUI() {
    if (!this.currentVariant) return;

    const root = this.getRoot();
    const stockEls = root.querySelectorAll(".product-info__stock");
    if (!stockEls.length) return;

    const inStockText = window.theme?.strings?.inStock || "In stock";
    const outOfStockText = window.theme?.strings?.outOfStock || "Out of stock";

    stockEls.forEach((el) => {
      if (this.currentVariant.available) {
        el.classList.remove("out-of-stock");
        el.classList.add("in-stock");
        el.innerHTML = `<span class="stock_indicator product_avaiable"></span>${inStockText}`;
      } else {
        el.classList.remove("in-stock");
        el.classList.add("out-of-stock");
        el.innerHTML = `<span class="stock_indicator product_unavaiable"></span>${outOfStockText}`;
      }
    });
  }

  updateAvailability() {
    const availableSuccessDiv = document.querySelector(".availability-success__wrapper");
    const availableErrorDiv = document.querySelector(".availability-error__wrapper");

    if (!this.currentVariant) return;

    if (this.currentVariant.available) {
      if (availableSuccessDiv) availableSuccessDiv.setAttribute("aria-hidden", "false");
      if (availableErrorDiv) availableErrorDiv.setAttribute("aria-hidden", "true");
    } else {
      if (availableSuccessDiv) availableSuccessDiv.setAttribute("aria-hidden", "true");
      if (availableErrorDiv) availableErrorDiv.setAttribute("aria-hidden", "false");
    }
  }

  updateMedia() {
    if (this.isUpsell) return;
    if (!this.currentVariant?.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;

    this.element.dispatchEvent(
      new CustomEvent("variant:changed", { bubbles: true, detail: { new_image: newMedia } })
    );
  }

  updateURL() {
    if (this.isUpsell) return;
    if (!this.currentVariant) return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateLowestPriceIn(container, { animate = false, prevHadLowest = null } = {}) {
    if (!this.currentVariant || !container) return;

    const wrapper = container.querySelector("[data-lowest-wrapper]");
    const valueEl = container.querySelector("[data-lowest-value]");
    if (!wrapper || !valueEl) return;

    // "Has lowest" comes from actual rendered value text
    const hasLowest = !!(valueEl.textContent || "").trim();

    // persist for next variant change
    this._lastHadLowest = hasLowest;

    const setHidden = () => {
      wrapper.classList.remove("is-showing");
      wrapper.classList.add("is-hidden");
      wrapper.setAttribute("aria-hidden", "true");
    };

    const setShowing = () => {
      wrapper.classList.remove("is-hidden");
      wrapper.classList.add("is-showing"); // stays while visible
      wrapper.setAttribute("aria-hidden", "false");
    };

    // first run: no animation
    if (!animate || prevHadLowest === null) {
      hasLowest ? setShowing() : setHidden();
      return;
    }

    // exit
    if (prevHadLowest && !hasLowest) {
      setHidden();
      return;
    }

    // enter (force a real transition)
    if (!prevHadLowest && hasLowest) {
      setHidden();          // ensure we start hidden
      wrapper.offsetHeight; // force reflow
      requestAnimationFrame(() => setShowing());
      return;
    }

    // steady states
    hasLowest ? setShowing() : setHidden();
  }



  renderProductInfo({ animateLowest = false, prevHadLowest = null } = {}) {
    if (this.isUpsell) return;
    if (!this.currentVariant?.id) return;

    const DURATION = 330;
    const root = this.getRoot();
    const selector = ".ProductInfo--Prices";

    const baseUrl = new URL(this.dataset.url, window.location.origin);
    baseUrl.searchParams.set("variant", String(this.currentVariant.id));
    baseUrl.searchParams.set("section_id", String(this.dataset.section));

    // grab current destinations + keep the CURRENT wrapper nodes so they survive innerHTML swap
    const destinationsBefore = Array.from(root.querySelectorAll(selector));
    const persistentWrappers = destinationsBefore.map(d => d.querySelector("[data-lowest-wrapper]"));

    // helper: does the fetched HTML contain a lowest value?
    const fetchedHasLowest = (docEl) => {
      const val = docEl?.querySelector?.("[data-lowest-value]");
      return !!(val?.textContent || "").trim();
    };

    fetch(baseUrl.toString(), { credentials: "same-origin" })
      .then(r => r.text())
      .then((responseText) => {
        const doc = new DOMParser().parseFromString(responseText, "text/html");
        const source = doc.querySelector(selector);
        if (!source) return;

        const nextHasLowest = fetchedHasLowest(source);

        // If we need EXIT animation, run it on the existing nodes BEFORE swapping
        if (animateLowest && prevHadLowest === true && nextHasLowest === false) {
          destinationsBefore.forEach((dest) => {
            this.updateLowestPriceIn(dest, { animate: true, prevHadLowest: true });
          });
        }

        const doSwap = () => {
          const destinations = Array.from(root.querySelectorAll(selector));
          if (!destinations.length) return;

          // swap html
          destinations.forEach((dest) => {
            dest.innerHTML = source.innerHTML;
          });

          // restore persistent wrapper nodes + copy new inner content into them
          destinations.forEach((dest, i) => {
            const keep = persistentWrappers[i];
            if (!keep) return;

            const newWrapper = dest.querySelector("[data-lowest-wrapper]");
            if (!newWrapper) return;

          // copy new content into the kept node, then replace
          keep.innerHTML = newWrapper.innerHTML;
          newWrapper.replaceWith(keep);
        });

        // No need to update prices again - server HTML already has them formatted
        // and onVariantChange() already updated them before this fetch

        // animate after swap (ENTER + steady)
        requestAnimationFrame(() => {
            const destinationsAfter = Array.from(root.querySelectorAll(selector));
            destinationsAfter.forEach((dest) => {
              this.updateLowestPriceIn(dest, { animate: animateLowest, prevHadLowest });
            });
          });

          // No need to dispatch here - onVariantChange already dispatches it
        };

        // delay swap only when doing exit animation
        if (animateLowest && prevHadLowest === true && nextHasLowest === false) {
          setTimeout(doSwap, DURATION);
        } else {
          doSwap();
        }
      })
      .catch(() => {
        // don't break other UI if fetch fails
        this.updatePdpPricesUI();
        this.toggleAddButton();
        this.updateStickyAtcUI();
        document.dispatchEvent(new CustomEvent("variant:price-updated"));
      });
  }



  toggleAddButton() {
    if (!this.currentVariant || this.isUpsell) return;

    const root = this.getRoot();
    const available = !!this.currentVariant.available;

    root.querySelectorAll(".Quantity-ATC--wrapper").forEach((w) => {
      w.classList.toggle("is-in-stock", available);
      w.classList.toggle("is-oos", !available);
    });

    const targets = [
      root.querySelector(".product-info__actions"),
      root.querySelector(".product-module__sticky-atc, .pdp-sticky-product-atc")
    ].filter(Boolean);

    targets.forEach((scope) => {
      scope.querySelectorAll(".add-to-cart__wrapper, .QuantityHandler").forEach((el) => {
        el.classList.remove("hideBtn");
        el.setAttribute("aria-hidden", "false");
      });

      scope.querySelectorAll(".notify-wrapper").forEach((el) => {
        el.classList.toggle("hideBtn", available);
        el.setAttribute("aria-hidden", available ? "true" : "false");
      });

      scope.querySelectorAll('button[type="submit"], .product__atc-button').forEach((btn) => {
        btn.disabled = !available;
        btn.setAttribute("aria-disabled", !available ? "true" : "false");
      });

      scope.querySelectorAll('input[name="quantity"], button[name="plus"], button[name="minus"]').forEach((el) => {
        el.disabled = !available;
      });
    });

    root.querySelectorAll(".product__atc-button").forEach((btn) => {
      const labelNode = btn.querySelector(".button-txt") || btn.querySelector(".ButtonText");
      if (!labelNode) return;

      Array.from(labelNode.childNodes).forEach((n) => {
        if (n.nodeType === Node.TEXT_NODE) n.remove();
      });

      const inline = labelNode.querySelector(".atc-price-inline");
      const totalInLabel = labelNode.querySelector(".button-total-price");

      if (!available) {
        if (inline) inline.remove();
        if (totalInLabel) totalInLabel.textContent = "";
        return;
      }

      labelNode.insertBefore(
        document.createTextNode((window.variantStrings?.addToCart || "ADD TO CART").toUpperCase()),
        labelNode.firstChild
      );

      if (inline && !labelNode.contains(inline)) labelNode.appendChild(inline);
      if (totalInLabel && !labelNode.contains(totalInLabel)) labelNode.appendChild(totalInLabel);
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateSelectedTexts() {
    if (!this.currentVariant) return;

    this.querySelectorAll("[data-selected-text]").forEach((el) => {
      const index = parseInt(el.getAttribute("data-option-index"), 10);
      const value = this.currentVariant.options[index];
      if (value) el.textContent = value;
    });
  }
}

customElements.define("variant-selects", VariantSelects);


class NotifyMePopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(document.body);

    this._closeTimer = null;
    this._isClosing = false;

    this._onVariantIdChanged = (e) => {
      const popup = this.element.querySelector(".notify-me__popup-wrapper");
      if (!popup) return;
      const { variantId } = e.detail;
      if (variantId) popup.setAttribute("variant-value", String(variantId));
    };
    document.addEventListener("variant:id-changed", this._onVariantIdChanged);

    this.bindEvents();
  }

  disconnectedCallback() {
    if (this._onVariantIdChanged) {
      document.removeEventListener("variant:id-changed", this._onVariantIdChanged);
      this._onVariantIdChanged = null;
    }
  }

  bindEvents() {
    this.delegateElement.on("submit", ".notify-me__popup-inputs", (e) => {
      this.submitNotifyMe(e);
    });

    // Open (sold out button)
    this.delegateElement.on(
      "click",
      '[data-action="toggle-popup"][aria-controls="notify-me-popup"]',
      (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
        this.openPopup();
      }
    );

    // CLOSE — overlay + X use the SAME handler
    this.delegateElement.on("click", ".notify-me__overlay", (e) => {
      e.preventDefault();
      this._requestClose(e);
    });

    this.delegateElement.on("click", ".notify-me__close-btn", (e) => {
      e.preventDefault();
      this._requestClose(e);
    });
  }

  _getPopupEl() {
    // Prefer within this instance
    return this.element.querySelector("#notify-me-popup") || document.getElementById("notify-me-popup");
  }

  _getOverlayEl() {
    return this.element.querySelector(".notify-me__overlay") || document.querySelector(".notify-me__overlay");
  }

  _clearCloseState(popup) {
    this._isClosing = false;

    if (this._closeTimer) {
      clearTimeout(this._closeTimer);
      this._closeTimer = null;
    }

    if (popup) popup.classList.remove("closing");
  }

  openPopup() {
    const popup = document.getElementById("notify-me-popup");
    const overlay =
      this.element.querySelector(".notify-me__overlay") || document.querySelector(".notify-me__overlay");

    if (!popup) return;

    // Cancel any in-flight close animation
    if (this._closeTimer) {
      clearTimeout(this._closeTimer);
      this._closeTimer = null;
    }

    if (this._onCloseAnimEnd) {
      popup.removeEventListener("animationend", this._onCloseAnimEnd);
      this._onCloseAnimEnd = null;
    }

    popup.classList.remove("closing");
    this._isClosing = false;

    // Open
    popup.setAttribute("aria-hidden", "false");
    popup.setAttribute("aria-visible", "true");
    overlay?.classList.add("is-visible");
  }

  _requestClose(e) {
    e?.stopPropagation?.();
    if (typeof e?.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    this.closePopup({ immediate: true });
  }


  closePopup({ immediate = false } = {}) {
    const popup = document.getElementById("notify-me-popup");
    const overlay =
      this.element.querySelector(".notify-me__overlay") || document.querySelector(".notify-me__overlay");

    if (!popup) return;

    // If already hidden, do nothing
    if (popup.getAttribute("aria-hidden") === "true") {
      overlay?.classList.remove("is-visible");
      return;
    }

    // Clear any previous animation handler/timer
    if (this._closeTimer) {
      clearTimeout(this._closeTimer);
      this._closeTimer = null;
    }

    if (this._onCloseAnimEnd) {
      popup.removeEventListener("animationend", this._onCloseAnimEnd);
      this._onCloseAnimEnd = null;
    }

    overlay?.classList.remove("is-visible");

    if (immediate) {
      popup.classList.remove("closing");
      popup.setAttribute("aria-hidden", "true");
      popup.setAttribute("aria-visible", "false");
      this._isClosing = false;
      return;
    }

    // Animated close
    this._isClosing = true;
    popup.classList.add("closing");

    this._onCloseAnimEnd = () => {
      // If it got reopened mid-animation, do not hide it
      if (popup.getAttribute("aria-hidden") === "false") {
        popup.classList.remove("closing");
        this._isClosing = false;
        return;
      }

      popup.classList.remove("closing");
      popup.setAttribute("aria-hidden", "true");
      popup.setAttribute("aria-visible", "false");
      this._isClosing = false;
    };

    popup.addEventListener("animationend", this._onCloseAnimEnd, { once: false });

    // Safety: if animationend doesn't fire for any reason
    this._closeTimer = setTimeout(() => {
      popup.classList.remove("closing");
      popup.setAttribute("aria-hidden", "true");
      popup.setAttribute("aria-visible", "false");
      this._isClosing = false;

      if (this._onCloseAnimEnd) {
        popup.removeEventListener("animationend", this._onCloseAnimEnd);
        this._onCloseAnimEnd = null;
      }
      this._closeTimer = null;
    }, 450); // match your CSS animation duration
  }
  submitNotifyMe(e) {
    e.preventDefault();
    const emailInput = this.element.querySelector(".notify-me__input");
    const emailTxt = (emailInput?.value || "").trim();
    const alertErr = this.element.querySelector(".notify-me__popup-content .AlertError");

    if (emailTxt === "" || !emailTxt.includes("@")) {
      if (alertErr) {
        alertErr.style.display = "block";
        setTimeout(() => (alertErr.style.display = "none"), 3000);
      }
      return;
    }
    if (alertErr) alertErr.style.display = "none";

    this.handleDotdigitalAPI(emailTxt);
  }

  async handleDotdigitalAPI(myEmail) {
    const elementWithId = this.element.querySelector(".notify-me__popup-wrapper");
    if (!elementWithId) return;

    const variantID = elementWithId.getAttribute("variant-value");
    const productID = elementWithId.getAttribute("notify-product-id");

    const res = await fetch("https://r1-t.trackedlink.net/product-notifications", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        productId: productID,
        variantId: variantID,
        ddID: window.dd_bis_config?.ddID,
        email: myEmail,
        notificationSettingsID: window.dd_bis_config?.notificationSettingsID
      })
    });

    if (!res.ok) throw new Error(`Dotdigital request failed: ${res.statusText}`);

    elementWithId.setAttribute("notify-me-success", "true");
    elementWithId.style.opacity = 0;

    const content = elementWithId.querySelector(".notify-me__popup-content");
    const heading = elementWithId.querySelector(".notify-me__heading");
    const successMsg = elementWithId.querySelector(".notify-me__success-msg");
    const successHeading = elementWithId.querySelector(".notify-me__heading--success");

    if (content) content.style.display = "none";
    if (heading) heading.style.display = "none";

    setTimeout(() => {
      elementWithId.style.opacity = 1;
      if (successMsg) successMsg.style.display = "flex";
      if (successHeading) successHeading.style.display = "flex";
    }, 500);
  }
}

customElements.define("notify-me-popup", NotifyMePopup);



class SearchBar extends HTMLElement {
  constructor() {
    super();

    // base refs
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    // key elements (guard every lookup)
    this.searchInputElement = this.element.querySelector('[name="q"]');
    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.clearSearchButton = this.element.querySelector(".search-input__clear");
    this.closeBtnMobile = this.element.querySelector(
      ".search__close-btn-wrapper"
    );
    this.searchInputContainer = this.element.querySelector(
      ".search-header__input-container"
    );
    this.formElement = this.element.querySelector("form.searchForm");
    this.suggestedSearchesElement = this.element.querySelector(
      ".search__suggested-searches"
    );
    this.popularSearchesElement = this.element.querySelector(
      ".search__popular-searches"
    );

    new AddToCart(this.element);

    // options
    const settingsAttr = this.element.getAttribute("data-settings");
    try {
      this.options = settingsAttr ? JSON.parse(settingsAttr) : {};
    } catch {
      this.options = {};
    }

    // initial layout snapshot (guard)
    this.initialSearchLayout = this.searchResultsElement
      ? this.searchResultsElement.cloneNode(true)
      : null;

    // header sizing (guard) — defer to avoid forced reflow during init
    const headerEl = this.element.querySelector(".search-header");
    if (headerEl) {
      requestAnimationFrame(() => {
        document.documentElement.style.setProperty(
          "--search-header-height",
          `${headerEl.offsetHeight + 48}px`
        );
      });
    }

    // feature flags
    this.headerTransparent = false;
    this.isOpen = false;

    this.bindEvents();
    this.updateSearchToggleButtons(false);
  }

  bindEvents() {
    this._onInputListener = debounce(this.onInput.bind(this), 450);

    this.delegateBody.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateBody.on(
      "click",
      ".search[aria-expanded=false] .searchInput--Wrapper",
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );

    if (this.searchInputElement) {
      this.searchInputElement.addEventListener("input", this._onInputListener);
    }

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );
    this.delegateElement.on(
      "keypress",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
    this.delegateBody.on("drawer:opened", this.closeSearch.bind(this));
    this.delegateBody.on("popup:opened", this.closeSearch.bind(this));

    this.delegateElement.on(
      "submit",
      "form.searchForm",
      this.handleFormSubmit.bind(this)
    );
  }

  updateSearchToggleButtons(isExpanded) {
    const toggles = document.querySelectorAll('[data-action="open-search"]');
    toggles.forEach((toggle) =>
      toggle.setAttribute("aria-expanded", isExpanded ? "true" : "false")
    );
  }

  handleFormSubmit(event) {
    event.preventDefault();

    let url = new URL(this.formElement.action, window.location.origin);
    url.searchParams.set("q", this.searchInputElement.value);

    if (this.element.querySelector("product-card")) {
      url.searchParams.set("type", "product");
    } else {
      url.searchParams.set("type", "article");
    }

    window.location.href = url.toString();
  }

  initCarousel() {
    if (!this.searchResultsElement) return;
    const carousel = this.searchResultsElement.querySelector(
      "[data-swiper-settings]"
    );
    if (!carousel) return;
    const swiperEl = carousel.closest("swiper-init") || carousel;
    if (swiperEl && typeof swiperEl.initSwiper === "function") {
      swiperEl.initSwiper();
      this.newCarousel = swiperEl.getSwiper();
    }
  }
  openSearch(event) {
    if (event?.preventDefault) event.preventDefault();

    // Hydrate search initial products from template on first open
    const tpl = this.element.querySelector('template[data-search-initial]');
    if (tpl) {
      tpl.parentNode.appendChild(tpl.content);
      tpl.remove();
    }

    // Prevent opening if already opening or if currently closing
    if (this.isOpen || this._isOpening || this._isClosing) {
      // If already open, allow it to toggle closed
      if (this.isOpen && !this._isClosing) {
        this.closeSearch();
      }
      return;
    }

    this._isOpening = true;

    // Lock scroll FIRST, before closing other UI
    this.focusElement = this.element.querySelector("[data-scrollable]");
    if (this.focusElement) {
      bodyScrollLock.disableBodyScroll(this.focusElement, bodyScrollLockOptions);
    }
    document.body.classList.add("scrollLock");

    // Close other UI directly
    Drawer.instances.forEach(d => d.isOpen && d.closeDrawer());
    if (window.globalPopup) window.globalPopup.closeAllPopups?.();
    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );

    // ensure element exists
    if (!this.element) {
      this._isOpening = false;
      return;
    }

    // show container
    this.element.style.display = "block";

    // ARIA setup
    requestAnimationFrame(() => {
      const search = document.querySelector("#quickSearch");

      if (search) {
        search.setAttribute("aria-hidden", "false");
        search.setAttribute("aria-expanded", "true");
      }
    });

    const headerSearchBar = document.querySelector(".header-search");
    if (headerSearchBar) headerSearchBar.classList.add("hidden");

    this.pageOverlayElement.classList.add("is-visible");

    // focus input
    setTimeout(() => {
      if (this.searchInputElement) this.searchInputElement.focus();
    }, 200);

    // header transparency handling — fixed so transparent headers stay transparent
    const headerElement = document.querySelector("header-component");
    if (
      headerElement &&
      headerElement.classList.contains("Header--Transparent")
    ) {
      this.element._wasTransparentBeforeOpen = true;
      // Block automatic transparency while popup is open
      if (headerElement.drawerBlocksTransparency !== undefined) {
        headerElement.drawerBlocksTransparency = true;
      }
      headerElement.classList.remove("Header--Transparent");
    } else {
      this.element._wasTransparentBeforeOpen = false;
    }

    // state + overlay click to close
    this.isOpen = true;
    this._isOpening = false;
    this.updateSearchToggleButtons(true);

    if (this.pageOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener("click", this.closeListener);
    }
  }

  closeSearch(event) {
    if (event?.preventDefault) event.preventDefault();
    if (!this.isOpen) return;

    // Prevent multiple close operations
    if (this._isClosing) return;
    this._isClosing = true;

    if (responsive.currentBreakpoint == "desktop")
      this.element.setAttribute("aria-hidden", "true");
    this.element.setAttribute("aria-expanded", "false");

    // Clean up any existing listener to prevent stacking
    if (this.handleSearchCloseBinder) {
      this.element.removeEventListener(
        "transitionend",
        this.handleSearchCloseBinder
      );
    }

    this.handleSearchCloseBinder = this.handleSearchClose.bind(this);
    this.element.addEventListener(
      "transitionend",
      this.handleSearchCloseBinder,
      { once: true }
    );

    this.pageOverlayElement.classList.remove("is-visible");
    // Remove the click listener immediately
    if (this.closeListener && this.pageOverlayElement) {
      this.pageOverlayElement.removeEventListener("click", this.closeListener);
      this.closeListener = null;
    }

    this.isOpen = false;
    this.updateSearchToggleButtons(false);

    const headerSearchBar = document.querySelector(".header-search");
    if (headerSearchBar) headerSearchBar.classList.remove("hidden");

    // Clear any existing fallback timeout
    if (this._closeTimeout) {
      clearTimeout(this._closeTimeout);
    }

    // Fallback: force cleanup if transition doesn't fire
    this._closeTimeout = setTimeout(() => {
      if (!this.isOpen && this._isClosing) {
        this.handleSearchClose({ propertyName: "opacity" });
      }
    }, 400); // Increased to 400ms to avoid conflicts
  }

  handleSearchClose(e) {
    // Only run once per close operation
    if (!this._isClosing) return;

    // Only proceed on the opacity transition or forced cleanup
    if (e?.propertyName !== "opacity") return;

    this.element.style.display = "none";

    // Clear the fallback timeout
    if (this._closeTimeout) {
      clearTimeout(this._closeTimeout);
      this._closeTimeout = null;
    }

    // Restore transparent header if it was previously transparent
    if (this.element._wasTransparentBeforeOpen) {
      const headerElement = document.querySelector("header-component");
      if (headerElement) {
        headerElement.classList.add("Header--Transparent");
        // Restore transparency blocking
        if (headerElement.drawerBlocksTransparency !== undefined) {
          headerElement.drawerBlocksTransparency = false;
        }
      }
      this.element._wasTransparentBeforeOpen = false;
    }

    // Unlock scroll - but check if mobile menu is open first
    const mobileMenu = document.querySelector(
      "main-menu-dropdown .menu__drawer"
    );
    const isMobileMenuOpen =
      mobileMenu && mobileMenu.getAttribute("aria-expanded") === "true";

    // Only remove scrollLock class if no drawer is open.
    // NOTE: Drawer.active is not a reliable source of truth (it may be unset).
    const anyDrawerOpen =
      typeof Drawer !== "undefined" &&
      Array.isArray(Drawer.instances) &&
      Drawer.instances.some((d) => d && d.isOpen);
    if (!isMobileMenuOpen && !anyDrawerOpen) {
      document.body.classList.remove("scrollLock");
    }

    const scrollable = this.element.querySelector("[data-scrollable]");
    if (typeof bodyScrollLock !== "undefined" && scrollable) {
      try {
        // Only enable scroll for this specific element, don't clear all locks
        bodyScrollLock.enableBodyScroll(
          scrollable,
          window.bodyScrollLockOptions || undefined
        );
      } catch { }
    }

    this.resetSearch();

    // Clean up listener
    if (this.handleSearchCloseBinder) {
      this.element.removeEventListener(
        "transitionend",
        this.handleSearchCloseBinder
      );
      this.handleSearchCloseBinder = null;
    }

    // Reset closing flag
    this._isClosing = false;
  }

  async onInput(event) {
    // 1) get the value (typing OR clicking a suggestion)
    const source = event?.target;
    let val = source && "value" in source ? source.value : "";
    if (source?.getAttribute && source.getAttribute("data-value") && !val) {
      val = source.getAttribute("data-value");
      const el = this.element.querySelector(".searchInput");
      if (el) {
        el.value = val;
        el.setAttribute("value", val);
      }
    }
    this.lastInputValue = val;

    // 2) empty input → reset
    if (!val.trim()) {
      if (this.initialSearchLayout && this.searchResultsElement) {
        this.searchResultsElement.innerHTML =
          this.initialSearchLayout.innerHTML;
        this.searchResultsElement.style.opacity = 1;
      }
      this.popularSearchesElement.style.display = "";
      this.suggestedSearchesElement.style.display = "none";
      if (this.clearSearchButton)
        this.clearSearchButton.setAttribute("aria-hidden", "true");
      return;
    }

    this.popularSearchesElement.style.display = "none";
    this.suggestedSearchesElement.style.display = "";

    // 3) ensure wrapper exists
    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    if (!this.searchResultsElement) return;
    this.searchResultsElement.style.opacity = 0;
    if (this.clearSearchButton)
      this.clearSearchButton.setAttribute("aria-hidden", "false");

    // 4) RACE GUARD: only latest request may update the UI
    const token = (this.currentRequestToken =
      (this.currentRequestToken || 0) + 1);

    try {
      // 5) build a clean URL (no trailing spaces) + ask for query suggestions
      const sectionId = "search-predictive";
      const params = new URLSearchParams();
      params.set("q", val);
      params.set("resources[type]", "query,product,collection,article,page");
      params.set("resources[limit_scope]", "each");
      params.set(
        "resources[options][fields]",
        "title,product_type,variants.title,tag,body,author,vendor,variants.sku"
      );
      params.set("section_id", sectionId);
      params.set("_", String(Date.now())); // cache-buster
      const url = `${routes.predictive_search_url}?${params.toString()}`;

      const response = await fetch(url, { cache: "no-store" });
      if (!response.ok) throw new Error(response.status);

      // If a newer request started, drop this one
      if (token !== this.currentRequestToken) return;

      // 6) parse the HTML and inject results
      const text = await response.text();
      const parsed = new DOMParser().parseFromString(text, "text/html");
      const hostEl =
        parsed.querySelector(`#shopify-section-${sectionId}`) || parsed.body;
      const resultsMarkup = hostEl ? hostEl.innerHTML : "";

      this.searchResultsElement.classList.add("is-loading");

      this.searchResultsElement.innerHTML = resultsMarkup;

      if (hostEl.querySelector(".predictive-search__products--no-results")) {
        this.popularSearchesElement.style.display = "";
        this.suggestedSearchesElement.style.display = "none";
      }

      requestAnimationFrame(() => {
        this.initCarousel();

        if (this.newCarousel?.on) {
          this.newCarousel.on("init", () => {
            this.searchResultsElement.classList.remove("is-loading");
          });
          this.newCarousel.on("afterInit", () => {
            this.searchResultsElement.classList.remove("is-loading");
          });
        } else {
          requestAnimationFrame(() => {
            this.searchResultsElement.classList.remove("is-loading");
          });
        }
      });

      // 7) finish
      this.searchResultsElement.style.opacity = 1;
    } catch (error) {
      if (error?.code === 20) return; // aborted
      if (this.searchResultsElement)
        this.searchResultsElement.style.opacity = 1;
    }
  }

  resetSearch() {
    if (this.initialSearchLayout && this.searchResultsElement) {
      this.searchResultsElement.classList.add("is-loading");
      this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;
    }

    if (this.searchInputElement) {
      this.searchInputElement.value = "";
      this.searchInputElement.removeAttribute("value");
    }

    this.popularSearchesElement.style.display = "";
    this.suggestedSearchesElement.style.display = "none";

    requestAnimationFrame(() => {
      this.initCarousel();

      if (this.newCarousel?.on) {
        this.newCarousel.on("init", () => {
          this.searchResultsElement.classList.remove("is-loading");
        });
        this.newCarousel.on("afterInit", () => {
          this.searchResultsElement.classList.remove("is-loading");
        });
      } else {
        requestAnimationFrame(() => {
          this.searchResultsElement.classList.remove("is-loading");
        });
      }
    });

    if (this.searchResultsElement) this.searchResultsElement.style.opacity = "";

    setTimeout(() => {
      if (this.searchInputElement) this.searchInputElement.focus();
    }, 200);

    if (this.clearSearchButton) {
      this.clearSearchButton.setAttribute("aria-hidden", "true");
    }
  }
}

customElements.define("search-bar", SearchBar);

class TermsAndConditions extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.searchInput = this.element.querySelector(".terms--search");
    this.termsBlocks = document.querySelectorAll(".terms__dropdown");
    this.termsLinksDesktop = this.element.querySelector(".terms-link-list-items-desktop");
    this.noResultsElement = document.querySelector("#terms__results--none");
  }

  connectedCallback() {
    this.bindEvents();
    this.openFirstDropdown();

    this.delegateElement.on(
      "click",
      '[data-action="toggle-dropdown"]',
      this.handleDropdownClick.bind(this)
    );
  }

  handleDropdownClick(event) {
    const dropdown = event.target.closest(".Dropdown");
    const dropdownContent = dropdown.querySelector(".Dropdown--Content");

    if (dropdownContent.getAttribute("aria-hidden") === "false") return;

    dropdownContent.addEventListener("transitionend", () => {
      this.scrollToSection(dropdown);
    }, { once: true });
  }

  bindEvents() {
    this.onInputListener = debounce(this.handleSearch.bind(this), 350);
    this.delegateElement.on(
      "keyup",
      '[data-action="search-string"]',
      this.onInputListener
    );
  }

  openFirstDropdown() {
    const firstDropdown = this.element.querySelector(
      ".terms__dropdown.Dropdown"
    );
    if (firstDropdown) {
      const dropdownBtn = firstDropdown.querySelector(".Dropdown--Button");
      dropdownBtn.setAttribute("aria-expanded", "true");
      const dropdownContent = firstDropdown.querySelector(".Dropdown--Content");
      dropdownContent.setAttribute("aria-hidden", "false");
    }
  }

  handleSearch() {
    const searchTerm = this.searchInput.value.toLowerCase().trim();

    const noResultsContainer = this.querySelector(".terms__results--none");
    let hasMatch = false;

    this.termsBlocks.forEach((block) => {
      const title = block
        .querySelector(".terms__dropdown--title")
        .textContent.toLowerCase();
      const termsItems = block.querySelectorAll(".terms__dropdown-item");
      let blockMatch = false;

      if (title.includes(searchTerm)) {
        this.toggleBlockVisibility(block, true);
        termsItems.forEach((content) => content.classList.remove("is-hidden"));
        blockMatch = true;
      } else {
        termsItems.forEach((termsItem) => {
          const termsItemTitle = termsItem
            .querySelector(".terms__dropdown-item--title")
            .textContent.toLowerCase();
          const termsItemText = termsItem
            .querySelector(".terms__dropdown-item--text")
            .textContent.toLowerCase();
          if (
            termsItemTitle.includes(searchTerm) ||
            termsItemText.includes(searchTerm)
          ) {
            termsItem.classList.remove("is-hidden");
            blockMatch = true;
          } else {
            termsItem.classList.add("is-hidden");
          }
        });

        this.toggleBlockVisibility(block, blockMatch);
      }

      if (blockMatch) hasMatch = true;
    });

    if (searchTerm === "" || !hasMatch) {
      this.resetBlockVisibility(searchTerm === "");
      this.noResultsElement.setAttribute(
        "aria-hidden",
        searchTerm === "" || hasMatch ? "true" : "false"
      );
      this.noResultsElement.style.display =
        searchTerm === "" || hasMatch ? "none" : "block";
    } else {
      this.noResultsElement.setAttribute("aria-hidden", "true");
    }
  }

  toggleBlockVisibility(block, show) {
    block.classList.toggle("is-hidden", !show);
  }

  resetBlockVisibility() {
    this.termsBlocks.forEach((block) => {
      block
        .querySelectorAll(".terms__dropdown-item")
        .forEach((content) => content.classList.remove("is-hidden"));
    });

    this.termsBlocks.forEach((block) => {
      block.classList.remove("is-hidden");
    });
  }

  scrollToSection(targetElement) {
    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height-fixed')) || 0;
    const offset = headerHeight;
    let targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset - 15;
    if (responsive.currentBreakpoint !== 'desktop') {
      targetPosition = targetPosition - 105;
    }

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }
}

customElements.define("terms-and-conditions", TermsAndConditions);

class FAQSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.searchInput = this.element.querySelector(".faq--search");
    this.termsBlocks = this.element.querySelectorAll(".terms__dropdown");
    this.termsLinksDesktop = this.element.querySelector(
      ".terms-link-list-items-desktop"
    );
    this.noResultsElement = this.element.querySelector("#faq__results--none");
    this.clearBtn = this.element.querySelector('[data-action="clear-search"]');
  }

  connectedCallback() {
    this.bindEvents();
    this.setupTabs();
    this.openFirstDropdown();
    this.injectFAQSchema();
  }

  injectFAQSchema() {
    var items = this.querySelectorAll('.terms__dropdown-item');
    if (!items.length) return;
    var qa = [];
    items.forEach(function(item) {
      var titleEl = item.querySelector('.terms__dropdown-item--title p');
      var answerEl = item.querySelector('.terms__dropdown-item--text');
      if (titleEl && answerEl) {
        var q = titleEl.textContent.trim();
        var a = answerEl.innerHTML.trim();
        if (q && a) {
          qa.push({
            "@type": "Question",
            "name": q,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": a
            }
          });
        }
      }
    });
    if (qa.length) {
      var script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": qa
      });
      document.head.appendChild(script);
    }
  }

  bindEvents() {
    this.onInputListener = debounce(this.handleSearch.bind(this), 350);
    this.delegateElement.on(
      "keyup",
      '[data-action="search-string"]',
      this.onInputListener
    );

    this.delegateElement.on(
      "click",
      '[data-action="handle-tab-click"]',
      this.handleTabClick.bind(this)
    );

    this.delegateElement.on(
      "click",
      ".terms__dropdown-btn",
      this.changeActiveTabOnDropdownOpen.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="clear-search"]',
      this.clearSearch.bind(this)
    );
  }

  setupTabs() {
    const dropdowns = Array.from(
      this.element.querySelectorAll(".terms__dropdown.Dropdown")
    );
    if (!dropdowns.length) return;

    const mobileWrapper = this.element.querySelector(
      ".faq__link-list .swiper-wrapper"
    );
    const desktopWrapper = this.element.querySelector(
      ".terms-link-list-items-desktop"
    );

    if (!mobileWrapper || !desktopWrapper) return;

    const mobileTemplate = mobileWrapper.querySelector("button.linklist--tab");
    const desktopTemplate = desktopWrapper.querySelector(
      "button.linklist--tab"
    );

    if (!mobileTemplate || !desktopTemplate) return;

    mobileWrapper.innerHTML = "";
    desktopWrapper.innerHTML = "";

    dropdowns.forEach((dropdown, index) => {
      const triggerId = dropdown.id;
      if (!triggerId) return;

      const titleEl = dropdown.querySelector(".terms__dropdown--title");
      const title = titleEl ? titleEl.textContent.trim() : `Tab ${index + 1}`;

      // --- Mobile button ---
      const mobileBtn = mobileTemplate.cloneNode(true);
      mobileBtn.removeAttribute("aria-hidden");
      mobileBtn.setAttribute("data-trigger-id", triggerId);
      if (index === 0) mobileBtn.classList.add("is-active");

      const mobileText = mobileBtn.querySelector(".button-txt");
      if (mobileText) mobileText.textContent = title;

      mobileWrapper.appendChild(mobileBtn);

      // --- Desktop button ---
      const desktopBtn = desktopTemplate.cloneNode(true);
      desktopBtn.removeAttribute("aria-hidden");
      desktopBtn.setAttribute("data-trigger-id", triggerId);
      if (index === 0) desktopBtn.classList.add("is-active");

      const desktopText = desktopBtn.querySelector(".button-txt");
      if (desktopText) desktopText.textContent = title;

      desktopWrapper.appendChild(desktopBtn);
    });

    this.tabs = this.element.querySelectorAll(".linklist--tab");
  }

  handleTabClick(event, delegateTarget) {
    if (allDropdowns.lock) return;

    const clickedTab = delegateTarget || event.target.closest('[data-trigger-id]');
    const triggerId = clickedTab?.getAttribute("data-trigger-id");
    const dropdownToOpen = this.element.querySelector(`#${triggerId}`);
    if (!dropdownToOpen) return;

    const dropdownContent = dropdownToOpen.querySelector(".Dropdown--Content");
    dropdownContent.addEventListener("transitionend", () => {
      this.scrollToSection(dropdownToOpen);
    }, { once: true });

    const dropdownBtn = dropdownToOpen.querySelector(".Dropdown--Button");
    allDropdowns.openDropdown(dropdownToOpen, dropdownBtn);

    this.tabs.forEach((tab) => {
      if (tab.getAttribute("data-trigger-id") === triggerId) {
        tab.classList.add("is-active");
      } else {
        tab.classList.remove("is-active");
      }
    });

    this.slideSwiperToTab(triggerId);
  }

  changeActiveTabOnDropdownOpen(event) {
    const target = event.target;

    const dropdown = target.closest(".terms__dropdown");
    const targetId = dropdown.id;

    const dropdownContent = dropdown.querySelector(".Dropdown--Content");
    dropdownContent.addEventListener("transitionend", () => {
      this.scrollToSection(dropdown);
    }, { once: true });

    this.tabs.forEach((tab) => {
      if (tab.getAttribute("data-trigger-id") === targetId) {
        tab.classList.add("is-active");
      } else {
        tab.classList.remove("is-active");
      }
    });

    this.slideSwiperToTab(targetId);
  }

  slideSwiperToTab(triggerId) {
    const swiperInitEl = this.element.querySelector('.faq__link-list swiper-init');
    if (!swiperInitEl) return;

    const swiper = swiperInitEl.getSwiper();
    if (!swiper?.swiperElement) return;

    const slides = Array.from(swiperInitEl.querySelectorAll('.swiper-slide'));
    const index = slides.findIndex(
      (slide) => slide.getAttribute('data-trigger-id') === triggerId
    );

    if (index >= 0) {
      swiper.swiperElement.slideTo(index, 350);
    }
  }

  openFirstDropdown() {
    const firstDropdown = this.element.querySelector(".terms__dropdown.Dropdown");
    if (!firstDropdown) return;

    const btn = firstDropdown.querySelector(".Dropdown--Button");
    const content = firstDropdown.querySelector(".Dropdown--Content");
    if (!btn || !content) return;

    btn.setAttribute("aria-expanded", "true");
    content.setAttribute("aria-hidden", "false");

    content.style.height = "auto";
    content.style.pointerEvents = "all";
  }



  handleSearch() {
    const searchTerm = this.searchInput.value.toLowerCase().trim();

    let hasMatch = false;

    this.termsBlocks.forEach((block) => {
      const title = block
        .querySelector(".terms__dropdown--title")
        .textContent.toLowerCase();
      const termsItems = block.querySelectorAll(".terms__dropdown-item");
      let blockMatch = false;

      if (title.includes(searchTerm)) {
        this.toggleBlockVisibility(block, true);
        termsItems.forEach((content) => content.classList.remove("is-hidden"));
        blockMatch = true;
      } else {
        termsItems.forEach((termsItem) => {
          const termsItemTitle = termsItem
            .querySelector(".terms__dropdown-item--title")
            .textContent.toLowerCase();
          const termsItemText = termsItem
            .querySelector(".terms__dropdown-item--text")
            .textContent.toLowerCase();
          if (
            termsItemTitle.includes(searchTerm) ||
            termsItemText.includes(searchTerm)
          ) {
            termsItem.classList.remove("is-hidden");
            blockMatch = true;
          } else {
            termsItem.classList.add("is-hidden");
          }
        });

        this.toggleBlockVisibility(block, blockMatch);
      }

      if (blockMatch) hasMatch = true;
    });

    if (searchTerm === "") this.clearBtn.style.display = "none";
    else this.clearBtn.style.display = "";

    if (searchTerm === "" || !hasMatch) {
      this.resetBlockVisibility(searchTerm === "");
      this.noResultsElement.setAttribute(
        "aria-hidden",
        searchTerm === "" || hasMatch ? "true" : "false"
      );
      this.noResultsElement.style.display =
        searchTerm === "" || hasMatch ? "none" : "block";
    } else {
      this.noResultsElement.setAttribute("aria-hidden", "true");
    }
  }

  toggleBlockVisibility(block, show) {
    block.classList.toggle("is-hidden", !show);
  }

  resetBlockVisibility() {
    this.termsBlocks.forEach((block) => {
      block
        .querySelectorAll(".terms__dropdown-item")
        .forEach((content) => content.classList.remove("is-hidden"));
    });

    this.termsBlocks.forEach((block) => {
      block.classList.remove("is-hidden");
    });
  }

  scrollToSection(targetElement) {
    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height-fixed')) || 0;
    const offset = headerHeight;
    let targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;
    if (responsive.currentBreakpoint !== 'desktop') {
      targetPosition = targetPosition - 105;
    }

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }

  clearSearch() {
    this.searchInput.value = "";
    this.handleSearch();
  }
}

customElements.define("faq-section", FAQSection);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

    this.updateLastGroupBorder();
  }

  connectedCallback() {
    this.initFormValidation();
    this.updateLastGroupBorder();
  }

  updateGlobalErrorVisibility() {
    const globalError = this.element.querySelector(".contact-section__error");
    if (!globalError) return;

    const anyFieldHasError = this.element.querySelector(".field.field--error");
    const hasText = globalError.textContent.trim().length > 0;

    globalError.style.display = (anyFieldHasError && hasText) ? "block" : "none";
  }

  initFormValidation() {
    const form = this.element.querySelector("form");
    if (!form) return;

    this.validator = new FormValidator(form, {
      errorClass: "field--error",
      fieldSelector: ".field, .form-checkbox",
      buttonSelector: ".validate-button",
      validateOnBlur: true,
      validateOnInput: false,
      showErrorsOnSubmitOnly: false,
      errorOutputSelector: this.element.querySelector(".contact-section__error")
    });

    const inputs = form.querySelectorAll("input, textarea, select");

    inputs.forEach((input) => {
      input.addEventListener("blur", () => {
        this.validator.validateField(input, false);
        this.validator.updateErrorOutput();
        this.updateGlobalErrorVisibility();
      });

      input.addEventListener("input", () => {
        this.validator.updateErrorOutput();
        this.updateGlobalErrorVisibility();
      });
    });

    const button = form.querySelector(".validate-button");
    if (button) {
      button.addEventListener("click", (e) => {
        this.validator.markSubmitted();
        const isValid = this.validator.validateForm(false);

        this.updateGlobalErrorVisibility();

        if (button.type === "submit" && !isValid) {
          e.preventDefault();
        }

        this.toggleButton();
      });
    }
  }


  updateLastGroupBorder() {
    const parent = this.element.querySelector(".contanct-section__content");
    if (!parent) return;

    parent.querySelectorAll(".group-text-button__block-wrapper.is-last")
      .forEach(el => el.classList.remove("is-last"));

    const visible = [...parent.querySelectorAll(".group-text-button__block-wrapper")]
      .filter(el => el.offsetParent !== null);

    const last = visible[visible.length - 1];
    if (last) last.classList.add("is-last");
  }
  toggleButton() {
    if (this.validator && this.validator.updateButtonState) {
      this.validator.updateButtonState();
    }
  }
}

customElements.define("contact-section", ContactSection);


class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() { }

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
      this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);


class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    // Drawer root & inner wrapper
    this.drawerEl = this.element.querySelector('#accountDrawer');
    this.wrapper = this.drawerEl?.querySelector('.Drawer--Wrapper');

    // If you still need your Drawer class, keep it:
    this.drawer = new Drawer(this.drawerEl);

    this.bindEvents();
  }

  connectedCallback() {
    this.initFormValidation();
    // If you have a default state set in markup, sync height on mount:
    if (responsive.matchesBreakpoint("lap_and_up")) {

      setTimeout(() => {
        requestAnimationFrame(() => {
          document.documentElement.classList.add('account-drawer-ready');
        });
      }, 800)

    }
  }

  bindEvents() {

    this.delegateBody.on("account-drawer:closed", this.resetToLoginTab.bind(this))

    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on('click', '[data-action="submit-login"]', this.submitLogin.bind(this));
    this.delegateElement.on('click', '[data-action="submit-register"]', this.submitRegistration.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-recovery"]', this.toggleRecovery.bind(this));
    this.delegateElement.on('click', '[data-action="submit-recovery"]', this.accountRecover.bind(this));

    this.delegateElement.on("keypress", '[data-action="submit-input-login"]', this.accountInputSubmit.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-reg"]', this.accountInputSubmitReg.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-forgot-pass"]', this.accountInputSubmitForgot.bind(this));
  }

  showError(errorElement, message) {
    if (!errorElement) return;

    // Clear any existing timeout for this element
    if (errorElement._hideTimeout) {
      clearTimeout(errorElement._hideTimeout);
    }

    // Set the error message and show it
    errorElement.innerHTML = message;
    errorElement.classList.add('is-visible');

    // Auto-hide after 2 seconds
    errorElement._hideTimeout = setTimeout(() => {
      errorElement.classList.remove('is-visible');
      errorElement._hideTimeout = null;
    }, 2000);
  }

  resetToLoginTab() {

    setTimeout(() => {
      this.element.querySelector('#recover')?.setAttribute('aria-visible', 'false');
      this.element.querySelector('#loginFlex')?.setAttribute('aria-visible', 'true');
    }, 800)

  }

  initFormValidation() {
    const forms = {
      login: { el: "#login_popup", button: ".btn-drawer-log-in", error: ".input-validation" },
      register: { el: "#register_popup", button: ".btn-drawer-register", error: ".input-validation" },
      forgotten_password: { el: "#recover-popup", button: ".btn-drawer-recover", error: ".input-validation" },
    };

    for (const [key, { el, button, error }] of Object.entries(forms)) {
      const form = this.querySelector(el);
      if (!form) continue;

      this[`${key}Validator`] = new FormValidator(form, {
        errorClass: "field--error",
        fieldSelector: ".field",
        buttonSelector: button,
        fieldErrorSelector: error,
        validateOnBlur: true,
        validateOnInput: false,
        showErrorsOnSubmitOnly: false
      });
    }
  }

  accountInputSubmit(e) { if (e.key === "Enter") this.submitLogin(e); }
  accountInputSubmitReg(e) { if (e.key === "Enter") this.submitRegistration(e); }
  accountInputSubmitForgot(e) { if (e.key === "Enter") { e.preventDefault(); this.accountRecover(e); } }

  toggleRecovery(event) {
    event.preventDefault();
    const id = event.target.dataset.id;
    const newTitle = event.target.dataset.title || '';
    const newSubtitle = event.target.dataset.subtitle || '';

    this.setDrawerTitle(newTitle);
    this.setDrawerSubtitle(newSubtitle);

    if (id === 'recover') {
      this.element.querySelector('#recover')?.setAttribute('aria-visible', 'true');
      this.element.querySelector('#login')?.setAttribute('aria-visible', 'false');
      // Update auth switch to show recover view
      this.updateAuthSwitch('recover');
    } else {
      this.element.querySelector('#recover')?.setAttribute('aria-visible', 'false');
      this.element.querySelector('#login')?.setAttribute('aria-visible', 'true');
      // Update auth switch to show login view
      this.updateAuthSwitch('login');
    }
  }

  async accountRecover(event) {
    event.preventDefault();
    const recoverEndpoint = "/account/recover";
    const requestBody = {
      email: this.element.querySelector("#RecoverEmail").value,
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    // Find the recovery button from the form container instead of event target
    const recoveryButton = this.element.querySelector('[data-action="submit-recovery"]');
    const loader = recoveryButton?.querySelector(".itemLoader");

    recoveryButton?.classList.add("is-loading");
    loader?.classList.add("is-visible");

    try {
      const response = await fetch(recoverEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });



      const responseText = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = responseText;



      const recoverError = this.element.querySelector("#recover .accountDrawer--ErrorSpace");
      const recoverSuccess = this.element.querySelector("#recover .accountDrawer--SuccessSpace");
      if (responseText.includes("account__recover-email-error")) {
        recoverSuccess.classList.remove("is-visible");
        recoverError.innerHTML = "";
        recoverError.innerHTML = tempDiv.querySelector("#account__recover-email-error").innerHTML;
        recoverError.classList.add("is-visible");
      } else if (responseText.includes("account__form-success-msg")) {
        recoverError.classList.remove("is-visible");

        recoverSuccess.innerHTML = "";
        recoverSuccess.innerHTML = tempDiv.querySelector("#account__form-success-msg").innerHTML;
        recoverSuccess.classList.add("is-visible");


      }

      if (buttonText) buttonText.style.visibility = "visible";
      if (loader) loader.classList.remove("is-visible");
    } catch (error) {
      // Error during recovery request
    } finally {
      recoveryButton?.classList.remove("is-loading");
      loader?.classList.remove("is-visible");
    }
  }

  async submitRegistration(event) {
    event.preventDefault();
    event.stopPropagation();

    const form = this.element.querySelector("#register_popup");
    if (!form) return;

    const emailInput = form.querySelector("#RegisterForm-email");
    const passwordInput = form.querySelector("#RegisterForm-password");

    const errorBox = form.querySelector(".accountDrawer--ErrorSpace");
    const successBox = form.querySelector(".accountDrawer--SuccessSpace");

    const btn = this.element.querySelector('[data-action="submit-register"]')?.closest("button");
    const loader = btn?.querySelector(".itemLoader");

    // reset UI
    if (errorBox) { errorBox.innerHTML = ""; errorBox.classList.remove("is-visible"); }
    if (successBox) { successBox.innerHTML = ""; successBox.classList.remove("is-visible"); }
    emailInput?.closest(".field")?.classList.remove("input--error");
    passwordInput?.closest(".field")?.classList.remove("input--error");
    emailInput?.setAttribute("aria-invalid", "false");
    passwordInput?.setAttribute("aria-invalid", "false");

    btn?.classList.add("is-loading");
    loader?.classList.add("is-visible");

    try {
      const fd = new FormData(form);

      // hcaptcha if present
      if (window.hcaptcha) {
        const captchaToken = await window.hcaptcha.execute(null, { async: true });
        fd.append("h-captcha-response", captchaToken.response);
      }

      const res = await fetch(form.action, {
        method: "POST",
        body: fd,
        credentials: "same-origin",
        redirect: "follow",
        headers: { "Accept": "text/html" }
      });

      const finalPath = new URL(res.url, window.location.origin).pathname.replace(/\/+$/, "");
      const stayedOnRegister = finalPath === "/account/register";

      if (stayedOnRegister) {
        const msg =
          (window.languages && window.languages.account_already_exists) ||
          "This email address already exists.";

        if (successBox) successBox.classList.remove("is-visible");

        if (errorBox) {
          errorBox.innerHTML = msg;
          errorBox.classList.add("is-visible");
        }

        emailInput?.closest(".field")?.classList.add("input--error");
        emailInput?.setAttribute("aria-invalid", "true");
        return;
      }

      // ✅ success: only if not failure
      if (successBox) {
        const msg = successBox.dataset.registerSuccessText || "";
        successBox.textContent = msg;
        successBox.classList.add("is-visible");
      }

      setTimeout(() => {
        location.href = window.routes.account_url;
      }, 800);

    } catch (err) {

      if (errorBox) {
        errorBox.textContent = "Greška. Pokušaj ponovno.";
        errorBox.classList.add("is-visible");
      }
    } finally {
      btn?.classList.remove("is-loading");
      loader?.classList.remove("is-visible");
    }
  }


  async submitLogin(event) {
    event.preventDefault();
    const loginEndpoint = `${window.routes.localeRootUrl}/account/login`;
    const requestBody = {
      customer: {
        email: this.element.querySelector("#CustomerEmail").value,
        password: this.element.querySelector("#CustomerPassword").value,
      },
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const loginButton = this.element.querySelector('[data-action="submit-login"]');
    const loader = loginButton?.querySelector(".itemLoader");

    loginButton?.classList.add("is-loading");
    loader?.classList.add("is-visible");


    try {
      const response = await fetch(loginEndpoint, {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();

      if (responseText.includes("loginError")) {
        const loginError = this.element.querySelector("#login .accountDrawer--ErrorSpace");
        loginError.innerHTML = "";
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;
        loginError.innerHTML = tempDiv.querySelector(".AlertError").innerHTML;
        loginError.classList.add("is-visible");

        const fieldErr = loginError.closest('.field');
        if (fieldErr) fieldErr.classList.add('input--error');
      } else {
        location.href = window.routes.account_url;
      }
    } catch (error) {
    } finally {
      loginButton?.classList.remove("is-loading");
      loader?.classList.remove("is-visible");
    }
  }

  // Title and subtitle setters
  setDrawerTitle(title) {
    const titleElement = this.element.querySelector('.acc-drawer__title');
    if (titleElement && title) titleElement.textContent = title;
  }

  setDrawerSubtitle(subtitle) {
    const subtitleElement = this.element.querySelector('.acc-drawer__subtitle');
    if (subtitleElement && subtitle) subtitleElement.textContent = subtitle;
  }

  toggleTab(event) {
    const id = event.target.dataset.id;
    const titleToSet = event.target.dataset.title;
    const subtitleToSet = event.target.dataset.subtitle;

    this.setDrawerTitle(titleToSet);
    this.setDrawerSubtitle(subtitleToSet);

    const allTabs = this.element.querySelectorAll('.acc-drawer__tab[aria-expanded="true"]');
    const allContent = this.element.querySelectorAll('.accountContent');

    allTabs.forEach((tab) => tab.setAttribute('aria-expanded', 'false'));
    event.target.setAttribute('aria-expanded', 'true');
    allContent.forEach((c) => c.setAttribute('aria-visible', 'false'));

    const content = this.element.querySelector(`#${id}`);
    if (content) content.setAttribute('aria-visible', 'true');

    // Update auth switch
    this.updateAuthSwitch(id);
  }

  updateAuthSwitch(activeView) {
    const switchOptions = this.element.querySelectorAll('[data-switch-view]');
    switchOptions.forEach((option) => {
      const viewType = option.dataset.switchView;
      option.style.display = viewType === activeView ? 'flex' : 'none';
    });
  }
}

customElements.define("account-handler", AccountHandler);


class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    let breakpoint = responsive.getCurrentBreakpoint();
    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    var location = this.element.getAttribute('data-settings');

    if (location == "sidebarMenu") {
      var additionalOverlay = true;
    } else {
      var additionalOverlay = false;
    }
    if (breakpoint != "phone" && breakpoint != "tablet") {
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(
            item
          );
        });
      }
    } else {
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(
            item, true, additionalOverlay
          );
        });
      }
    }

  }

}
customElements.define("localization-selectors", LocalizationSelectors);

class SubscriptionSelector extends HTMLElement {
  connectedCallback() {
    this.element = this;
    this.planId = this.getAttribute("data-plan-id") || "";
    this.root = this.closest("product-component") || document;
    this.subscriptionOnly = this.hasAttribute("data-subscription-only");

    this.hiddenInput = this.querySelector('input[name="selling_plan"][data-selling-plan-input]');
    this.radios = Array.from(this.querySelectorAll('input[type="radio"].subscription-selector__radio'));

    this.cardOnetime = this.querySelector('[data-card="onetime"] input[type="radio"]');
    this.cardSub = this.querySelector('[data-card="subscription"] input[type="radio"]');

    this.priceOneTime = this.querySelector("[data-price-onetime]");
    this.priceSub = this.querySelector("[data-price-sub]");
    this.priceSubCompare = this.querySelector("[data-price-sub-compare]");
    this.savePctEl = this.querySelector("[data-save-pct]");
    this.selectedPlanNameEl = this.querySelector("[data-selected-plan-name]");

    // Plan dropdown elements (inline trigger + list)
    this.frequencyTrigger = this.querySelector("[data-action='toggle-plan-dropdown']");
    this.dropdownList = this.querySelector("[data-plan-dropdown-list]");

    this.variantPrices = this._readVariantPriceJson();

    // Delegate-based event binding
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this._onVariantIdChanged = this._onVariantIdChanged.bind(this);
    this._onClickOutside = this._onClickOutside.bind(this);

    this.bindEvents();

    // In subscription-only mode, ensure subscription is selected from the start
    if (this.subscriptionOnly && this.cardSub) {
      this.cardSub.checked = true;
    }

    // init from current checked state
    this._applySellingPlanFromUI();

    // init prices from current variant
    this._updatePricesForCurrentVariant();
  }

  disconnectedCallback() {
    this.delegateElement?.off?.();
    this.delegateBody?.off?.();
    document.removeEventListener("variant:id-changed", this._onVariantIdChanged);
    window.removeEventListener("click", this._onClickOutside);
  }

  bindEvents() {
    // Radio change (one-time ↔ subscription)
    this.delegateElement.on(
      "change",
      ".subscription-selector__radio",
      this._onChange.bind(this)
    );

    // Dropdown toggle
    this.delegateElement.on(
      "click",
      "[data-action='toggle-plan-dropdown']",
      this._toggleDropdown.bind(this)
    );

    // Dropdown item selection
    this.delegateElement.on(
      "click",
      "[data-action='select-plan']",
      this._onSelectPlan.bind(this)
    );

    // When VariantSelects updates the hidden variant id inputs
    document.addEventListener("variant:id-changed", this._onVariantIdChanged);

    // Close dropdown on outside click (same pattern as RevolutionSelectbox)
    window.addEventListener("click", this._onClickOutside);
  }

  _readVariantPriceJson() {
    const el = this.querySelector("script[type='application/json'][data-variant-plan-prices]");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /* ── Dropdown methods ────────────────────────────── */

  _toggleDropdown(e, target) {
    e.preventDefault();

    if (!this.dropdownList || !this.frequencyTrigger) return;
    const isOpen = this.frequencyTrigger.getAttribute("aria-expanded") === "true";
    if (isOpen) {
      this._closeDropdown();
    } else {
      this._openDropdown();
    }
  }

  _openDropdown() {
    if (!this.dropdownList || !this.frequencyTrigger) return;

    // Auto-select subscription if not already selected
    if (!this._isSubscriptionSelected() && this.cardSub) {
      this.cardSub.checked = true;
      this.cardSub.dispatchEvent(new Event("change", { bubbles: true }));
    }

    this.frequencyTrigger.setAttribute("aria-expanded", "true");
    this.dropdownList.setAttribute("aria-hidden", "false");
  }

  _closeDropdown() {
    if (!this.dropdownList || !this.frequencyTrigger) return;
    this.frequencyTrigger.setAttribute("aria-expanded", "false");
    this.dropdownList.setAttribute("aria-hidden", "true");
  }

  _onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (!withinBoundaries) {
      this._closeDropdown();
    }
  }

  _onSelectPlan(e, target) {
    const item = target || e.target.closest("[data-action='select-plan']");
    if (!item) return;

    const newPlanId = item.dataset.planId;
    const newPlanName = item.dataset.planName;
    if (!newPlanId) return;

    const allItems = this.querySelectorAll("[data-action='select-plan']");
    allItems.forEach((el) => {
      el.classList.remove("is-active");
      el.removeAttribute("aria-current");
    });
    item.classList.add("is-active");
    item.setAttribute("aria-current", "true");

    if (this.selectedPlanNameEl) {
      this.selectedPlanNameEl.textContent = newPlanName;
    }

    this.planId = String(newPlanId);
    this.setAttribute("data-plan-id", this.planId);

    this._closeDropdown();
    this._applySellingPlanFromUI();
    this._updatePricesForCurrentVariant();

    document.dispatchEvent(new CustomEvent("variant:price-updated"));
  }

  /* ── Radio change (one-time / subscription) ──────── */

  _onChange(e, target) {
    // Only close the plan list when switching to one-time.
    // Do NOT close when switching to subscription — the click may have
    // originated from the frequency-trigger button inside the <label>,
    // which means the user intended to open the plan list, not close it.
    if (!this._isSubscriptionSelected()) {
      this._closeDropdown();
    }

    this._applySellingPlanFromUI();
    this._updatePricesForCurrentVariant();

    // let your PDP totals/inline update
    document.dispatchEvent(new CustomEvent("variant:price-updated"));
  }

  _onVariantIdChanged(e) {
    // only react if this selector is inside the same product-component
    const changedProductId = e?.detail?.productId;
    if (changedProductId && this.dataset.productId && String(changedProductId) !== String(this.dataset.productId)) {
      return;
    }

    this._updatePricesForCurrentVariant();

    // keep selling_plan consistent
    this._applySellingPlanFromUI();

    // No need to dispatch variant:price-updated here - VariantSelects already does it
  }

  _getCurrentVariantId() {
    const idInput = this.root.querySelector('form[data-product-form] input[name="id"]');
    return idInput?.value ? String(idInput.value) : null;
  }

  _isSubscriptionSelected() {
    const checked = this.radios.find((r) => r.checked);
    return checked?.value === "subscription";
  }

  _applySellingPlanFromUI() {
    const shouldUsePlan = this._isSubscriptionSelected();
    const selectorProductId = String(this.dataset.productId || "");

    // Main + sticky only. Upsells live in the same product-component but must not get the PDP plan.
    this.root
      .querySelectorAll('form[data-product-form] input[name="selling_plan"]')
      .forEach((inp) => {
        const form = inp.closest("form");
        const formProductId = getFormProductId(form);
        if (!selectorProductId || !formProductId || String(formProductId) !== String(selectorProductId)) {
          return;
        }

        if (shouldUsePlan && this.planId) {
          inp.value = String(this.planId);
          inp.disabled = false;
        } else {
          inp.value = "";
          inp.disabled = true;
        }
        inp.dispatchEvent(new Event("change", { bubbles: true }));
      });
  }

  _money(cents) {
    const moneyFormat =
      window.theme?.moneyFormat ||
      "{{amount}}";
    return Shopify.formatMoney(cents, moneyFormat);
  }

  _getSubPriceForVariant(variantData) {
    // New format: variantData.plans is an object keyed by plan ID
    if (variantData.plans && variantData.plans[String(this.planId)] !== undefined) {
      return Number(variantData.plans[String(this.planId)]);
    }
    // Fallback: legacy format with a single "sub" key
    if (variantData.sub !== undefined) {
      return Number(variantData.sub);
    }
    // Final fallback: one-time price
    return Number(variantData.one_time || 0);
  }

  _updatePricesForCurrentVariant() {
    if (!this.variantPrices?.variants) return;

    const variantId = this._getCurrentVariantId();
    if (!variantId) return;

    const v = this.variantPrices.variants[String(variantId)];
    if (!v) return;

    const oneTime = Number(v.one_time || 0);
    const sub = this._getSubPriceForVariant(v);

    // One-time price
    if (this.priceOneTime) this.priceOneTime.textContent = this._money(oneTime);

    // Subscription price + compare
    if (this.priceSub) this.priceSub.textContent = this._money(sub);

    if (this.priceSubCompare) {
      this.priceSubCompare.textContent = this._money(oneTime);
    }

    // Savings %
    let pct = 0;
    if (oneTime > 0 && sub > 0 && sub < oneTime) {
      pct = Math.round(((oneTime - sub) * 100) / oneTime);
    }

    if (this.savePctEl) {
      if (pct > 0) {
        this.savePctEl.style.display = "";
        this.savePctEl.textContent = `${pct}%`;
      } else {
        this.savePctEl.style.display = "none";
        this.savePctEl.textContent = "";
      }
    }

    // Update savings labels in the plan picker list
    this._updatePlanListSavings(v);

    // Expose the effective price so ProductElement can read it for ATC totals
    const isSubscription = this._isSubscriptionSelected();
    const effectivePrice = isSubscription ? sub : oneTime;
    this.setAttribute("data-effective-price", String(effectivePrice));

    // Update the main PDP title-area price to reflect the active selection
    this._updateMainPdpPrice(effectivePrice, isSubscription ? oneTime : 0);
  }

  /**
   * Sync the PDP title-area price elements so they reflect the currently
   * active price (one-time or subscription).
   *   displayPrice  – the price to show as the main value
   *   comparePrice  – the crossed-out compare-at price (0 = hide)
   */
  _updateMainPdpPrice(displayPrice, comparePrice) {
    const root = this.root; // product-component or document

    // In subscription-only mode, don't show a crossed-out compare price
    // since there's no one-time option to compare against.
    if (this.subscriptionOnly) {
      comparePrice = 0;
    }

    // Main PDP title-area prices
    root.querySelectorAll(".product-info__price--value").forEach((el) => {
      el.setAttribute("data-price", String(displayPrice));
      el.textContent = this._money(displayPrice);
    });

    root.querySelectorAll(".product-info__price--compare").forEach((el) => {
      if (comparePrice && comparePrice > displayPrice) {
        el.style.display = "";
        el.textContent = this._money(comparePrice);
        el.setAttribute("data-price", String(comparePrice));
      } else {
        el.textContent = "";
        el.removeAttribute("data-price");
        el.style.display = "none";
      }
    });

    // Sticky ATC prices
    const stickyRoot = root.querySelector(
      ".product-module__sticky-atc, .pdp-sticky-product-atc"
    );
    if (stickyRoot) {
      stickyRoot.querySelectorAll(".product-module__price--current").forEach(
        (el) => (el.textContent = this._money(displayPrice))
      );
      stickyRoot.querySelectorAll(".product-module__price--compare").forEach((el) => {
        if (comparePrice && comparePrice > displayPrice) {
          el.style.display = "";
          el.textContent = this._money(comparePrice);
        } else {
          el.style.display = "none";
          el.textContent = "";
        }
      });
    }
  }

  _updatePlanListSavings(_variantData) {
    // Plan names already contain savings info — nothing to append.
  }
}

customElements.define("subscription-selector", SubscriptionSelector);


class SwiperInit extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.swiper = null;
    this.initializationMode = this.getInitializationMode();
    this.intersectionObserver = null;
    this.isDynamic = this.element.hasAttribute('data-swiper-dynamic');
    this.isDynamicOnce = this.element.hasAttribute('data-swiper-dynamic-once');
    this.isHorizontalFadeDesktop = this.element.hasAttribute("data-swiper-fade-horizontal-desktop");
    this.isHorizontalFadeMobile = this.element.hasAttribute("data-swiper-fade-horizontal-mobile");
    this.isHorizontalFade = this.element.hasAttribute("data-swiper-fade-horizontal");
    this.hasBeenInitialized = false; // Track if dynamic-once has been initialized

    // Bind methods
    this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);
  }

  getInitializationMode() {
    // Check data attributes to determine mode
    if (this.element.hasAttribute('data-swiper-mobile')) {
      return 'mobile';
    } else if (this.element.hasAttribute('data-swiper-desktop')) {
      return 'desktop';
    } else if (this.element.hasAttribute('data-swiper-tablet')) {
      return 'tablet';
    } else {
      return 'universal';
    }
  }

  connectedCallback() {
    // Listen to responsive system breakpoint changes
    document.addEventListener('breakpoint:changed', this.handleBreakpointChange);

    // Set up intersection observer for dynamic swipers
    if (this.isDynamic || this.isDynamicOnce) {
      this.setupIntersectionObserver();
    } else {
      // Auto-initialize if not dynamic and not disabled
      if (!this.element.hasAttribute('data-swiper-manual')) {
        this.initSwiper();
      }
    }
  }

  disconnectedCallback() {
    document.removeEventListener('breakpoint:changed', this.handleBreakpointChange);
    this.cleanupIntersectionObserver();
    this.destroy();
  }

  setupIntersectionObserver() {
    // Get threshold from attribute or use default
    const threshold = parseFloat(this.element.getAttribute('data-swiper-dynamic-threshold')) || 0.1;

    // Get root margin from attribute or use default
    const rootMargin = this.element.getAttribute('data-swiper-dynamic-margin') || '50px';

    this.intersectionObserver = new IntersectionObserver(this.handleIntersection, {
      threshold: threshold,
      rootMargin: rootMargin
    });

    this.intersectionObserver.observe(this.element);

  }

  cleanupIntersectionObserver() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.target === this.element) {
        if (entry.isIntersecting) {
          // Element is in view - initialize if should be active
          if (this.shouldInitialize() && !this.swiper) {
            this.initSwiper();
          }
        } else {
          // Element is out of view
          if (this.isDynamic && this.swiper) {
            // Dynamic mode: destroy when out of view
            this.destroy();
          }
          // Dynamic-once mode: keep swiper active once initialized
        }
      }
    });
  }

  handleBreakpointChange(event) {
    const { currentBreakpoint } = event.detail;

    // Check if we should be active on this breakpoint
    const shouldBeActive = this.shouldInitialize(currentBreakpoint);
    const currentlyActive = !!this.swiper;

    // For dynamic swipers, only initialize if also in view
    if (this.isDynamic || this.isDynamicOnce) {
      // Let the intersection observer handle initialization
      // Just destroy if shouldn't be active
      if (!shouldBeActive && currentlyActive) {
        this.destroy();
      }
    } else {
      // Normal behavior for non-dynamic swipers
      if (shouldBeActive && !currentlyActive) {
        this.initSwiper();
      } else if (!shouldBeActive && currentlyActive) {
        this.destroy();
      } else if (shouldBeActive && currentlyActive) {
        this.initSwiper();
      }
    }
  }

  initHorizontalFadeOnSwiper() {
    const swiper = this.element.getSwiper();
    const swiperInstance = swiper.swiperElement;
    if (!swiper) return;

    // Add "content-fade" class here
    this.element.classList.add('content-fade');
    const fadeContainer = this.element;

    const update = () => this.updateHorizontalFadeClasses(swiperInstance, fadeContainer);

    // Initial update
    update();

    // Listen to swiper events
    swiperInstance.on('slideChange', update);
    swiperInstance.on('resize', update);
    swiperInstance.on('progress', update);
    swiperInstance.on('touchMove', update);

    responsive.addResizeListener(this, update);
  }

  updateHorizontalFadeClasses(swiperInstance, fadeContainer) {
    const c = fadeContainer.classList;
    c.remove('fade-left', 'fade-right', 'fade-both-horizontal');

    const atStart = swiperInstance.isBeginning;
    const atEnd = swiperInstance.isEnd;

    // Skip left fade when the active slide is aligned to the left edge
    const activeSlide = swiperInstance.slides?.[swiperInstance.activeIndex];
    const leftPos = activeSlide ? activeSlide.offsetLeft + swiperInstance.translate : 0;
    const showLeft = !atStart && Math.abs(leftPos) > 1;

    if (showLeft && !atEnd) {
      c.add('fade-both-horizontal');
    } else if (showLeft) {
      c.add('fade-left');
    } else if (!atEnd) {
      c.add('fade-right');
    }
  }

  shouldInitialize(breakpoint = null) {
    const currentBreakpoint = breakpoint || responsive.getCurrentBreakpoint();

    switch (this.initializationMode) {
      case 'mobile':
        return ['phone', 'pocket'].includes(currentBreakpoint);
      case 'desktop':
        return ['desktop', 'lap_and_up', 'desktop_wide'].includes(currentBreakpoint);
      case 'tablet':
        return ['tablet', 'tablet_and_up'].includes(currentBreakpoint);
      case 'universal':
        return true;
      default:
        return true;
    }
  }

  initSwiper() {
    // Don't initialize if we shouldn't be active
    if (!this.shouldInitialize()) {
      return;
    }

    // Destroy existing swiper
    this.destroy();

    // Defer autoplay: strip autoplay config now, start it after user interaction
    if (this.element.hasAttribute('data-defer-autoplay') && !this._autoplayDeferred) {
      this._autoplayDeferred = true;
      const settings = this.element.getAttribute('data-swiper-settings');
      if (settings) {
        try {
          const parsed = JSON.parse(settings);
          if (parsed.autoplay) {
            this._deferredAutoplayConfig = parsed.autoplay;
            delete parsed.autoplay;
            this.element.setAttribute('data-swiper-settings', JSON.stringify(parsed));
          }
        } catch (e) {}
      }

      // Start autoplay after first user interaction
      if (this._deferredAutoplayConfig) {
        const startAutoplay = () => {
          if (this.swiper && this.swiper.swiperElement && this._deferredAutoplayConfig) {
            this.swiper.swiperElement.params.autoplay = this._deferredAutoplayConfig;
            this.swiper.swiperElement.autoplay.start();
            this._deferredAutoplayConfig = null;
          }
        };
        ['scroll', 'click', 'touchstart', 'keydown'].forEach(evt => {
          window.addEventListener(evt, startAutoplay, { once: true, passive: true });
        });
      }
    }

    try {
      // Get thumb element if specified
      const thumbSelector = this.element.getAttribute('data-swiper-thumb');
      const thumbElement = thumbSelector ? document.querySelector(thumbSelector) : null;

      // Use existing RevolutionSwiper class as-is
      this.swiper = new RevolutionSwiper(this.element, thumbElement);

      // Mark as initialized for dynamic-once mode
      if (this.isDynamicOnce) {
        this.hasBeenInitialized = true;
      }

      if (this.isHorizontalFadeDesktop && responsive.matchesBreakpoint('lap_and_up')) {
        this.initHorizontalFadeOnSwiper(this.element);
      }

      const currentBreakpoint = responsive.getCurrentBreakpoint();
      if (this.isHorizontalFadeMobile && (currentBreakpoint === 'phone' || currentBreakpoint === 'pocket')) {
        this.initHorizontalFadeOnSwiper(this.element);
      }

      if (this.isHorizontalFade) {
        this.initHorizontalFadeOnSwiper(this.element);
      }

      // Dispatch initialization event
      this.element.dispatchEvent(new CustomEvent('swiper:initialized', {
        bubbles: true,
        detail: {
          breakpoint: responsive.getCurrentBreakpoint(),
          mode: this.initializationMode,
          isDynamic: this.isDynamic,
          isDynamicOnce: this.isDynamicOnce,
          swiper: this.swiper
        }
      }));



    } catch (error) {
    }
  }

  destroy() {
    if (this.swiper && this.swiper.swiperElement) {
      this.swiper.swiperElement.destroy(true, true);
      this.swiper = null;

      this.element.dispatchEvent(new CustomEvent('swiper:destroyed', {
        bubbles: true,
        detail: {
          breakpoint: responsive.getCurrentBreakpoint(),
          mode: this.initializationMode,
          isDynamic: this.isDynamic,
          isDynamicOnce: this.isDynamicOnce
        }
      }));
    }
  }

  // Public API methods
  selectSlide(index) {
    if (this.swiper && this.swiper.selectCell) {
      this.swiper.selectCell(index);
    } else {
      // Wait for swiper to initialize, then select
      this.element.addEventListener('swiper:initialized', () => {
        if (this.swiper && this.swiper.selectCell) {
          this.swiper.selectCell(index);
        }
      }, { once: true });
    }
  }

  resize() {
    if (this.swiper) {
      this.swiper.resize();
    }
  }

  getSwiper() {
    return this.swiper;
  }

  getCurrentBreakpoint() {
    return responsive.getCurrentBreakpoint();
  }

  reinitialize() {
    this.initSwiper();
  }

  isDynamicSwiper() {
    return this.isDynamic || this.isDynamicOnce;
  }

  getDynamicMode() {
    if (this.isDynamic) return 'dynamic';
    if (this.isDynamicOnce) return 'dynamic-once';
    return 'static';
  }

  // Static method to initialize all swipers
  static initializeAll() {
    document.querySelectorAll('swiper-init').forEach(element => {
      element.initSwiper();
    });
  }
}
customElements.define("swiper-init", SwiperInit);


class AnimatedAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.blocks = Array.from(
      this.element.querySelectorAll(".announcement-bar__block")
    );
    this.currentBlockIndex = 0;
    this.transitionSpeed =
      parseInt(this.element.getAttribute("data-settings")) * 1000;
    this.announcementBar = document.querySelector(".announcement-bar");
    this.initBlocks();

    requestAnimationFrame(() => {
      document.documentElement.style.setProperty(
        "--announcement-height-fixed",
        this.element.clientHeight + "px"
      );
    });

    if (
      typeof this.transitionSpeed === "number" &&
      !isNaN(this.transitionSpeed)
    ) {
      if (this.blocks.length > 1) {
        this.startAnimating();
      }
    }
    this.updateVisibleHeight();
    this.updateVisibleHeightListener = this.updateVisibleHeight.bind(this);
    scrollListener.addScrollListener(this, this.updateVisibleHeightListener);
  }

  initBlocks() {
    // CSS :first-child already handles initial visibility.
    // Only set inline styles on non-first blocks if they lack them,
    // to avoid redundant style writes that cause CLS.
    this.blocks.forEach((block, index) => {
      if (index > 0 && block.style.display !== "none") {
        block.style.opacity = 0;
        block.style.display = "none";
      }
    });
  }

  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight =
      Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);

    // Update the height of .announcement-bar with the visible height
    document.documentElement.style.setProperty(
      "--announcement-dynamic-height",
      `${visibleHeight}px`
    );
  }

  startAnimating() {
    setInterval(() => {
      this.showNextBlock();
    }, this.transitionSpeed);
  }

  showNextBlock() {
    const currentBlock = this.blocks[this.currentBlockIndex];
    const nextBlockIndex = (this.currentBlockIndex + 1) % this.blocks.length;
    const nextBlock = this.blocks[nextBlockIndex];

    currentBlock.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 500,
      fill: "forwards",
      easing: "ease-out",
    }).onfinish = () => {
      currentBlock.style.display = "none";
      currentBlock.style.position = 'relative';

      nextBlock.style.display = "flex";
      nextBlock.animate(
        [
          { opacity: 0, transform: "translateY(10px)" },
          { opacity: 0.2, transform: "translateY(5px)" },
          { opacity: 1, transform: "translateY(0)" },
        ],
        {
          duration: 500,
          fill: "forwards",
          easing: "ease-in-out",
        }
      );
    };
    this.currentBlockIndex = nextBlockIndex;
  }
}

customElements.define("announcement-bar", AnimatedAnnouncementBar);

class FeaturedCollection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    const cartMode = document.body.dataset.cartMode || 'drawer';
    this.innerBottomContainer = this.element.querySelector(
      '.featured-collection__inner--bottom',
    );
    this.navContainer = this.element.querySelector(
      '.featued-collection__nav-container',
    );

    if (cartMode === 'drawer') {
      new AddToCart(this.element);
    } else {
      this.delegate = new Delegate(this.element);
      this.delegate.on('submit', "form[action*='/cart']", (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    }

    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    this.delegateElement.on('click', '[data-action="toggle-collection"]', (e) =>
      this.handleToggleCollection(e),
    );

    this.initButtonContainer();
    this.moveNavigation();

    this.swiperSlidesWithCheckBound = this.setSwiperContentAlignment.bind(this);

    responsive.addResizeListener(this, this.swiperSlidesWithCheckBound);
    this.setSwiperContentAlignment();
  }

  disconnectedCallback() {
    this.delegateElement?.off?.();
    window.removeEventListener('resize', this.swiperSlidesWithCheckBound);
  }

  initButtonContainer() {
    const container = this.element.querySelector('.pc__button-container');
    if (!container) return;

    const buttons = this.element.querySelectorAll(
      '.featured_collection__toggle-button--wrapper',
    );
    if (!buttons.length) return;

    // Lazy DOM: collection blocks start as <template data-lazy-collection>
    // The first may already be hydrated by an inline script to prevent CLS
    const isLazy = this.element.hasAttribute('data-lazy-collections');
    this._lazyTemplates = new Map();
    const alreadyHydrated = this.element.querySelectorAll('.featured_collection__block').length > 0;
    const templates = this.element.querySelectorAll('template[data-lazy-collection]');
    templates.forEach((template, index) => {
      const blockId = template.getAttribute('data-block-id');
      if (!isLazy || (index === 0 && !alreadyHydrated)) {
        this._hydrateTemplate(template, false);
      } else {
        this._lazyTemplates.set(blockId, template);
      }
    });

    // Hide non-first blocks
    const blocks = this.element.querySelectorAll('.featured_collection__block');
    blocks.forEach((block, index) => {
      if (index !== 0) {
        block.setAttribute('aria-hidden', 'true');
      }
    });

    // Check if inline script already moved buttons (CLS prevention)
    const alreadyMoved = container.querySelectorAll('.featured_collection__toggle-button--wrapper').length > 0;
    if (alreadyMoved) return;

    if (buttons.length <= 1) {
      container.closest('.swiper')?.style.setProperty('display', 'none');
    }

    buttons.forEach((btn, index) => {
      if (btn.parentElement !== container) {
        container.appendChild(btn);
      }
      if (index === 0) {
        btn.querySelector('.Button')?.setAttribute('aria-expanded', 'true');
      }
    });
  }

  _hydrateTemplate(template, moveNav) {
    const block = template.content.firstElementChild;
    // Insert into DOM — connectedCallback on <swiper-init> auto-calls initSwiper()
    template.parentNode.insertBefore(block, template);
    template.remove();

    // Move navigation to nav container (only on tab click, not initial load — moveNavigation handles initial)
    if (moveNav) {
      const nav = block.querySelector('.pc__swiper-navigation');
      if (nav && this.navContainer) {
        nav.parentNode.removeChild(nav);
        this.navContainer.appendChild(nav);
      }
    }

    return block;
  }

  moveNavigation() {
    // Check if inline script already moved first nav (CLS prevention)
    if (this.navContainer && this.navContainer.children.length > 0) return;

    const navs = this.element.querySelectorAll(
      '.featured_collection__block .pc__swiper-navigation',
    );
    navs.forEach((nav) => {
      if (nav.parentNode) nav.parentNode.removeChild(nav);
      this.navContainer.appendChild(nav);
    });

    if (!navs[0]) return;
    navs[0].setAttribute('aria-hidden', 'false');
    navs[0].style.display = '';
  }

  handleToggleCollection(e) {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();

    const trigger =
      e && e.target
        ? e.target.closest('[data-action="toggle-collection"]')
        : null;
    console.log('[FC] trigger:', trigger, 'contains:', trigger ? this.element.contains(trigger) : 'N/A');
    if (!trigger || !this.element.contains(trigger)) return;

    this.scrollToggleIntoView(trigger);

    const targetId = trigger.getAttribute('data-block-id');
    console.log('[FC] targetId:', targetId);
    console.log('[FC] _lazyTemplates:', this._lazyTemplates);
    if (!targetId) return;

    // Hydrate lazy template if this block hasn't been loaded yet
    if (this._lazyTemplates && this._lazyTemplates.has(targetId)) {
      const template = this._lazyTemplates.get(targetId);
      console.log('[FC] hydrating template for', targetId);
      this._hydrateTemplate(template, true);
      this._lazyTemplates.delete(targetId);
    }

    // Toggle blocks
    const blocks = this.element.querySelectorAll('.featured_collection__block');
    console.log('[FC] blocks found:', blocks.length, [...blocks].map(b => b.getAttribute('data-block-id')));
    blocks.forEach((block) => {
      const isMatch = block.getAttribute('data-block-id') === targetId;
      block.setAttribute('aria-hidden', isMatch ? 'false' : 'true');
      console.log('[FC] block', block.getAttribute('data-block-id'), 'aria-hidden:', !isMatch);
    });

    const navigations = this.navContainer.querySelectorAll(
      '.pc__swiper-navigation',
    );

    navigations.forEach((navigation) => {
      const isNavMatch = navigation.getAttribute('data-block-id') === targetId;
      navigation.setAttribute('aria-hidden', isNavMatch ? 'false' : 'true');
      navigation.style.display = isNavMatch ? '' : 'none';
    });

    // Toggle buttons
    const buttons = this.element.querySelectorAll(
      '.featured_collection__toggle-button',
    );
    buttons.forEach((btn) => {
      const isActive = btn.getAttribute('data-block-id') === targetId;
      btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });
  }

  calculateButtonSwiperSlidesWidth() {
    const swiperWrapper =
      this.innerBottomContainer.querySelector('.swiper-wrapper');
    const children = Array.from(swiperWrapper.children);
    const totalChildrenWidth = children.reduce((total, child) => {
      const childWidth = child.offsetWidth || 0;
      return total + childWidth + 24; //24 for 24px gap between swiper slides
    }, 0);

    return totalChildrenWidth;
  }

  setSwiperContentAlignment() {
    if (responsive.currentBreakpoint != 'desktop') return;

    const swiperEl = this.innerBottomContainer.querySelector('.swiper');

    const swiperWrapper = this.innerBottomContainer.querySelector(
      '.pc__button-container',
    );

    if (this.calculateButtonSwiperSlidesWidth() <= swiperEl.offsetWidth) {
      swiperWrapper.classList.add('pc__button-container--end');
    } else {
      swiperWrapper.classList.remove('pc__button-container--end');
    }
  }

  scrollToggleIntoView(trigger) {
    const slide = trigger.closest('.swiper-slide');
    if (!slide) return;

    const swiperEl = slide.closest('.swiper');
    const swiper = swiperEl?.swiper?.swiperElement;
    if (!swiper) return;

    const index = swiper.slides.indexOf(slide);
    if (index < 0) return;

    swiper.update();

    if (swiper.isLocked)
      return; // Prevents repositioning if .swiper-wrapper has less width than .swiper
    else if (this.calculateButtonSwiperSlidesWidth() <= swiperEl.offsetWidth)
      return;

    swiper.slideTo(index, 350);
  }
}

customElements.define("featured-collection", FeaturedCollection);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.intersectionObserver = new IntersectionObserver(
      this.handleIntersection.bind(this),
      { rootMargin: '0px 0px 600px 0px' }
    );
  }

  connectedCallback() {
    this.intersectionObserver.observe(this);

    this.carouselElement = this.element.querySelector(".pc__carousels swiper-init");

    if (this.carouselElement) this.carouselElement.reinitialize();

    new AddToCart(this.element);
  }

  async handleIntersection(entries, observer) {
    const entry = entries?.[0];
    if (!entry?.isIntersecting) return;

    observer.unobserve(this);

    const url = this.dataset?.url;
    if (!url) {
      return;
    }

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch content: ${response.status} ${response.statusText}`);
      }

      const text = await response.text();
      const html = document.createElement('div');
      html.innerHTML = text;

      const recommendations = html.querySelector('.product-recommendation');
      if (!recommendations || !recommendations.innerHTML.trim()) {
        return;
      }

      this.style.opacity = '0';
      this.innerHTML = recommendations.innerHTML;

      const swiperEl = this.querySelector('.swiper');
      if (swiperEl) swiperEl.reinitialize();
      new RevolutionAnimation(this.element);

      this.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease-in-out',
      });

      this.element.dispatchEvent(new CustomEvent('recommendations:loaded', { bubbles: true }));

    } catch (error) {
    }
  }
}

customElements.define("product-recommendations", ProductRecommendations);
class ArticleComments extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.articleWrapper = this.element.querySelector(".article-comments__main-container");
    this.showLessButton = this.element.querySelector(".article-comments__show-less-button");
    this.commentForm = this.element.querySelector("#comment_form");


    if (this.commentForm) {
      this.commentForm.addEventListener("submit", (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        this.customSubmit(event);
        return false;
      }, true); // Use capture phase to ensure we're first
    }

    this.bindEvents();
    this.toggleButton();
    // this.autoHideSuccessMessage();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="load-more"]',
      this.loadMore.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="scroll-to-comment-form"]',
      this.scrollToCommentForm.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="open-comment-form"]',
      this.openCommentForm.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="show-less"]',
      this.showLess.bind(this)
    );

    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  toggleButton() {
    this.buttonState = true;

    var allRequiredFields = this.element.querySelectorAll("[data-state='required']");

    allRequiredFields.forEach((item) => {
      if (item.type === "checkbox" && !item.checked) {
        this.buttonState = false;
      } else if (item.type !== "checkbox" && item.value.trim() === "") {
        this.buttonState = false;
      }
    });

    if (this.buttonState === true) {
      this.element.querySelector(".article-comments__submit-button").removeAttribute("disabled");
    } else {
      this.element.querySelector(".article-comments__submit-button").setAttribute("disabled", true);
    }
  }

  //Escaping first digit for valid querySelector
  escapeSelector(id) {
    // If id starts with a digit, escape it properly
    if (/^\d/.test(id)) {
      return `\\3${id[0]} ${id.slice(1)}`;
    }
    return id.replace(/([!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~])/g, '\\$1');
  }


  async loadMore(event, target) {
    event.preventDefault();
    const dataHref = target.getAttribute("data-next-href");

    if (!dataHref) {
      return;
    }

    const loader = this.element.querySelector(".article-comments__load-more-button .itemLoader");

    try {
      loader?.classList.add("is-visible");

      // Add small artificial delay because Shopify takes time 
      // validating and approving new comments
      await new Promise(resolve => setTimeout(resolve, 500));

      const response = await fetch(`${window.routes.localeRootUrl}${dataHref}`, {
        credentials: "same-origin",
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const htmlData = await response.text();
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(htmlData, "text/html");

      const newComments = htmlDocument.querySelectorAll(".article-comments__comment");
      const commentsContainer = this.element.querySelector(".article-comments__main-container");

      newComments.forEach((comment) => {
        const commentId = comment.getAttribute('id');
        if (!commentId) return;

        const escapedId = this.escapeSelector(commentId);
        if (!commentsContainer.querySelector(`#${escapedId}`)) {
          commentsContainer.appendChild(comment);
        }
      });

      new RevolutionAnimation(this.element);

      const newLoadMoreElement = htmlDocument.querySelector("[data-next-href]");
      const currentLoadMoreElement = this.element.querySelector(".article-comments__load-more-button");

      if (newLoadMoreElement) {
        const newHref = newLoadMoreElement.dataset.nextHref;
        if (currentLoadMoreElement) {
          currentLoadMoreElement.dataset.nextHref = newHref;
          commentsContainer.appendChild(currentLoadMoreElement);
          commentsContainer.appendChild(this.showLessButton);
        }
      } else {
        currentLoadMoreElement?.remove();
        commentsContainer.appendChild(this.showLessButton);
        this.showLessButton.classList.remove('hidden');
      }

    } catch (error) {
    } finally {
      loader?.classList.remove("is-visible");
    }
  }


  scrollToCommentForm(event) {
    event.preventDefault();
    const formRect = this.commentForm.getBoundingClientRect();
    const scrollOffset = 50;

    window.scrollTo({
      top: formRect.top + window.scrollY - scrollOffset,
      behavior: 'smooth'
    });
  }

  openCommentForm(event) {
    event.preventDefault();
    const target = event.target;
    const commentForm = this.element.querySelector(".comment-form-wrapper");

    if (!commentForm) return;

    // Open form and scroll to it.
    target.setAttribute("data-action", "scroll-to-comment-form");
    setTimeout(() => {
      this.scrollToCommentForm(event);
    }, 300);

    commentForm.setAttribute("aria-expanded", true);
    requestAnimationFrame(() => {
      commentForm.setAttribute("aria-visible", true);
    });
  }

  async customSubmit(event) {
    const submitButton = this.commentForm.querySelector('.article-comments__submit-button');
    const loader = submitButton?.querySelector('.itemLoader');
    const messageWrapper = this.element.querySelector('.article-comments__submit-message-wrapper');


    // Show loader and disable button
    if (loader) {
      loader.classList.add('is-visible');
    }
    if (submitButton) {
      submitButton.setAttribute('disabled', 'true');
    }

    // Remove any existing messages
    messageWrapper?.querySelectorAll('#comment_form .AlertSuccess, #comment_form .AlertError').forEach(msg => msg.remove());

    try {
      // Collect form data
      const formData = new FormData(this.commentForm);
      const actionUrl = this.commentForm.action;

      // Execute hCaptcha if available
      if (window.hcaptcha) {
        const captchaToken = await window.hcaptcha.execute(null, { async: true });
        formData.set("h-captcha-response", captchaToken.response);
      }


      // Submit via fetch
      const response = await fetch(actionUrl, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
      });


      if (!response.ok) {
        throw new Error(`Comment submission failed with status ${response.status}`);
      }

      // Get the HTML response
      const htmlData = await response.text();
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(htmlData, 'text/html');

      // Check if comment was successful
      const successMessage = htmlDocument.querySelector('#comment_form .AlertSuccess');
      const errorMessage = htmlDocument.querySelector('#comment_form .AlertError');

      if (successMessage) {
        // Show success message
        messageWrapper?.appendChild(successMessage.cloneNode(true));

        // Reset form
        this.commentForm.reset();

        // Update the comment count in the heading
        const currentHeading = this.element.querySelector('.article-comments__heading h2');
        if (currentHeading) {
          const countMatch = currentHeading.textContent.match(/\((\d+)\)/);
          if (countMatch) {
            const currentCount = parseInt(countMatch[1], 10);
            currentHeading.textContent = currentHeading.textContent.replace(`(${currentCount})`, `(${currentCount + 1})`);
          } else {
            // No count yet, add (1)
            currentHeading.textContent = currentHeading.textContent.trim() + ' (1)';
          }
        }

        // Reload comments to show the new one
        const commentsContainer = this.element.querySelector('.article-comments__main-container');
        const newComment = htmlDocument.querySelector('.article-comments__comment');

        if (newComment && commentsContainer) {
          // Add the new comment at the top
          const firstComment = commentsContainer.querySelector('.article-comments__comment');
          if (firstComment) {
            commentsContainer.insertBefore(newComment, firstComment);
          } else {
            commentsContainer.appendChild(newComment);
          }

          // Trigger animation
          new RevolutionAnimation(this.element);
        }

        // Auto-hide success message after 5 seconds
        setTimeout(() => {
          messageWrapper?.querySelector('.AlertSuccess')?.remove();
        }, 5000);

      } else if (errorMessage) {
        // Show error message
        messageWrapper?.appendChild(errorMessage.cloneNode(true));
      }

    } catch (error) {

      // Show generic error message
      const errorDiv = document.createElement('div');
      errorDiv.className = 'AlertError';
      errorDiv.setAttribute('role', 'alert');
      errorDiv.innerHTML = '<h3 class="AlertError u-p3" tabindex="-1">An error occurred. Please try again.</h3>';
      messageWrapper?.appendChild(errorDiv);

    } finally {
      // Hide loader and re-enable button
      if (loader) {
        loader.classList.remove('is-visible');
      }
      if (submitButton) {
        submitButton.removeAttribute('disabled');
      }
    }
  }

  async showLess(event, target) {
    event.preventDefault();
    const firstPageUrl = target.dataset.firstPageUrl;
    const loader = this.element.querySelector(".article-comments__show-less-button .itemLoader");

    try {
      loader?.classList.add("is-visible");

      const response = await fetch(`${window.routes.localeRootUrl}${firstPageUrl}`, {
        credentials: "same-origin",
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const htmlData = await response.text();
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(htmlData, "text/html");

      const firstPageComments = htmlDocument.querySelectorAll(".article-comments__comment");
      const commentsContainer = this.element.querySelector(".article-comments__main-container");

      commentsContainer.querySelectorAll(".article-comments__comment").forEach(comment => comment.remove());
      commentsContainer.prepend(...firstPageComments);

      new RevolutionAnimation(this.element);

      this.showLessButton.classList.add('hidden');

      const loadMoreButton = htmlDocument.querySelector(".article-comments__load-more-button");
      if (loadMoreButton) {
        commentsContainer.appendChild(loadMoreButton);
      }

      const containerRect = this.element.getBoundingClientRect();
      const scrollOffset = 150;

      window.scrollTo({
        top: containerRect.top + window.scrollY - scrollOffset,
        behavior: 'smooth',
      });
    } catch (error) {
    } finally {
      loader?.classList.remove("is-visible");
    }
  }

  autoHideSuccessMessage() {
    // Check if the URL contains a comment parameter (indicating successful comment submission)
    if (window.location.search.includes('comment=')) {
      const successMessage = this.element.querySelector('.AlertSuccess');

      if (successMessage) {
        // Auto-hide after 5 seconds
        setTimeout(() => {
          successMessage.remove();

          // Clean up URL by removing the comment parameter
          const url = new URL(window.location);
          url.searchParams.delete('comment');
          window.history.replaceState({}, '', url);
        }, 5000);
      }
    }
  }
}

customElements.define("article-comments", ArticleComments);


class UspSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.updateEmptyStates = this.updateEmptyStates.bind(this);
    this.onSectionLoad = this.onSectionLoad.bind(this);
    this.onSwiperInitialized = this.onSwiperInitialized.bind(this);
    this.onSlideChange = this.onSlideChange.bind(this);

    this.onUspClickCapture = this.onUspClickCapture.bind(this);
    this.onUspTouchEndCapture = this.onUspTouchEndCapture.bind(this);

    this.CONTROL_SELECTOR = [
      ".video-js .vjs-control-bar",
      ".video-js .vjs-control-bar *",
      ".video-js .vjs-big-play-button",
      ".video-js .vjs-big-play-button *",
      ".video-js .vjs-slider",
      ".video-js .vjs-slider *",
      ".video-js .vjs-menu",
      ".video-js .vjs-menu *",
    ].join(",");

    this.onMediaVideoEventCapture = this.onMediaVideoEventCapture.bind(this);
    this.refreshControlledVideoFlags = this.refreshControlledVideoFlags.bind(this);

  }

  connectedCallback() {
    this.updateEmptyStates();

    document.addEventListener("shopify:section:load", this.onSectionLoad);

    this.element.addEventListener("click", this.onUspClickCapture, true);
    this.element.addEventListener("touchend", this.onUspTouchEndCapture, { capture: true, passive: false });

    this.swiperEl = this.element.querySelector("swiper-init");
    if (this.swiperEl) {
      this.swiperEl.addEventListener("swiper:initialized", this.onSwiperInitialized);
      this.onSwiperInitialized();
    }

    this.element.addEventListener("play", this.onMediaVideoEventCapture, true);
    this.element.addEventListener("pause", this.onMediaVideoEventCapture, true);
    this.element.addEventListener("ended", this.onMediaVideoEventCapture, true);

    this.refreshControlledVideoFlags();
    requestAnimationFrame(() => this.refreshControlledVideoFlags());
    setTimeout(() => this.refreshControlledVideoFlags(), 250);

  }

  disconnectedCallback() {
    document.removeEventListener("shopify:section:load", this.onSectionLoad);

    this.element.removeEventListener("click", this.onUspClickCapture, true);
    this.element.removeEventListener("touchend", this.onUspTouchEndCapture, true);

    if (this.swiperEl) {
      this.swiperEl.removeEventListener("swiper:initialized", this.onSwiperInitialized);
    }

    if (this.swiper && this.swiper.off) {
      this.swiper.off("slideChange", this.onSlideChange);
    }

    this.swiper = null;
    this.swiperEl = null;

    this.element.removeEventListener("play", this.onMediaVideoEventCapture, true);
    this.element.removeEventListener("pause", this.onMediaVideoEventCapture, true);
    this.element.removeEventListener("ended", this.onMediaVideoEventCapture, true);

  }

  refreshControlledVideoFlags() {
    this.element.querySelectorAll(".usp-section--media").forEach((media) => {
      const vc = media.querySelector("video-component");
      const videoEl = media.querySelector("video");

      // If there's no video at all, reset and exit
      if (!vc || !videoEl) {
        media.classList.remove("has-video", "has-controlled-video", "is-paused");
        return;
      }

      media.classList.add("has-video");

      // Read controls=true from VideoComponent settings (optional, keep if you use it elsewhere)
      let controlsOn = false;
      try {
        const opts = JSON.parse(vc.getAttribute("data-section-settings") || "{}");
        controlsOn = !!opts.controls;
      } catch (e) {
        controlsOn = false;
      }

      media.classList.toggle("has-controlled-video", controlsOn);

      // Core logic: paused/ended => show text
      media.classList.toggle("is-paused", videoEl.paused || videoEl.ended);
    });
  }


  onMediaVideoEventCapture(e) {
    const videoEl = e.target;
    if (!(videoEl instanceof HTMLVideoElement)) return;

    const media = videoEl.closest(".usp-section--media");
    if (!media) return;

    if (e.type === "pause" || e.type === "ended") {
      media.classList.add("is-paused");
    } else if (e.type === "play") {
      media.classList.remove("is-paused");
    }
  }



  onUspClickCapture(e) {
    // Only handle clicks inside usp media in THIS component
    if (!e.target.closest(".usp-section--media")) return;

    // Only when clicking VideoJS controls UI
    if (!e.target.closest(this.CONTROL_SELECTOR)) return;

    // Only if a link would be triggered (wrapper <a> or overlay <a>)
    const inLink = e.target.closest("a[href]");
    const hasOverlay = !!e.target.closest(".usp-section--media")?.querySelector("a[href]");
    if (!inLink && !hasOverlay) return;

    // Stop navigation, but allow VideoJS to receive the click
    e.preventDefault();
  }

  onUspTouchEndCapture(e) {
    if (!e.target.closest(".usp-section--media")) return;
    if (!e.target.closest(this.CONTROL_SELECTOR)) return;
    e.preventDefault();
  }

  onSectionLoad() {
    this.updateEmptyStates();
  }

  onSwiperInitialized() {
    const inst = this.swiperEl?.getSwiper?.();
    const nextSwiper = inst?.swiperElement || inst;

    if (this.swiper && this.swiper.off) {
      this.swiper.off("slideChange", this.onSlideChange);
    }

    this.swiper = nextSwiper;

    if (this.swiper && this.swiper.on) {
      this.swiper.on("slideChange", this.onSlideChange);
    }

    this.updateEmptyStates();
    this.refreshControlledVideoFlags();
  }

  onSlideChange() {
    this.updateEmptyStates();
    this.refreshControlledVideoFlags();
    setTimeout(() => this.refreshControlledVideoFlags(), 150);
  }


  updateEmptyStates() {
    this.element.querySelectorAll(".usp-section--media-text").forEach((parent) => {
      const wrap = parent.querySelector(".group-text-button__block-wrapper");
      if (!wrap) return;
      parent.classList.toggle("is-empty", wrap.children.length === 0);
    });
  }
}

customElements.define("usp-section", UspSection);


class MainSearch extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    const url = new URL(window.location.href);
    if (url.pathname.startsWith('/search') && !url.searchParams.has('type')) {
      url.searchParams.set('type', 'product');
      window.location.replace(url.toString());
    }

    new AddToCart(this.element);
    this.delegateElement = new Delegate(this.element);

    this.filterMobileButton = document.querySelector('.collection__filter-bar-button.not_desktop');
    this.filtersEnabledEl = document.querySelector('.collection__nav-filter-bar');
    this.scrollBound = false;

    if (this.filtersEnabledEl) {
      this.filtersEnabled = this.filtersEnabledEl.getAttribute('data-filter-enabled');
      if (this.filtersEnabled === 'true') this.checkGridHeigth();
      else if (this.filterMobileButton) this.filterMobileButton.style.display = 'none';
    }

    this.toggleProductsBtn = this.element.querySelector('[data-action="toggle-products"]');
    this.toggleArticlesBtn = this.element.querySelector('[data-action="toggle-articles"]');

    this.bindEvents();
    this.prefetchGrids();
    this.setInitialGridVisibility();
    this.updateSearchTotals();
  }

  /** Simplifies building a filtered URL that only includes safe params */
  getFilteredSearchUrl(typeOverride = null) {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const filtered = new URLSearchParams();

    const keep = ['q', 'type', 'sort_by'];
    keep.forEach((key) => {
      if (params.has(key)) filtered.set(key, params.get(key));
    });

    if (typeOverride) filtered.set('type', typeOverride);
    filtered.set('page', '1');

    url.search = filtered.toString();
    return url.toString();
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      const productBtn = e.target.closest('[data-action="toggle-products"]');
      const articleBtn = e.target.closest('[data-action="toggle-articles"]');

      if (productBtn) {
        e.preventDefault();
        this.showProducts(e);
      } else if (articleBtn) {
        e.preventDefault();
        this.showArticles(e);
      }
    });

    this.delegateElement.on('click', '[data-action="toggle-collection"]', this.toggleGrid.bind(this));
    window.addEventListener('popstate', this.toggleGridBasedOnUrl.bind(this));
  }

  async prefetchGrids() {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const currentType = params.get('type') || 'product';
    const currentPage = params.get('page') || 0;

    let productHtml, articleHtml;

    if (currentType === 'product' || (currentPage > 1 && !document.querySelector('.active-filters__item'))) {
      const articleUrl = this.getFilteredSearchUrl('article');
      articleHtml = await fetch(articleUrl).then((res) => res.text());
      productHtml = document.documentElement.innerHTML;
    }

    if (currentType === 'article' || currentPage > 1) {
      const productUrl = this.getFilteredSearchUrl('product');
      productHtml = await fetch(productUrl).then((res) => res.text());
      if (!articleHtml) articleHtml = document.documentElement.innerHTML;
    }

    const productDoc = new DOMParser().parseFromString(productHtml, 'text/html');
    const articleDoc = new DOMParser().parseFromString(articleHtml, 'text/html');

    const productGrid = productDoc.querySelector('#collection__main-grid-products');
    if (productGrid && currentType === 'article') {
      const target = document.querySelector('#collection__main-grid-products');
      if (target) target.innerHTML = productGrid.innerHTML;
    }

    const productFilters = productDoc.querySelector('.block-filters-bar');

    const targetFilters = document.querySelector('.block-filters-bar');


    if (productFilters && targetFilters && currentType === 'article') {
      targetFilters.innerHTML = productFilters.innerHTML;
      const collFilterItemsDesk = document.querySelector('.collection__filter-items--desktop');
      const collFilterBtnMob = document.querySelector('.collection__filter-bar-button');
      if (collFilterItemsDesk) {
        collFilterItemsDesk.style.display = 'none';
        collFilterItemsDesk.setAttribute('aria-hidden', 'true');
      }

      if (collFilterBtnMob) {
        collFilterBtnMob.style.display = 'none';
        collFilterBtnMob.setAttribute('aria-hidden', 'true');
      }
    }

    const articleGrid = articleDoc.querySelector('#collection__main-grid-articles');
    if (articleGrid && currentType === 'product') {
      const target = document.querySelector('#collection__main-grid-articles');
      if (target) target.innerHTML = articleGrid.innerHTML;
    }

    const totalProductsTarget = document.querySelector('.main-search__total-products-num');
    let totalProductsEl;

    if (currentPage > 1 && document.querySelector('.active-filters__item')) {
      const url = new URL(window.location.href);
      const params = url.searchParams;
      params.set('page', '1');
      url.search = params.toString();

      const productUrl = url.toString();
      const productHtmlForTotal = await fetch(productUrl).then((res) => res.text());
      const productHtmlForTotalDoc = new DOMParser().parseFromString(productHtmlForTotal, 'text/html');

      totalProductsEl = productHtmlForTotalDoc.querySelector('.main-search__total-products-num');
      if (totalProductsEl) {
        totalProductsTarget.innerHTML = totalProductsEl.innerHTML;
      }
    } else {

      totalProductsEl = productDoc.querySelector('.main-search__total-products-num');
      if (totalProductsEl) {
        totalProductsTarget.innerHTML = totalProductsEl.innerHTML;
      }
    }

    document.querySelector('.main-search__toggle-button.loading')?.classList.remove('loading');

    const totalArticlesEl = articleDoc.querySelector('.main-search__total-articles-num');

    const totalArticlesTarget = document.querySelector('.main-search__total-articles-num');

    if (totalArticlesEl && totalArticlesTarget) {
      totalArticlesTarget.innerHTML = totalArticlesEl.innerHTML;
    }

    if (totalProductsTarget.textContent == 0)
      document.querySelector('.main-search__product-button').style.display = 'none';
    else if (totalArticlesTarget.textContent == 0)
      document.querySelector('.main-search__article-button').style.display = 'none';

    if (currentType === 'article') this.handleSortForArticles();

    this.cachedTotals = {
      product: totalProductsEl ? totalProductsEl.innerHTML : null,
      article: totalArticlesEl ? totalArticlesEl.innerHTML : null,
    };
  }

  setInitialGridVisibility() {
    const url = new URL(window.location.href);
    const type = url.searchParams.get('type') || 'product';

    const productGrid = this.element.querySelector('#collection__main-grid-products');
    const articleGrid = this.element.querySelector('#collection__main-grid-articles');

    if (type === 'article') {
      if (productGrid) productGrid.setAttribute('aria-hidden', 'true');
      if (articleGrid) articleGrid.setAttribute('aria-hidden', 'false');
    } else {
      if (productGrid) productGrid.setAttribute('aria-hidden', 'false');
      if (articleGrid) articleGrid.setAttribute('aria-hidden', 'true');
    }

    if (this.filterMobileButton) {
      this.filterMobileButton.style.display = type === 'article' ? 'none' : '';
      this.filterMobileButton.setAttribute('aria-hidden', type === 'article');
    }

    const filtersWrapperDesk = this.element.querySelector('.collection__filter-items--desktop');
    const activeFilters = this.element.querySelector('.active-filters');

    if (filtersWrapperDesk) {
      filtersWrapperDesk.style.display = type === 'article' ? 'none' : '';
      filtersWrapperDesk.setAttribute('aria-hidden', type === 'article');
    }

    if (activeFilters) {
      activeFilters.style.display = type === 'article' ? 'none' : '';
      activeFilters.setAttribute('aria-hidden', type === 'article');
    }

  }

  updateSearchTotals() {
    if (!this.cachedTotals) return;
    const { product, article } = this.cachedTotals;

    if (product) {
      const el = document.querySelector('.main-search__total-products-num');
      if (el) el.innerHTML = product;
    }

    if (article) {
      const el = document.querySelector('.main-search__total-articles-num');
      if (el) el.innerHTML = article;
    }
  }

  toggleGridByType(type) {
    const gridsToHide = this.element.querySelectorAll('.collection__grid--inner');
    gridsToHide.forEach((g) => g.setAttribute('aria-hidden', 'true'));

    const gridToShow = this.element.querySelector(
      type === 'product' ? '#collection__main-grid-products' : '#collection__main-grid-articles'
    );
    if (gridToShow) gridToShow.setAttribute('aria-hidden', 'false');

    if (this.filterMobileButton) {
      this.filterMobileButton.style.display = type === 'article' ? 'none' : '';
      this.filterMobileButton.setAttribute('aria-hidden', type === 'article');
    }

    const filtersWrapperDesk = this.element.querySelector('.collection__filter-items--desktop');

    if (filtersWrapperDesk) {
      filtersWrapperDesk.style.display = type === 'article' ? 'none' : '';
      filtersWrapperDesk.setAttribute('aria-hidden', type === 'article');
    }

    const collectionFilterBarButtonMob = this.element.querySelector('.collection__filter-bar-button');

    if (collectionFilterBarButtonMob) {
      collectionFilterBarButtonMob.style.display = type === 'article' ? 'none' : '';
      collectionFilterBarButtonMob.setAttribute('aria-hidden', type === 'article');
    }

    const activeFilters = this.element.querySelector('.block-filters-bar .active-filters');

    if (activeFilters) {
      activeFilters.style.display = type === 'article' ? 'none' : '';
      activeFilters.setAttribute('aria-hidden', type === 'article');
    }


    if (this.toggleProductsBtn && this.toggleArticlesBtn) {
      if (type === 'product') {
        this.toggleProductsBtn.classList.add('active');
        this.toggleArticlesBtn.classList.remove('active');
      } else {
        this.toggleProductsBtn.classList.remove('active');
        this.toggleArticlesBtn.classList.add('active');

        document.querySelector('filters-custom').closeAllDrawers();
      }
    }

    if (type === 'article') this.handleSortForArticles();
  }

  handleSortForArticles() {
    const url = new URL(window.location.href);
    if (url.searchParams.has('sort_by')) {
      url.searchParams.delete('sort_by');
      history.replaceState({}, '', url.toString());
    }

    const checked = document.querySelector('.collection__sort-element--price input[name="sort_by"]:checked');
    if (!checked) return;

    const firstOptionTextEl =
      this.element.querySelector('.collection__sort-text');

    const labelText = firstOptionTextEl.textContent.trim();

    document.querySelectorAll('.collection__filter-current-sort-option').forEach(el => {
      el.textContent = labelText;
    });

    document.querySelector('#collection__sort-drawer--desktop [name=sort_by]').checked = true;
    document.querySelector('.collection__sort-items.Drawer--Content [name=sort_by]').checked = true;
  }

  toggleGrid(e) {
    const target = e.target.closest('[data-action="toggle-collection"]');
    const id = target.getAttribute('aria-controls');
    const gridsToHide = this.element.querySelectorAll('.collection__grid[aria-hidden="false"]');
    const gridToShow = this.element.querySelector(`#${id}`);

    gridsToHide.forEach((grid) => grid.setAttribute('aria-hidden', 'true'));
    if (gridToShow) gridToShow.setAttribute('aria-hidden', 'false');

    if (this.filterMobileButton) {
      this.filterMobileButton.style.display = id === 'collection-article' ? 'none' : '';
    }
  }

  toggleGridBasedOnUrl() {
    const url = new URL(window.location.href);
    const type = url.searchParams.get('type') || 'product';
    this.toggleGridByType(type);
  }

  showArticles(e) {
    e.preventDefault();
    this.toggleGridByType('article');
    const url = this.getFilteredSearchUrl('article');
    history.pushState({}, '', url);
  }

  showProducts(e) {
    e.preventDefault();
    this.toggleGridByType('product');
    const url = this.getFilteredSearchUrl('product');
    history.pushState({}, '', url);
  }
}

customElements.define('search-component', MainSearch);

const lerp = (c, t, f) => c * (1 - f) + t * f;
class AnimatedCartUspsBar extends HTMLElement {
  constructor() {
    super();
    // Default settings and state
    this.speed = 30;       // seconds
    this.fps = 60;
    this.paused = false;
    this.lerp = { current: 0, target: 0 };
    this.factor = 0.1;
    this.pxPerFrame = 0;
    this.gutter = 0;       // in px
    this.animationEnabled = true;

    // Internal flag so we only start animate() once
    this._hasStarted = false;

    // Will be set in connectedCallback()
    this.wrapper = null;
    this.container = null;
    this.resizeObserver = null;
  }

  connectedCallback() {
    this.wrapper = this.querySelector('.cart-drawer__usp-bar--duplicate-wrapper');
    this.container = this.querySelector('.cart-drawer__usp-bar--anim-wrapper');

    // Speed override from data-settings
    const speedAttr = parseFloat(this.getAttribute('data-settings'));
    if (!isNaN(speedAttr)) this.speed = speedAttr;

    // Parse JSON for enableAnimation flag
    const json = this.getAttribute('data-block-settings');
    if (json) {
      try {
        const parsed = JSON.parse(json);
        if (parsed.enableAnimation === false) {
          this.animationEnabled = false;
        }
      } catch (e) {
      }
    }

    if (this.animationEnabled && this.offsetWidth > 0) {
      this.init();
    }
  }

  disconnectedCallback() {
    if (this._rafId) {
      cancelAnimationFrame(this._rafId);
      this._rafId = null;
    }
    this._hasStarted = false;

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }

  init() {
    if (this._initialized) return;
    this.cloneItems();
    this.measure();         // does initial measurement + kicks off animation
    this.observeResize();
    this.bindInteractions();
    this._initialized = true;
  }

  cloneItems() {

    if (this.wrapper.children.length === 1) {
      this.wrapper.style.gap = "25rem"
    }
    // Duplicate each child so we can scroll seamlessly
    Array.from(this.wrapper.children).forEach(child =>
      this.wrapper.appendChild(child.cloneNode(true))
    );
  }

  measure() {
    requestAnimationFrame(() => {
      const contentWidth = this.wrapper.scrollWidth;   // full, double-run width
      const hostRect = this.getBoundingClientRect();
      const parentRect = this.parentElement.getBoundingClientRect();
      this.gutter = (hostRect.width - parentRect.width) / 2;

      // Expand wrapper to cover two runs + gutters
      this.wrapper.style.width = `${contentWidth + this.gutter * 2}px`;
      // Mask width = host width
      if (hostRect.width != 0) this.container.style.width = `${hostRect.width}px`;

      // px moved per frame = oneRunWidth / (seconds * fps)
      const oneRun = contentWidth / 2;
      this.pxPerFrame = oneRun / (this.speed * this.fps);

      // Reset lerp position & initial transform
      this.lerp.current = this.lerp.target = 0;
      this.wrapper.style.transform = `translateX(-${this.gutter}px)`;

      // Start animation loop once
      if (!this._hasStarted) {
        this._hasStarted = true;
        this.animate();
      }
    });
  }

  observeResize() {
    this.resizeObserver = new ResizeObserver(() => this.measure());
    this.resizeObserver.observe(this.wrapper);
  }

  bindInteractions() {
    this.container.addEventListener('mouseenter', () => this.paused = true);
    this.container.addEventListener('mouseleave', () => this.paused = false);
    this.container.addEventListener('click', () => {
      if (!window.matchMedia('(hover: hover)').matches) {
        this.paused = !this.paused;
      }
    });
  }

  animate() {
    const step = () => {
      if (!this.paused) {
        // Only proceed if we have at least one item
        if (this.wrapper && this.wrapper.children.length > 0) {
          const first = this.wrapper.children[0];
          const gap = parseFloat(getComputedStyle(this.wrapper).gap) || 0;
          const fw = first.offsetWidth + gap;

          // Advance our target, then lerp toward it
          this.lerp.target += this.pxPerFrame;
          this.lerp.current = this._lerp(this.lerp.current, this.lerp.target, this.factor);

          // If we've scrolled past one item, cycle it to the end
          if (this.lerp.current >= fw) {
            this.wrapper.appendChild(first);
            this.lerp.current -= fw;
            this.lerp.target -= fw;
          }

          // Always include the gutter offset
          const x = this.lerp.current + this.gutter;
          this.wrapper.style.transform = `translateX(-${x}px)`;
        }
      }
      this._rafId = requestAnimationFrame(step);
    };

    this._rafId = requestAnimationFrame(step);
  }

  _lerp(c, t, f) {
    return c * (1 - f) + t * f;
  }
}

customElements.define('cart-drawer-usp-bar', AnimatedCartUspsBar);

class AnnouncementMarquee extends HTMLElement {
  constructor() {
    super();
    this._ro = null;
    this._onResize = null;
    this._onEnter = null;
    this._onLeave = null;
    this._built = false;
    this._raf = null;
    this._restartRaf = null;
  }

  connectedCallback() {
    if (!this._built) this._buildShell();
    this._applySettings();
    this._scheduleReflow();
    this._observe();
    this._bindHover();
    this._reflowAfterAssets();
  }

  disconnectedCallback() {
    if (this._ro) this._ro.disconnect();
    if (this._onResize) window.removeEventListener("resize", this._onResize);
    if (this._onEnter) this.removeEventListener("mouseenter", this._onEnter);
    if (this._onLeave) this.removeEventListener("mouseleave", this._onLeave);
    if (this._raf) cancelAnimationFrame(this._raf);
    if (this._restartRaf) cancelAnimationFrame(this._restartRaf);
    this._raf = null;
    this._restartRaf = null;
  }

  _buildShell() {
    // If theme already rendered them, reuse
    let viewport = this.querySelector(".ab-group__viewport");
    let track = this.querySelector(".ab-group__track");

    if (!viewport) {
      viewport = document.createElement("div");
      viewport.className = "ab-group__viewport";
      this.appendChild(viewport);
    }

    if (!track) {
      track = document.createElement("div");
      track.className = "ab-group__track";
      viewport.appendChild(track);
    }

    this._built = true;
  }

  _applySettings() {
    const enabled = (this.dataset.enabled ?? "true") === "true";
    const duration = this.dataset.duration || "22s";
    const direction = this.dataset.direction || "rtl"; // rtl or ltr

    this.style.setProperty("--ab-duration", duration);
    this.style.setProperty("--ab-play", "running");
    this.classList.toggle("is-disabled", !enabled);

    const track = this.querySelector(".ab-group__track");
    // When animation plays 'normal', track moves LEFT (negative X), creating right-to-left scroll
    // When animation plays 'reverse', track moves RIGHT (positive X), creating left-to-right scroll
    if (track) track.style.animationDirection = direction === "rtl" ? "normal" : "reverse";
  }

  _scheduleReflow() {
    if (this._raf) cancelAnimationFrame(this._raf);
    this._raf = requestAnimationFrame(() => {
      this._raf = null;
      this._reflow();
    });
  }

  _restartAnimation(track) {
    if (!track) return;

    // Force the CSS animation to restart (reliable across browsers)
    track.style.animationName = "none";
    // force reflow
    void track.offsetHeight;

    // Remove inline override so CSS rule applies again
    this._restartRaf = requestAnimationFrame(() => {
      track.style.animationName = "";
      this._restartRaf = null;
    });
  }

  _reflow() {
    const enabled = (this.dataset.enabled ?? "true") === "true";
    const viewport = this.querySelector(".ab-group__viewport");
    const track = this.querySelector(".ab-group__track");
    const source = this.querySelector(".ab-group__source");

    if (!viewport || !track || !source) return;

    // Disabled: static single cycle
    if (!enabled || this.classList.contains("is-disabled")) {
      track.innerHTML = "";
      const cycle = document.createElement("div");
      cycle.className = "ab-group__cycle";
      cycle.append(...Array.from(source.childNodes).map((n) => n.cloneNode(true)));
      track.appendChild(cycle);

      this.style.setProperty("--ab-shift", "0px");
      this.style.setProperty("--ab-play", "running");
      this._restartAnimation(track);
      return;
    }

    // Build first cycle from source
    const cycle = document.createElement("div");
    cycle.className = "ab-group__cycle";
    cycle.append(...Array.from(source.childNodes).map((n) => n.cloneNode(true)));

    // Mount & measure
    track.innerHTML = "";
    track.appendChild(cycle);

    const viewW = Math.ceil(viewport.getBoundingClientRect().width);
    const cycleW = Math.ceil(cycle.getBoundingClientRect().width);

    if (!cycleW || cycleW < 2 || !viewW) {
      this.style.setProperty("--ab-shift", "0px");
      this.style.setProperty("--ab-play", "running");
      this._restartAnimation(track);
      return;
    }

    // Fill track to avoid gaps
    const minTrackW = (viewW * 2) + cycleW;
    let totalW = cycleW;

    while (totalW < minTrackW) {
      const clone = cycle.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      track.appendChild(clone);
      totalW += cycleW;
    }

    // Compute step including margins/gaps:
    // difference in offsetLeft between cycle 1 and 2.
    const cycles = track.querySelectorAll(".ab-group__cycle");
    let step = cycleW;

    if (cycles.length >= 2) {
      const left0 = cycles[0].offsetLeft;
      const left1 = cycles[1].offsetLeft;
      const measured = left1 - left0;
      if (measured && measured > 0) step = measured;
    }

    this.style.setProperty("--ab-shift", `${step}px`);
    this.style.setProperty("--ab-play", "running");

    // 🔥 important: restart after DOM rebuild so animation actually moves
    this._restartAnimation(track);
  }

  _observe() {
    const viewport = this.querySelector(".ab-group__viewport");
    if (!viewport) return;

    const doReflow = () => this._scheduleReflow();

    if ("ResizeObserver" in window) {
      this._ro = new ResizeObserver(doReflow);
      this._ro.observe(viewport);
      this._ro.observe(this);
    } else {
      this._onResize = debounce(doReflow, 150);
      window.addEventListener("resize", this._onResize);
    }
  }

  _bindHover() {
    const pauseOnHover = (this.dataset.pauseHover ?? "false") === "true";
    if (!pauseOnHover) return;

    this._onEnter = () => {
      if (this.classList.contains("is-disabled")) return;
      this.style.setProperty("--ab-play", "paused");
    };

    this._onLeave = () => {
      if (this.classList.contains("is-disabled")) return;
      this.style.setProperty("--ab-play", "running");
    };

    this.addEventListener("mouseenter", this._onEnter);
    this.addEventListener("mouseleave", this._onLeave);
  }

  _reflowAfterAssets() {
    // Fonts can change widths after first paint
    if (document.fonts?.ready) {
      document.fonts.ready.then(() => this._scheduleReflow());
    }

    // Images in announcement blocks (if any)
    this.querySelectorAll(".ab-group__source img").forEach((img) => {
      if (!img.complete) {
        img.addEventListener("load", () => this._scheduleReflow(), { once: true });
        img.addEventListener("error", () => this._scheduleReflow(), { once: true });
      }
    });
  }
}

if (!customElements.get("announcement-marquee")) {
  customElements.define("announcement-marquee", AnnouncementMarquee);
}

class PDPScrollToTarget {
  constructor() {
    this.handleClick = this.handleClick.bind(this);
    this.bind();
  }

  bind() {
    // Capture phase is critical so theme delegates can't hijack it
    document.addEventListener("click", this.handleClick, true);
  }

  handleClick(e) {
    const link = e.target.closest('a[data-action="scroll-to-product-top"]');
    if (!link) return;

    const href = link.getAttribute("href");
    if (!href || !href.startsWith("#")) return;

    const target = document.querySelector(href);
    if (!target) return;

    // 🔒 Stop everything else (prevents reload / PJAX / fetchAndNavigate)
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation?.();

    this.scrollTo(target);

    // optional: update URL hash without triggering navigation
    try {
      history.replaceState(null, "", href);
    } catch (err) { }
  }

  scrollTo(target) {
    target.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }

  destroy() {
    document.removeEventListener("click", this.handleClick, true);
  }
}

if (document.querySelector('a[data-action="scroll-to-product-top"]')) {
  new PDPScrollToTarget();
}

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-section-settings") || "{}");

    this.hasShopifySuccess =
      window.location.search.includes("customer_posted=true") &&
      (window.location.hash.includes("popupForm") || window.location.hash === "");

    if (this.hasShopifySuccess) {
      this.options.delay = 0;
    }

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
      return;
    }

    this.checkCookiePopupAndStart();
  }

  connectedCallback() {
    this.bindEvents();
    this.initFormValidation();

    if (this.hasShopifySuccess) {
      localStorage.setItem("popup-subscribed", "true");
      localStorage.setItem("popup-seen", "true");

      this.openNewsletter(() => {
        this.showSuccessState();
      });
    }
  }

  bindEvents() {
    this.delegateElement.on("click", '[data-action="close-modal"]', this.closeNewsletter);
  }

  disconnectedCallback() {
    this.delegateElement?.off?.();
  }

  initFormValidation() {
    const form = this.element.querySelector("form");
    if (!form) return;

    this.validator = new FormValidator(form, {
      errorClass: "field--error",
      fieldSelector: ".newsletter__email-input-wrapper",
      buttonSelector: ".newsletter__subscribe-button",
      validateOnBlur: true,
      validateOnInput: true,
      errorOutputSelector: ".newsletter-popup__error-wrapper",
      showErrorsOnSubmitOnly: false,
    });
  }

  checkCookiePopupAndStart() {
    const cookiePopup = document.querySelector("#shopify-pc__banner");
    if (!cookiePopup) {
      this.cookiePopupDismissed = true;
      this.handleOpenOptions();
      return;
    }

    const isVisible =
      cookiePopup.style.display !== "none" &&
      window.getComputedStyle(cookiePopup).display !== "none";

    if (isVisible) {
      this.waitForCookiePopupDismissal();
    } else {
      this.cookiePopupDismissed = true;
      this.handleOpenOptions();
    }
  }

  handleCookieButtonClick = () => {
    setTimeout(() => {
      this.cookiePopupDismissed = true;
      this.handleOpenOptions();
      document.removeEventListener("click", this.handleCookieButtonClick);
    }, 500);
  };

  waitForCookiePopupDismissal() {
    this.delegateBody.on("click", "#shopify-pc__banner__btn-decline", this.handleCookieButtonClick);
    this.delegateBody.on("click", "#shopify-pc__banner__btn-accept", this.handleCookieButtonClick);
  }

  handleOpenOptions() {
    if (!this.cookiePopupDismissed) return;

    // If we just came from a successful post, we already opened in connectedCallback
    if (this.hasShopifySuccess) return;

    const seen = localStorage.getItem("popup-seen") === "true";
    const subscribed = localStorage.getItem("popup-subscribed") === "true";

    if ((this.options.show_only_once && seen) || subscribed) return;

    if (this.options.scroll_amount > 0) {
      this.myScrollListener = scrollListener.addScrollListener(this, this.scrollListener);
    } else {
      this.openNewsletter();
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter(afterOpenCb) {
    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
      this.myScrollListener = null;
    }

    setTimeout(() => {
      // You rely on display:none, so keep this
      this.element.style.display = "block";

      void this.element.offsetHeight;

      requestAnimationFrame(() => {
        this.element.setAttribute("aria-hidden", false);
        this.pageOverlayElement?.classList.add("is-visible");
        bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
        document.body.classList.add("scrollLock");

        this.pageOverlayElement?.addEventListener("click", this.closeNewsletter);

        localStorage.setItem("popup-seen", "true");

        if (typeof afterOpenCb === "function") afterOpenCb();
      });
    }, 1000 * (this.options.delay || 0));
  }

  closeNewsletter = (e) => {
    if (e && typeof e.preventDefault === "function") e.preventDefault();

    this.element.setAttribute("aria-hidden", true);
    this.pageOverlayElement?.classList.remove("is-visible");
    bodyScrollLock.enableBodyScroll(this.element);
    document.body.classList.remove("scrollLock");

    this.pageOverlayElement?.removeEventListener("click", this.closeNewsletter);

    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
      this.myScrollListener = null;
    }

    const onTransitionEnd = (ev) => {
      if (ev.propertyName !== "opacity" && ev.propertyName !== "transform") return;
      this.element.style.display = "none";
      this.element.removeEventListener("transitionend", onTransitionEnd);
    };

    this.element.addEventListener("transitionend", onTransitionEnd);
  };

  showSuccessState() {
    const popup = this.element;
    const form = popup.querySelector(".newsletter__form");
    const success = popup.querySelector(".newsletter__success-wrapper");
    if (!form || !success) return;

    // Flip states (keep your existing structure)
    success.style.display = "";
    success.setAttribute("aria-hidden", "false");

    form.style.display = "none";
    form.setAttribute("aria-hidden", "true");
  }
}

customElements.define("newsletter-popup", NewsletterPopup);